(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * isMobile.js v0.4.1
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /Windows Phone/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group

            'Nexus 7' +     // Nexus 7

            '|' +           // OR

            'BNTV250' +     // B&N Nook Tablet 7 inch

            '|' +           // OR

            'Kindle Fire' + // Kindle Fire

            '|' +           // OR

            'Silk' +        // Kindle Fire, Silk Accelerated

            '|' +           // OR

            'GT-P1000' +    // Galaxy Tab 7 inch

            ')',            // End non-capturing group

            'i');           // Case-insensitive matching

    var match = function(regex, userAgent) {
        return regex.test(userAgent);
    };

    var IsMobileClass = function(userAgent) {
        var ua = userAgent || navigator.userAgent;

        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = ua.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probable happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = ua.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        this.apple = {
            phone:  match(apple_phone, ua),
            ipod:   match(apple_ipod, ua),
            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
        };
        this.amazon = {
            phone:  match(amazon_phone, ua),
            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
        };
        this.android = {
            phone:  match(amazon_phone, ua) || match(android_phone, ua),
            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
        };
        this.windows = {
            phone:  match(windows_phone, ua),
            tablet: match(windows_tablet, ua),
            device: match(windows_phone, ua) || match(windows_tablet, ua)
        };
        this.other = {
            blackberry:   match(other_blackberry, ua),
            blackberry10: match(other_blackberry_10, ua),
            opera:        match(other_opera, ua),
            firefox:      match(other_firefox, ua),
            chrome:       match(other_chrome, ua),
            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
        };
        this.seven_inch = match(seven_inch, ua);
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

        // excludes 'other' devices and ipods, targeting touchscreen phones
        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

        // excludes 7 inch devices, classifying as phone or tablet is left to the user
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

        if (typeof window === 'undefined') {
            return this;
        }
    };

    var instantiate = function() {
        var IM = new IsMobileClass();
        IM.Class = IsMobileClass;
        return IM;
    };

    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
        //node
        module.exports = IsMobileClass;
    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
        //browserify
        module.exports = instantiate();
    } else if (typeof define === 'function' && define.amd) {
        //AMD
        define('isMobile', [], global.isMobile = instantiate());
    } else {
        global.isMobile = instantiate();
    }

})(this);

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceCar2 = require("./race/RaceCar");

var _RaceCar3 = _interopRequireDefault(_RaceCar2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  AI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 10/04/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceCar
 */
var AI = function (_RaceCar) {
    _inherits(AI, _RaceCar);

    /**
     * @param {number} id
     * @param {RaceCarView} view
     */
    function AI(id, view) {
        _classCallCheck(this, AI);

        var _this = _possibleConstructorReturn(this, (AI.__proto__ || Object.getPrototypeOf(AI)).call(this, id, view));

        _this.acceleration = 3.32;

        /**
         * @type {number}
         * @private
         */
        _this._targetX = 0;

        /**
         * @type {number}
         * @private
         */
        _this._powerupDesire = 0;

        /**
         * @type {number}
         * @private
         */
        _this._baseAccel = 0;
        return _this;
    }

    _createClass(AI, [{
        key: "init",
        value: function init() {
            _get(AI.prototype.__proto__ || Object.getPrototypeOf(AI.prototype), "init", this).call(this);

            this._targetX = this.offset.x;
            this._powerupDesire = Math.random() * 600;
            this._baseAccel = this.acceleration;

            delay(function () {
                this.applyTargetNoise();
            }, 2 + Math.random() * 4, this);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            var pos = _Common2.default.game.getRacePos(this);
            var cars = _Common2.default.game.getCars();
            this.acceleration = this._baseAccel + Math.pow(pos / cars.length * 0.2, 2);

            var powerup = this.isSeekingPowerup ? this.seekPowerup() : null;

            var target = void 0;
            if (powerup) {
                target = powerup.offset.x;
            } else {
                target = this._targetX + this.engine.getAverageTrackCurvature(this.distance) * 8400;
            }

            var width = 640;
            if (Math.abs(target) > width) {
                target = target / Math.abs(target) * width;
            }

            var distance = target - this.offset.x;
            var direction = distance / Math.abs(distance);
            var time = 1.6;

            var radius = 280;
            if (distance > radius) {
                this.turnSpeed = direction * this.turnAccel;
            } else {
                this.turnSpeed = direction * (this.turnAccel * Math.min(1, Math.abs(distance / radius)));
            }
            this.turnSpeed /= time;

            this._powerupDesire += this.getPowerupDesireModifier();

            _get(AI.prototype.__proto__ || Object.getPrototypeOf(AI.prototype), "update", this).call(this, dt);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "updateView",
        value: function updateView(dt) {
            _get(AI.prototype.__proto__ || Object.getPrototypeOf(AI.prototype), "updateView", this).call(this, dt);

            var curvature = 4 * this.engine.getAverageTrackCurvature(this.distance, 2);
            curvature = curvature + this.getPerpTo(this.engine.camera.target) * 1.4;
            curvature = curvature + -this.screenPosition.x * 0.0014;
            var gradient = this.engine.getTrackGradient(this.distance) - this.engine.getTrackGradient(this.engine.camera.target.distance);
            this._view.update(dt, this.distance, curvature * 160, gradient * 0.6, this.velocity, this.turnVelocity * 0.08, this._jumpOffset);
        }

        /**
         * @param powerup
         */

    }, {
        key: "usePowerup",
        value: function usePowerup(powerup) {
            _get(AI.prototype.__proto__ || Object.getPrototypeOf(AI.prototype), "usePowerup", this).call(this, powerup);

            this._powerupDesire = 0;
        }

        /**
         * @returns {RaceEntity}
         */

    }, {
        key: "seekPowerup",
        value: function seekPowerup() {
            var minDistance = Number.MAX_SAFE_INTEGER;
            var result = null;
            var powerups = _Common2.default.game.getPickups();

            for (var i = 0; i < powerups.length; ++i) {
                var powerup = powerups[i];
                if (!powerup.collected) {
                    var dx = Math.abs(powerup.offset.x - this.offset.x);
                    var dy = powerup.distance - this.distance;
                    if (dy > 0 && dy < 16) {
                        if (dx < minDistance) {
                            result = powerup;
                            minDistance = dx;
                        }
                    }
                }
            }
            return result;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "getOvertakeDesireModifier",
        value: function getOvertakeDesireModifier() {}

        /**
         * @returns {number}
         */

    }, {
        key: "getPowerupDesireModifier",
        value: function getPowerupDesireModifier() {
            var cars = _Common2.default.game.getCars();
            return (cars.indexOf(this) + 1) / cars.length * 0.6;
        }

        /**
         */

    }, {
        key: "applyTargetNoise",
        value: function applyTargetNoise() {
            this._targetX = p3.Utils.randomInt(1140, -1140);

            delay(function () {
                this.applyTargetNoise();
            }, 4 + Math.random() * 6, this);
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "isSeekingPowerup",
        get: function get() {
            return this._powerupDesire > 600;
        }
    }]);

    return AI;
}(_RaceCar3.default);

exports.default = AI;

},{"./Common":7,"./race/RaceCar":53}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Application
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 04/09/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _CharacterScene = require("./scenes/CharacterScene");

var _CharacterScene2 = _interopRequireDefault(_CharacterScene);

var _ConfirmQuitScene = require("./scenes/ConfirmQuitScene");

var _ConfirmQuitScene2 = _interopRequireDefault(_ConfirmQuitScene);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _GameScene = require("./scenes/GameScene");

var _GameScene2 = _interopRequireDefault(_GameScene);

var _PauseScene = require("./scenes/PauseScene");

var _PauseScene2 = _interopRequireDefault(_PauseScene);

var _ResultsScene = require("./scenes/ResultsScene");

var _ResultsScene2 = _interopRequireDefault(_ResultsScene);

var _SplashScene = require("./scenes/SplashScene");

var _SplashScene2 = _interopRequireDefault(_SplashScene);

var _ThemeLoaderScene = require("./scenes/ThemeLoaderScene");

var _ThemeLoaderScene2 = _interopRequireDefault(_ThemeLoaderScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Application = function () {
    function Application() {
        _classCallCheck(this, Application);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._overlay = null;
    }

    /**
     */


    _createClass(Application, [{
        key: "init",
        value: function init() {
            this.showSplashScene();
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showSplashScene",
        value: function showSplashScene(transition) {
            _Common2.default.paused = false;

            var scene = new _SplashScene2.default();
            scene.signals.next.add(function () {
                this.showCharacterScene();
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showCharacterScene",
        value: function showCharacterScene(transition) {
            var scene = new _CharacterScene2.default();
            scene.signals.next.add(function (scene, id) {
                _Common2.default.playerDriverId = id;

                this.showThemeLoaderScene();
            }, this);
            scene.signals.home.add(function () {
                this.showSplashScene();
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {ThemeLoaderScene}
         */

    }, {
        key: "showThemeLoaderScene",
        value: function showThemeLoaderScene(transition) {
            var scene = new _ThemeLoaderScene2.default();
            scene.signals.next.add(function (scene) {
                this.showGameScene(_Common2.default.isFirstTime);
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @param {boolean} [tutorial]
         * @param {boolean} [replay]
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showGameScene",
        value: function showGameScene(tutorial, replay, transition) {
            _Common2.default.paused = false;

            var scene = new _GameScene2.default(tutorial, replay);
            scene.signals.next.add(function (scene, place) {
                this.showResultsScene(_Common2.default.playerDriverId, place);
            }, this);
            scene.signals.pause.add(function () {
                scene.pauseGame();
                this.showOverlay(true);

                this.showPauseScene();
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showPauseScene",
        value: function showPauseScene(transition) {
            _Common2.default.paused = true;

            var scene = new _PauseScene2.default();
            scene.signals.home.add(function () {
                this.showConfirmQuitScene();
            }, this);
            scene.signals.next.add(function () {
                _Common2.default.paused = false;
                this.hideOverlay(true);

                _Common2.default.scene.remove();
            }, this);
            scene.signals.previous.add(function (scene) {
                this.showGameScene();
            }, this);

            if (!transition) {
                transition = new p3.Transition();
                transition.push = true;
                transition.replace = false;
            }
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @param {p3.Transition} [transition]
         * @returns {p3.Scene}
         */

    }, {
        key: "showConfirmQuitScene",
        value: function showConfirmQuitScene(transition) {
            var scene = new _ConfirmQuitScene2.default();
            scene.signals.next.add(function () {
                this.showSplashScene();
            }, this);
            scene.signals.previous.add(function () {
                _Common2.default.scene.remove();
            }, this);

            if (!transition) {
                transition = new p3.Transition();
                transition.push = true;
                transition.replace = true;
            }
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @param {number} [id]
         * @param {number} [place]
         * @param {p3.Transition} [transition]
         * @returns {ResultsScene}
         */

    }, {
        key: "showResultsScene",
        value: function showResultsScene(id, place, transition) {
            var scene = new _ResultsScene2.default(id, place);
            scene.signals.home.add(function () {
                this.showSplashScene();
            }, this);
            scene.signals.next.add(function () {
                this.showCharacterScene();
            }, this);
            scene.signals.previous.add(function () {
                this.showGameScene(false, true);
            }, this);

            transition = transition || new p3.FadeTransition();
            _Common2.default.scene.add(scene, transition);
            return scene;
        }

        /**
         * @param {boolean} [animate]
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "showOverlay",
        value: function showOverlay(animate, callback, scope) {
            this.hideOverlay();

            this._overlay = new PIXI.Sprite(_Common2.default.blankTexture);
            this._overlay.width = p3.View.width;
            this._overlay.height = p3.View.height;
            this._overlay.tint = 0x281186;
            _Common2.default.scene.view.addChild(this._overlay);

            if (animate) {
                this._overlay.alpha = 0;
                TweenMax.to(this._overlay, 0.2, {
                    alpha: 0.6,
                    ease: Power1.easeInOut,
                    onComplete: callback,
                    onCompleteScope: scope
                });
            } else {
                this._overlay.alpha = 0.6;
            }
        }

        /**
         * @param {boolean} [animate]
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "hideOverlay",
        value: function hideOverlay(animate, callback, scope) {
            if (!this._overlay) return;

            if (animate) {
                TweenMax.to(this._overlay, 0.2, {
                    alpha: 0,
                    ease: Power1.easeInOut,
                    onComplete: function onComplete() {
                        this._overlay.parent.removeChild(this._overlay);
                        this._overlay.destroy();
                        this._overlay = null;

                        callback && callback.call(scope);
                    },
                    onCompleteScope: this
                });
            } else {
                this._overlay.parent.removeChild(this._overlay);
                this._overlay.destroy();
                this._overlay = null;
            }
        }
    }]);

    return Application;
}();

exports.default = Application;

},{"./Common":7,"./scenes/CharacterScene":64,"./scenes/ConfirmQuitScene":65,"./scenes/GameScene":66,"./scenes/PauseScene":67,"./scenes/ResultsScene":68,"./scenes/SplashScene":69,"./scenes/ThemeLoaderScene":70}],4:[function(require,module,exports){
"use strict";

/**
 *  Audio
 *
 *  Created by Legman on 12/09/2016.
 *
 */

/**
 * @constructor
 */
function Audio() {
    /**
     * @type {number}
     */
    this.id = -1;

    /**
     * @type {Howl}
     */
    this.howl = null;
}
module.exports = Audio;

Audio.prototype.destroy = function () {
    this._onend && this.howl.off("end", this._onend);
    this.stop();
};

Audio.prototype.play = function () {
    this.howl.play(this.id);
};

Audio.prototype.stop = function () {
    this.howl.stop(this.id);
};

Audio.prototype.pause = function () {
    this.howl.pause(this.id);
};

},{}],5:[function(require,module,exports){
"use strict";

/**
 *  AudioManager
 *
 *  Created by Legman on 25/02/2016.
 *
 */

var Audio = require("./Audio");
var AudioParams = require("./AudioParams");

function AudioManager() {
    /**
     * @type {object}
     * @private
     */
    this._cache = {};

    /**
     * @type {Howl}
     * @private
     */
    this._music = null;

    /**
     * @type {boolean}
     * @private
     */
    this._isMuted = false;

    var hidden;
    "undefined" != typeof document.hidden ? (hidden = "hidden", this.visibilityChange = "visibilitychange") : "undefined" != typeof document.mozHidden ? (hidden = "mozHidden", this.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.msHidden ? (hidden = "msHidden", this.visibilityChange = "msvisibilitychange") : "undefined" != typeof document.webkitHidden && (hidden = "webkitHidden", this.visibilityChange = "webkitvisibilitychange");

    document.addEventListener(this.visibilityChange, function () {
        document[hidden] ? Howler.volume(0) : Howler.volume(1);
    }, false);
}
module.exports = AudioManager;

/**
 * @param {!Array.<string>} sounds
 * @param {!Array.<string>} extensions
 * @param {string=} basePath
 */
AudioManager.prototype.addSounds = function (sounds, extensions, basePath) {
    basePath = basePath || "";

    var howl, name, url, urls, extension, i, j;
    for (i = 0; i < sounds.length; ++i) {
        url = basePath + sounds[i];
        url = url.split("/");
        name = url[url.length - 1];

        urls = [];
        for (j = 0; j < extensions.length; ++j) {
            extension = extensions[j];
            urls.push(url.join("/") + extension);
        }
        howl = new Howl({
            src: urls,
            volume: 1.0,
            loop: false,
            autoplay: false
        });
        howl.name = name;
        this._cache[name] = howl;
    }
};

/**
 * @param {!Array.<string>} name
 * @param {!Array.<string>} sprite
 * @param {!Array.<string>} extensions
 * @param {string=} basePath
 */
AudioManager.prototype.addSoundSprite = function (name, sprite, extensions, basePath) {
    basePath = basePath || "";

    var extension;

    var url = basePath + name;
    url = url.split("/");

    var urls = [];
    for (var i = 0; i < extensions.length; ++i) {
        extension = extensions[i];
        urls.push(url.join("/") + extension);
    }

    var howl = new Howl({
        src: urls,
        sprite: sprite,
        volume: 1,
        loop: false,
        autoplay: false
    });
    howl.isSoundSprite = true;
    for (var key in sprite) {
        if (sprite.hasOwnProperty(key)) {
            this._cache[key] = howl;
        }
    }
};

/**
 * @param {!Array.<string>} sounds
 */
AudioManager.prototype.removeSounds = function (sounds) {
    var name, n, howl;
    for (var i = 0; i < sounds.length; ++i) {
        name = sounds[i];
        for (n in this._cache) {
            if (this._cache.hasOwnProperty(key)) {
                howl = this._cache[key];
                if (howl.name === n) {
                    howl.unload();
                    delete this._cache[name];
                    break;
                }
            }
        }
    }
};

/**
 * @param {!string | Array.<string>} name
 * @param {AudioParams=} params
 * @returns {Audio}
 */
AudioManager.prototype.playSound = function (name, params) {
    params = params || new AudioParams();

    var id = -1;

    if (typeof name !== "string") {
        name = name[Math.floor(Math.random() * name.length)];
    }

    var howl = this._cache[name];
    if (!howl) {
        console.warn("Could not find sound - " + name);
        return id;
    }

    id = howl.isSoundSprite ? howl.play(name) : howl.play();
    howl.volume(params.volume, id);
    howl.loop(params.loop, id);

    var audio = new Audio();
    audio.id = id;
    audio.howl = howl;

    if (params.callback) {
        audio._onend = function () {
            params.callback.call(params.scope);
        };
        howl.on("end", audio._onend);
    }

    return audio;
};

/**
 * @param {!string | Array.<string>} name
 * @param {AudioParams=} params
 * @returns {Audio}
 */
AudioManager.prototype.playMusic = function (name, params) {
    params = params || new AudioParams();

    var id = -1;

    if (typeof name !== "string") {
        name = name[Math.floor(Math.random() * name.length)];
    }

    // skip if no change
    if (this._music && this._music.howl.name === name) {
        return this._music;
    }

    var howl = this._cache[name];
    if (!howl) {
        console.warn("Could not find music - " + name);
        return null;
    }

    if (p3.Device && p3.Device.isAndroidStockBrowser) {
        howl.buffer = true;
    }

    id = howl.play();
    howl.volume(params.volume, id);
    howl.loop(true, id);

    var audio = new Audio();
    audio.id = id;
    audio.howl = howl;

    if (params.callback) {
        audio._onend = function () {
            params.callback.call(params.scope);
        };
        howl.on("end", audio._onend);
    }

    if (params.fadeIn > 0.0) {
        if (this._music) {
            this.fadeOut(this._music, params.fadeIn, function (audio) {
                audio.destroy();
            }, this);
        }
        this.fadeIn(audio, params.fadeIn);
    } else {
        this.stopMusic();
    }

    this._music = audio;
    return audio;
};

/**
 * @param {!string} name
 * @param {number=} id
 * @deprecated
 */
AudioManager.prototype.stopSound = function (name, id) {
    var howl = this._cache[name];
    !howl && console.warn("Could not find sound - " + name);
    howl.stop(id);

    console.warn("'AudioManager.stopSound()' is deprecated. Use 'Audio.stop()' instead.");
};

AudioManager.prototype.stopMusic = function () {
    if (!this._music) return;

    this._music.destroy();
    this._music = null;
};

/**
 * @param {!boolean} value
 */
AudioManager.prototype.mute = function (value) {
    this._isMuted = value;
    if (this._isMuted) {
        Howler.mute(true);
    } else {
        Howler.mute(false);
    }
};

/**
 * @param {!Audio} audio
 * @param {number=} duration
 * @param {function=} callback
 * @param {*=} scope
 */
AudioManager.prototype.fadeIn = function (audio, duration, callback, scope) {
    duration = duration || 1.0;

    var volume = audio.howl.volume(audio.id);
    audio.howl.volume(0.0, audio.id);
    audio.__volume = 0.0;

    TweenMax.killTweensOf(audio);
    TweenMax.to(audio, duration, {
        __volume: volume,
        ease: Power1.easeInOut,
        onUpdate: function onUpdate() {
            audio.howl.volume(audio.__volume, audio.id);
        },
        onUpdateScope: this,
        onComplete: callback,
        onCompleteParams: [audio],
        onCompleteScope: scope
    });
};

/**
 * @param {!Audio} audio
 * @param {number=} duration
 * @param {function=} callback
 * @param {*=} scope
 */
AudioManager.prototype.fadeOut = function (audio, duration, callback, scope) {
    duration = duration || 1.0;

    audio.__volume = audio.howl.volume(audio.id);

    TweenMax.killTweensOf(audio);
    TweenMax.to(audio, duration, {
        __volume: 0.0,
        ease: Power1.easeInOut,
        onUpdate: function onUpdate() {
            audio.howl.volume(audio.__volume, audio.id);
        },
        onUpdateScope: this,
        onComplete: callback,
        onCompleteParams: [audio],
        onCompleteScope: scope
    });
};

/**
 * @param {!Audio} audio
 * @param {!*} object
 * @param {!Camera} camera
 * @param {number=} min
 * @param {number=} max
 */
AudioManager.prototype.setAudioPos3D = function (audio, object, camera, min, max) {
    if (p3.Device.isMobile || !p3.Device.bowser["chrome"]) return;

    min = min || 0.0;
    max = max || 320.0;

    var layer = camera.findLayerForObject(object);
    var x = object.x * (1.0 / layer.parallax.x);
    var sign = x - camera.position.x;
    sign = sign / Math.abs(sign);

    if (sign == -1) x = Math.min(0.0, (x + min - camera.position.x) / (max - min));else if (sign == 1) x = Math.max(0.0, (x - min - camera.position.x) / (max - min));

    audio.howl.pos(x, 0.0, 0.0, audio.id);
};

/**
 * @param {Audio} audio
 * @param {*} object
 * @param {Camera} camera
 * @param {!number} [min]
 * @param {!number} [max]
 * @param {!number} [offset]
 * @param {boolean} [fallback]
 */
AudioManager.prototype.setAudioPosStereo = function (audio, object, camera, min, max, offset, fallback) {
    if (p3.Device.isMobile || !p3.Device.bowser["chrome"]) {
        fallback = true;
    }

    min = min || 0.0;
    max = max || 320.0;
    offset = offset || 0;

    var layer = camera.findLayerForObject(object);
    var x = (object.x + offset) * (1.0 / layer.parallax.x);
    var sign = x - camera.position.x;
    sign = sign / Math.abs(sign);

    x = Math.max(0.0, Math.abs(x - min - camera.position.x) / max);
    x = Math.max(0.0, Math.min(1.0, 1.0 + (1.0 - x)));

    audio.howl.volume(x, audio.id);

    if (fallback) return;

    x = (object.x + offset) * (1.0 / layer.parallax.x);

    if (sign == -1) x = Math.min(0.0, (x + min - camera.position.x) / (max - min));else if (sign == 1) x = Math.max(0.0, (x - min - camera.position.x) / (max - min));

    x = Math.max(-1.0, Math.min(1.0, x));
    audio.howl.stereo(x, audio.id);
};

Object.defineProperty(AudioManager.prototype, "isMute", {
    /**
     * @returns {!boolean}
     */
    get: function get() {
        return this._isMuted;
    }
});

},{"./Audio":4,"./AudioParams":6}],6:[function(require,module,exports){
"use strict";

/**
 *  AudioParams
 *
 *  Created by Legman on 25/02/2016.
 *
 */

/**
 * @constructor
 */
function AudioParams() {
  /**
   * @type {number}
   */
  this.volume = 1.0;

  /**
   * @type {boolean}
   */
  this.loop = false;

  /**
   * @type {number}
   */
  this.delay = 0.0;

  /**
   * @type {number}
   */
  this.fadeIn = 0.0;

  /**
   * @type {number}
   */
  this.priority = 0;

  /**
   * @type {function}
   */
  this.callback = null;

  /**
   * @type {*}
   */
  this.scope = window;
}
module.exports = AudioParams;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  Common
 *
 *  Created by Legman on 4/09/2015.
 *
 */

var Common = function () {
  function Common() {
    _classCallCheck(this, Common);
  }

  _createClass(Common, null, [{
    key: "getHighscore",

    /**
     * @returns {number}
     */
    value: function getHighscore() {
      var score = window.localStorage["cn_wackyraces"];
      return score || 0;
    }

    /**
     * @param {!number} score
     */

  }, {
    key: "saveHighscore",
    value: function saveHighscore(score) {
      if (score > Common.getHighscore()) {
        window.localStorage["cn_wackyraces"] = score;
      }
    }
  }]);

  return Common;
}();

/**
 * @static
 * @type {number}
 * @const
 */


exports.default = Common;
Common.STAGE_WIDTH = 1900;

/**
 * @static
 * @type {number}
 * @const
 */
Common.STAGE_HEIGHT = 768;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @static
 * @type {number}
 * @const
 */
Common.RACE_ENTITY_SCALE = 764;
//Common.RACE_ENTITY_SCALE = 900;

/**
 * @static
 * @type {PIXI.Container}
 */
Common.stage = null;

/**
 * @static
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 */
Common.renderer = null;

/**
 * @static
 * @type {p3.Timestep}
 */
Common.timestep = null;

/**
 * @static
 * @type {p3.Tracking}
 */
Common.tracking = null;

/**
 * @static
 * @type {AudioManager}
 */
Common.audio = null;

/**
 * @static
 * @type {p3.Camera}
 */
Common.camera = null;

/**
 * @static
 * @type {object}
 */
Common.copy = null;

/**
 * @static
 * @type {object}
 */
Common.config = null;

/**
 * @static
 * @type {string}
 */
Common.language = "en";

/**
 * @static
 * @type {PIXI.Point}
 */
Common.touch = new PIXI.Point(0, 0);

/**
 * @static
 * @type {boolean}
 */
Common.touching = false;

/**
 * @static
 * @type {boolean}
 */
Common.paused = false;

/**
 * @static
 * @type {boolean}
 */
Common.isWebGL = false;

/**
 * @static
 * @type {boolean}
 */
Common.isFirstTime = true;

/**
 * @static
 * @type {PIXI.Texture}
 */
Common.blankTexture = PIXI.Texture.EMPTY;

/**
 * @static
 * @type {number}
 */
Common.playerDriverId = 0;

/**
 * @static
 * @type {string}
 */
Common.previousTrackName = null;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceLadder = require("./RaceLadder");

var _RaceLadder2 = _interopRequireDefault(_RaceLadder);

var _StartingLights = require("./StartingLights");

var _StartingLights2 = _interopRequireDefault(_StartingLights);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Hud
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 29/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends PIXI.Container
 */
var Hud = function (_PIXI$Container) {
    _inherits(Hud, _PIXI$Container);

    function Hud() {
        _classCallCheck(this, Hud);

        /**
         * @member {p3.Button}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (Hud.__proto__ || Object.getPrototypeOf(Hud)).call(this));

        _this._pauseButton = null;

        /**
         * @member {RaceLadder}
         * @private
         */
        _this._ladder = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._laps = null;

        /**
         * @type {PIXI.BitmapText}
         * @private
         */
        _this._lapsLabel = null;

        /**
         * @type {StartingLights}
         * @private
         */
        _this._lights = null;

        _this.on("added", _this.init, _this);
        return _this;
    }

    /**
     */


    _createClass(Hud, [{
        key: "init",
        value: function init() {
            this.off("added", this.init);

            var assets = _Common2.default.assets;
            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_out");
            states.over = assets.getTexture("ui_btn_over");
            states.down = assets.getTexture("ui_btn_down");
            states.icon = assets.getTexture("ui_icon_pause");

            this._pauseButton = new p3.Button(states);
            this._pauseButton.overSoundName = "sfx_btn_rollover_00";
            this._pauseButton.clickSoundName = "sfx_btn_press_00";
            this.addChild(this._pauseButton);

            this._ladder = new _RaceLadder2.default();
            this.addChild(this._ladder);

            this._laps = new PIXI.Sprite(assets.getTexture("ui_icon_laps"));
            this._laps.x = _Common2.default.STAGE_WIDTH * 0.5 - 28;
            this._laps.y = 80;
            this._laps.anchor = new PIXI.Point(0.5, 0.5);
            this._laps.visible = false;
            this.addChild(this._laps);

            this._laps.label = new PIXI.BitmapText("99/99", font(42, "center"));
            this._laps.label.x = 28;
            this._laps.label.y = 2;
            this._laps.label.pivot.x = this._laps.label.textWidth * 0.5;
            this._laps.label.pivot.y = this._laps.label.textHeight * 0.5;
            this._laps.addChild(this._laps.label);
        }

        /**
         */

    }, {
        key: "resize",
        value: function resize() {
            this._pauseButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
            this._pauseButton.y = 100;

            this._ladder.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 120;
            this._ladder.y = 60;
        }

        /**
         */

    }, {
        key: "update",
        value: function update() {
            this._ladder.update();
        }

        /**
         * @param {number} [delay]
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "runCountdown",
        value: function runCountdown(delay, callback, scope) {
            this._lights = new _StartingLights2.default();
            this._lights.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._lights.y = _Common2.default.STAGE_HEIGHT * 0.5 - 280;
            this.addChild(this._lights);

            this._lights.animateIn(function () {
                this._lights.start(delay, function () {
                    callback && callback.call(scope);
                    this._lights.animateOut(function () {
                        this._lights.destroy();

                        this._laps.alpha = 0;
                        TweenMax.to(this._laps, 0.4, {
                            alpha: 1,
                            ease: Power1.easeInOut,
                            onStart: function onStart() {
                                this._laps.visible = true;
                            },
                            onStartScope: this
                        });
                    }, this);
                }, this);
            }, this);
        }

        /**
         * @param lap
         * @param total
         */

    }, {
        key: "setLaps",
        value: function setLaps(lap, total) {
            this._laps.label.text = lap + "/" + total;
            this._laps.label.pivot.x = this._laps.label.textWidth * 0.5;
        }

        /**
         * @returns {p3.Button}
         */

    }, {
        key: "pauseButton",
        get: function get() {
            return this._pauseButton;
        }

        /**
         * @returns {RaceLadder}
         */

    }, {
        key: "ladder",
        get: function get() {
            return this._ladder;
        }

        /**
         * @returns {StartingLights}
         */

    }, {
        key: "startingLights",
        get: function get() {
            return this._lights;
        }
    }]);

    return Hud;
}(PIXI.Container);

exports.default = Hud;

},{"./Common":7,"./RaceLadder":15,"./StartingLights":17}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Input
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 8/10/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Input = function () {
  function Input() {
    _classCallCheck(this, Input);

    /**
     * @member {Object} signals
     * @member {signals.Signal} signals.mouseMove
     * @member {signals.Signal} signals.mouseDown
     * @member {signals.Signal} signals.mouseUp
     * @member {signals.Signal} signals.mouseClick
     * @member {signals.Signal} signals.keyDown
     * @member {signals.Signal} signals.keyUp
     * @member {signals.Signal} signals.orientation
     * @member {signals.Signal} signals.swipeLeft
     * @member {signals.Signal} signals.swipeRight
     */
    this.signals = {
      mouseMove: new signals.Signal(),
      mouseDown: new signals.Signal(),
      mouseUp: new signals.Signal(),
      mouseClick: new signals.Signal(),
      keyDown: new signals.Signal(),
      keyUp: new signals.Signal(),
      orientation: new signals.Signal(),
      swipeLeft: new signals.Signal(),
      swipeRight: new signals.Signal()
    };

    /**
     * @type {PIXI.DisplayObject}
     * @private
     */
    this._stage = null;

    /**
     * @type {Object}
     * @private
     */
    this._keyMap = {};

    /**
     * @type {Object}
     * @private
     */
    this._keyBuffer = {};

    /**
     * @member {PIXI.Point}
     * @private
     */
    this._touch = null;

    /**
     * @member {Object} orientation
     * @member {number} orientation.gamma
     * @member {number} orientation.beta
     * @member {number} orientation.alpha
     * @private
     */
    this._orientation = {
      gamma: 0,
      beta: 0,
      alpha: 0
    };

    /**
     * @type {PIXI.Point}
     * @private
     */
    this._swipeStart = null;

    /**
     * @type {number}
     * @private
     */
    this._swipeTime = 0;
  }

  /**
   * @param {PIXI.DisplayObject} stage
   * @param {*} keyListener
   */


  _createClass(Input, [{
    key: "init",
    value: function init(stage, keyListener) {
      this._stage = stage;
      this._stage.interactive = true;
      this._stage.mousemove = this._stage.touchmove = this._onMouseMove.bind(this);
      this._stage.mousedown = this._stage.touchstart = this._onMouseDown.bind(this);
      this._stage.mouseup = this._stage.touchend = this._onMouseUp.bind(this);
      this._stage.click = this._stage.tap = this._onMouseClick.bind(this);

      keyListener.onkeydown = this._onKeyDown.bind(this);
      keyListener.onkeyup = this._onKeyUp.bind(this);
      keyListener.focus();

      document.onclick = function () {
        keyListener.focus();
      };

      _ismobilejs2.default.any && window.addEventListener("deviceorientation", this._onDeviceOrientation.bind(this));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._stage.mousemove = this._stage.touchmove = null;
      this._stage.mousedown = this._stage.touchstart = null;
      this._stage.mouseup = this._stage.touchend = null;
      this._stage.click = this._stage.tap = null;

      _ismobilejs2.default.any && window.removeEventListener("deviceorientation", this._onDeviceOrientation.bind(this));

      this.signals.mouseMove.dispose();
      this.signals.mouseDown.dispose();
      this.signals.mouseUp.dispose();
      this.signals.mouseClick.dispose();

      this.signals.keyDown.dispose();
      this.signals.keyUp.dispose();

      this.signals.orientation.dispose();

      this.signals.swipeLeft.dispose();
      this.signals.swipeRight.dispose();
    }
  }, {
    key: "update",
    value: function update() {
      for (var i in this._keyBuffer) {
        if (this._keyBuffer.hasOwnProperty(i)) {
          this._keyBuffer[i] = false;
        }
      }
    }

    /**
     * @param {number} keyCode
     * @returns {boolean}
     */

  }, {
    key: "isKeyDown",
    value: function isKeyDown(keyCode) {
      return this._keyMap[keyCode] === true;
    }

    /**
     * @param {number} keyCode
     * @returns {boolean}
     */

  }, {
    key: "isKeyPressed",
    value: function isKeyPressed(keyCode) {
      return this._keyBuffer[keyCode] === true;
    }

    /**
     * @param {Event} event
     */

  }, {
    key: "_onMouseMove",
    value: function _onMouseMove(event) {
      this._touch && (this._touch = event.data.getLocalPosition(this._stage));

      this.signals.mouseMove.dispatch(event);
    }

    /**
     * @param {Event} event
     */

  }, {
    key: "_onMouseDown",
    value: function _onMouseDown(event) {
      this._touch = event.data.getLocalPosition(this._stage);

      if (_ismobilejs2.default.any) {
        this._swipeStart = this._touch.clone();
        this._swipeTime = window.performance.now();
      }
      this.signals.mouseDown.dispatch(event);
    }

    /**
     * @param {Event} event
     */

  }, {
    key: "_onMouseUp",
    value: function _onMouseUp(event) {
      if (_ismobilejs2.default.any) {
        var swipe = new p3.Vector2(this._touch.x - this._swipeStart.x, this._touch.y - this._swipeStart.y);
        swipe.normalize(1);

        if (window.performance.now() - this._swipeTime < 800) {
          var left = swipe.dotProduct(new p3.Vector2(-1, 0));
          left > 0.9 && this.signals.swipeLeft.dispatch();

          var right = swipe.dotProduct(new p3.Vector2(1, 0));
          right > 0.9 && this.signals.swipeRight.dispatch();
        }
      }

      this._touch = null;
      this.signals.mouseUp.dispatch(event);
    }

    /**
     * @param {Event} event
     */

  }, {
    key: "_onMouseClick",
    value: function _onMouseClick(event) {
      this.signals.mouseClick.dispatch(event);
    }

    /**
     * @param {Event} event
     */

  }, {
    key: "_onKeyDown",
    value: function _onKeyDown(event) {
      !this.isKeyDown(event.keyCode) && (this._keyBuffer[event.keyCode] = true);
      this._keyMap[event.keyCode] = true;
      this.signals.keyDown.dispatch(event);
    }

    /**
     * @param {Event} event
     */

  }, {
    key: "_onKeyUp",
    value: function _onKeyUp(event) {
      this._keyMap[event.keyCode] = false;
      this.signals.keyUp.dispatch(event);
    }

    /**
     * @param {Event} event
     */

  }, {
    key: "_onDeviceOrientation",
    value: function _onDeviceOrientation(event) {
      this.signals.orientation.dispatch(event);
    }

    /**
     * @returns {PIXI.Point}
     */

  }, {
    key: "touch",
    get: function get() {
      return this._touch;
    }

    /**
     * @returns {Object} orientation
     * @returns {number} orientation.gamma
     * @returns {number} orientation.beta
     * @returns {number} orientation.alpha
     */

  }, {
    key: "orientation",
    get: function get() {
      return this._orientation;
    }
  }]);

  return Input;
}();

/**
 * @static
 * @const
 * @type {Object}
 */


exports.default = Input;
Input.keys = {};

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.W = 87;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.A = 65;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.S = 83;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.D = 68;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.Z = 90;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.X = 88;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.C = 67;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.LEFT = 37;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.RIGHT = 39;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.UP = 38;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.DOWN = 40;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.SPACE = 32;

/**
 * @static
 * @const
 * @type {number}
 */
Input.keys.ENTER = 13;

},{"ismobilejs":1}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Main
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 20/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Application = require("./Application");

var _Application2 = _interopRequireDefault(_Application);

var _AudioManager = require("./AudioManager");

var _AudioManager2 = _interopRequireDefault(_AudioManager);

var _BoomerangPreloaderScene = require("./scenes/BoomerangPreloaderScene");

var _BoomerangPreloaderScene2 = _interopRequireDefault(_BoomerangPreloaderScene);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _Input = require("./Input");

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Main = function () {
    /**
     * @param {number} width
     * @param {number} height
     */
    function Main(width, height) {
        _classCallCheck(this, Main);

        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {BoomerangPreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    _createClass(Main, [{
        key: "init",
        value: function init() {
            _Common2.default.assets = p3.AssetManager.instance;
            _Common2.default.audio = p3.Button.audio = new _AudioManager2.default();
            _Common2.default.language = language;

            var params = new p3.ViewParams();
            params.holderId = "game";
            params.width = this._width;
            params.height = this._height;
            params.rotateImageUrl = "./assets/images/localisation/rotate_" + language + ".jpg";
            params.rotateImageColor = "#000000";

            PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
            PIXI.settings.MIPMAP_TEXTURES = false;

            p3.Device.init(window["bowser"]);

            TweenMax.defaultOverwrite = "none";
            TweenMax.ticker.fps(60);

            var view = new p3.View(params);
            view.signals.ready.addOnce(function (canvas) {
                var options = {};
                options.view = canvas;
                options.transparent = false;
                options.antialias = false;
                options.preserveDrawingBuffer = false;
                options.resolution = 1.0;

                var stage = new PIXI.Container();
                _Common2.default.stage = stage;

                var input = new _Input2.default();
                input.init(stage, canvas);
                _Common2.default.input = input;

                if (p3.Device.isCocoonJS) {
                    stage.scale.x = window.innerHeight / params.height;
                    stage.scale.y = window.innerHeight / params.height;
                }

                var renderer = !p3.Device.isCocoonJS ? PIXI.autoDetectRenderer(this._width, this._height, options) : new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
                renderer.backgroundColor = 0x0;
                _Common2.default.renderer = renderer;
                _Common2.default.isWebGL = renderer instanceof PIXI.WebGLRenderer;

                var scene = new p3.SceneManager(renderer);
                scene.updateAll = true;
                _Common2.default.scene = scene;
                _Common2.default.stage.addChild(scene.view);

                // generate a blank texture
                var graphics = new PIXI.Graphics();
                graphics.beginFill(0xFFFFFF);
                graphics.drawRect(0, 0, 1, 1);
                graphics.endFill();
                _Common2.default.blankTexture = graphics.generateTexture();

                PIXI.ticker.shared.add(function (deltaTime) {
                    //window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;
                    window.deltaTime = 1 / 60;

                    scene.update();
                    input.update();
                    renderer.render(_Common2.default.stage);
                }, this);

                window.delay = function (callback, delay, scope) {
                    return TweenMax.delayedCall(delay, callback, [], scope);
                };
                window.translate = function (str) {
                    var s = _Common2.default.config.strings[str];
                    s = s && s[_Common2.default.language];
                    return typeof s !== "undefined" ? s : str;
                };
                window.font = function (size, align) {
                    align = align || "left";

                    switch (language) {
                        case "tr":
                        case "ro":
                        case "pl":
                            {
                                size += 10;
                                if (size > 64) {
                                    return { font: size + "px Cervo", align: align };
                                } else {
                                    return { font: size + "px Cervo", align: align };
                                }
                            }
                        default:
                            {
                                if (size > 64) {
                                    return { font: size + "px Antique Olive Std", align: align };
                                } else {
                                    return { font: size + "px Antique Olive Std", align: align };
                                }
                            }
                    }
                };

                this.loadPreloader();
            }, this);
            view.signals.resize.add(this.onCanvasResize, this);
            _Common2.default.view = view;
        }
    }, {
        key: "loadPreloader",
        value: function loadPreloader() {
            var files = [{ name: "characters", url: "data/" + "characters" + ".json" }, { name: "strings", url: "data/" + "strings" + ".json" }, { name: "preloader_1x", url: "images/" + "preloader_1x" + ".json" }, { name: "antique_64", url: "fonts/" + "antique_64" + ".xml" }, { name: "cervo_64", url: "fonts/" + "cervo_64" + ".xml" }, { name: "noto_64", url: "fonts/" + "noto_64" + ".xml" }];
            var sounds = [];
            if (files.length) {
                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.complete.addOnce(function () {
                    this.createConfig();
                    this.loadAssets();
                }, this);
                _Common2.default.assets.load();
            } else {
                this.loadAssets();
            }
        }
    }, {
        key: "loadAssets",
        value: function loadAssets() {
            var files = [{ name: "track01", url: "data/tracks/" + "track01" + ".json" }, { name: "track02", url: "data/tracks/" + "track02" + ".json" }, { name: "track03", url: "data/tracks/" + "track03" + ".json" }, { name: "track04", url: "data/tracks/" + "track04" + ".json" }, { name: "track05", url: "data/tracks/" + "track05" + ".json" }, { name: "vehicle_pussycat_1x", url: "images/" + "vehicle_pussycat_1x" + ".json" }, { name: "vehicle_turbo_1x", url: "images/" + "vehicle_turbo_1x" + ".json" }, { name: "vehicle_dastardly_1x", url: "images/" + "vehicle_dastardly_1x" + ".json" }, { name: "vehicle_grusome_1x", url: "images/" + "vehicle_grusome_1x" + ".json" }, { name: "vehicle_iq_1x", url: "images/" + "vehicle_iq_1x" + ".json" }, { name: "ui_splash", url: "images/" + "ui_splash" + ".jpg" }, { name: "ui_char_bg", url: "images/" + "ui_char_bg_1x" + ".jpg" }, { name: "ui_loading", url: "images/" + "ui_loading" + ".jpg" }, { name: "ui0_1x", url: "images/" + "ui0_1x" + ".json" }, { name: "ui1_1x", url: "images/" + "ui1_1x" + ".json" }, { name: "ui2_1x", url: "images/" + "ui2_1x" + ".json" }, { name: "powerups_1x", url: "images/" + "powerups_1x" + ".json" },
            //{name: "logo", url: "images/localisation/" + "logo_" + language + ".png"},
            { name: "logo", url: "images/localisation/" + "logo_en" + ".png" }, { name: "ui_tut_circle", url: "images/" + "ui_tut_circle" + ".png" }, { name: "particle_emitter_missile_normal_trail", url: "particles/" + "particle_emitter_missile_normal_trail" + ".json" }, { name: "particle_emitter_missile_smart_trail", url: "particles/" + "particle_emitter_missile_smart_trail" + ".json" }, { name: "particle_emitter_powerup_butterflies", url: "particles/" + "particle_emitter_powerup_butterflies" + ".json" }, { name: "particle_emitter_powerup_butterflies2", url: "particles/" + "particle_emitter_powerup_butterflies2" + ".json" }, { name: "particle_emitter_powerup_bubbles", url: "particles/" + "particle_emitter_powerup_bubbles" + ".json" }, { name: "particle_emitter_powerup_bubbles2", url: "particles/" + "particle_emitter_powerup_bubbles2" + ".json" }, { name: "particle_emitter_glue_puddle_00", url: "particles/" + "particle_emitter_glue_puddle_00" + ".json" }, { name: "particle_emitter_flameon_00", url: "particles/" + "particle_emitter_flameon_00" + ".json" }, { name: "particle_emitter_lightning_speed_00", url: "particles/" + "particle_emitter_lightning_speed_00" + ".json" }, { name: "particle_emitter_powerup_steamahead", url: "particles/" + "particle_emitter_powerup_steamahead" + ".json" }, { name: "particle_emitter_offtrack_dust_00", url: "particles/" + "particle_emitter_offtrack_dust_00" + ".json" }, { name: "particle_emitter_explosion_00", url: "particles/" + "particle_emitter_explosion_00" + ".json" }, { name: "particle_emitter_impact_left_00", url: "particles/" + "particle_emitter_impact_left_00" + ".json" }, { name: "particle_emitter_impact_right_00", url: "particles/" + "particle_emitter_impact_right_00" + ".json" }, { name: "particle_emitter_candy_blast_00", url: "particles/" + "particle_emitter_candy_blast_00" + ".json" }, { name: "particle_emitter_trophy_stars_00", url: "particles/" + "particle_emitter_trophy_stars_00" + ".json" }];
            var sounds = ["sfx_btn_press_00", "sfx_btn_rollover_00", "sfx_btn_nextcar_00", "sfx_car_land_00", "sfx_whistle_rise_00", "sfx_whistle_fall_00", "sfx_crowd_cheer_00", "sfx_fanfare_00", "sfx_carsrush_by_00", "sfx_cockerel_cry_00", "sfx_change_race_position_00", "ui_tracks_poster_reveal_00", "sfx_car_hit_00", "sfx_car_hit_01", "sfx_car_hit_02", "sfx_car_hit_03", "sfx_car_hit_04", "sfx_car_hit_05", "sfx_car_hit_06", "sfx_car_hit_07", "sfx_car_hit_08", "sfx_car_hit_09", "sfx_car_hit_10", "sfx_generic_race_loop_00", "sfx_generic_race_loop_01", "sfx_generic_race_loop_02", "sfx_ambient_wacky_loop_03", "sfx_trigger_switch_00", "sfx_carhorn_00", "sfx_carhorn_01", "sfx_carhorn_02", "sfx_carhorn_03", "sfx_crate_open_squeak_00", "sfx_muttly_giggle_00", "sfx_offtrack_loop_00", "sfx_pussycat_loop_01", "sfx_turbo_loop_00", "sfx_grusome_loop_01", "sfx_dastardly_loop_00", "sfx_iq_loop_01", "music_intro_start_00", "music_intro_loop_00", "music_intro_end_00", "music_garage_loop_00", "music_raceloop_00", "music_raceloop_01", "music_raceloop_02", "music_race_end_00", "sfx_race_lights_count_00", "sfx_race_lights_go_00", "sfx_car_start_tyres_04", "sfx_race_start_idle_revs_00", "sfx_hit_gravel_00", "sfx_hit_gravel_01", "sfx_hit_gravel_02", "sfx_bomb_explode_big_00", "sfx_bomb_explode_big_01", "sfx_launch_glue_00", "sfx_hit_glue_00", "sfx_launch_glue_00", "sfx_launch_missile_00", "sfx_launch_missile_01", "sfx_launch_object_00", "sfx_launch_object_01", "sfx_launch_object_02", "sfx_launch_object_03", "sfx_launch_object_04", "sfx_launch_object_05", "sfx_pickup_powerup_crate_00", "sfx_powerup_selected_00", "sfx_powerup_speedup_tyre_screech_00", "sfx_powerup_randomiser_loop_00", "sfx_car_slowdown_skid_00", "sfx_powerup_bubbles_00", "sfx_powerup_butterflies_01", "sfx_powerup_flame_00", "sfx_powerup_lightning_01", "sfx_powerup_steam_01", "sfx_hit_candy_02", "sfx_powerup_candy_00"];
            if (files.length) {
                this._preloader = new _BoomerangPreloaderScene2.default();
                _Common2.default.scene.add(this._preloader);

                _Common2.default.assets.addFiles(files, "assets/");
                _Common2.default.assets.signals.progress.add(this.onLoadingProgress, this);
                _Common2.default.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
                _Common2.default.assets.load();

                //Common.audio.addSoundSprite("sprite", sprite, [".ac3", ".m4a", ".mp3", ".ogg"], "assets/audio/");
                _Common2.default.audio.addSounds(sounds, [".m4a", ".mp3", ".ogg"], "assets/audio/");
            } else {
                this.startGame();
            }
        }
    }, {
        key: "createConfig",
        value: function createConfig() {
            var assets = _Common2.default.assets;

            var config = {};
            config.characters = assets.getJSON("characters").characters;
            config.strings = assets.getJSON("strings");
            _Common2.default.config = config;
            console.log(config);
        }
    }, {
        key: "startGame",
        value: function startGame() {
            delay(function () {
                this._game = new _Application2.default();
                this._game.init();
            }, 1.0, this);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onLoadingProgress",
        value: function onLoadingProgress(event) {
            this._preloader.loaded = event.progress / 100.0;
        }
    }, {
        key: "onLoadingCompleted",
        value: function onLoadingCompleted() {
            _Common2.default.assets.signals.progress.removeAll();
            _Common2.default.assets.signals.complete.removeAll();

            this._preloader.loaded = 1;
            this.startGame();
        }

        /**
         * @param {boolean} correct
         */

    }, {
        key: "onCanvasResize",
        value: function onCanvasResize(correct) {
            if (correct) {
                _Common2.default.renderer.resize(p3.View.width, p3.View.height);
                if (_Common2.default.scene) {
                    _Common2.default.scene.resize();
                }
            }
        }
    }]);

    return Main;
}();

exports.default = Main;

},{"./Application":3,"./AudioManager":5,"./Common":7,"./Input":9,"./scenes/BoomerangPreloaderScene":63}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceEntity2 = require("./race/RaceEntity");

var _RaceEntity3 = _interopRequireDefault(_RaceEntity2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Pickup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 21/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceEntity
 */
var Pickup = function (_RaceEntity) {
    _inherits(Pickup, _RaceEntity);

    function Pickup() {
        _classCallCheck(this, Pickup);

        var assets = _Common2.default.assets;

        var _this = _possibleConstructorReturn(this, (Pickup.__proto__ || Object.getPrototypeOf(Pickup)).call(this, _RaceEntity3.default.TYPE_STATIC, new PIXI.Sprite(assets.getTexture("powerup_mystery_object_00"))));

        _this.collisionWidth = 60;
        _this.collisionLength = 34;
        _this.view.anchor = new PIXI.Point(0.5, 0.5);

        /**
         * @param {signals.Signal}
         */
        _this.signals.collect = new signals.Signal();

        /**
         * @type {number}
         */
        _this.respawnDelay = 4;

        /**
         * @param {boolean}
         * @private
         */
        _this._collected = false;

        /**
         * @type {Array.<TweenMax>}
         * @private
         */
        _this._tweens = [];
        return _this;
    }

    /**
     */


    _createClass(Pickup, [{
        key: "init",
        value: function init() {
            _get(Pickup.prototype.__proto__ || Object.getPrototypeOf(Pickup.prototype), "init", this).call(this);

            this.startOffsetY = this.offset.y;

            this._tweens.push(TweenMax.to(this.offset, 0.8, {
                y: this.offset.y + 40.0,
                ease: Power1.easeInOut,
                yoyo: true,
                repeat: -1
            }));
        }

        /**
         * @param dt
         */

    }, {
        key: "update",
        value: function update(dt) {}

        /**
         */

    }, {
        key: "destroy",
        value: function destroy() {
            this.signals.collect.dispose();

            this.killAllTweens();

            _get(Pickup.prototype.__proto__ || Object.getPrototypeOf(Pickup.prototype), "destroy", this).call(this);
        }

        /**
         */

    }, {
        key: "reset",
        value: function reset() {
            this.offset.y = this.startOffsetY;
            this._collected = false;
            this.renderToWorld = true;
            this._view.alpha = 1;
            this._view.visible = true;

            this.killAllTweens();
            this.init();
        }

        /**
         */

    }, {
        key: "killAllTweens",
        value: function killAllTweens() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.kill();
            }
            this._tweens.length = 0;
        }

        /**
         * @param {RaceCar} collector
         * @returns {boolean}
         */

    }, {
        key: "collect",
        value: function collect(collector) {
            if (this._collected) return false;

            this._collected = true;
            this.renderToWorld = false;

            collector.jump(false);

            if (collector.id === _Common2.default.playerDriverId) {
                var tl = new TimelineMax();
                this._tweens.push(tl);

                tl.append(TweenMax.to(this._view.scale, 0.2, {
                    x: 1,
                    y: 1,
                    ease: Back.easeOut,
                    easeParams: [1]
                }));

                tl = new TimelineMax();
                this._tweens.push(tl);

                tl.append(TweenMax.to(this._view, 0.2, {
                    x: collector.view.x,
                    y: collector.view.y,
                    ease: Power1.easeInOut
                }));
                tl.append(TweenMax.to(this._view, 0.34, {
                    y: collector.view.y - 200,
                    ease: Power2.easeInOut,
                    onComplete: function onComplete() {
                        this._view.texture = _Common2.default.assets.getTexture("powerup_mystery_object_01");
                        collector.id === _Common2.default.playerDriverId && _Common2.default.audio.playSound("sfx_crate_open_squeak_00");

                        delay(function () {
                            this.signals.collect.dispatch(this, collector);
                        }, 0.4, this);
                    },
                    onCompleteScope: this
                }));
                tl.append(TweenMax.to(this._view, 0.34, {
                    delay: 0.2,
                    alpha: 0,
                    ease: Power1.easeInOut,
                    onComplete: function onComplete() {
                        this._view.texture = _Common2.default.assets.getTexture("powerup_mystery_object_00");
                        this._view.visible = false;
                    },
                    onCompleteScope: this
                }));
            } else {
                this.view.visible = false;
                this.signals.collect.dispatch(this, collector);
            }

            delay(this.reset, this.respawnDelay, this);

            // only play this sound if the player grabs
            collector.id === _Common2.default.playerDriverId && _Common2.default.audio.playSound("sfx_pickup_powerup_crate_00");
            return true;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "collected",
        get: function get() {
            return this._collected;
        }
    }]);

    return Pickup;
}(_RaceEntity3.default);

exports.default = Pickup;

},{"./Common":7,"./race/RaceEntity":57}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _Powerup = require("./powerups/Powerup");

var _Powerup2 = _interopRequireDefault(_Powerup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  PickupAnimation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 11/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends PIXI.Container
 */
var PickupSelector = function (_PIXI$Container) {
    _inherits(PickupSelector, _PIXI$Container);

    function PickupSelector(inputEnabled) {
        _classCallCheck(this, PickupSelector);

        /**
         * @type {*}
         */
        var _this = _possibleConstructorReturn(this, (PickupSelector.__proto__ || Object.getPrototypeOf(PickupSelector)).call(this));

        _this.signals = {};

        /**
         * @type {signals.Signal}
         */
        _this.signals.select = new signals.Signal();

        /**
         * @type {Array}
         * @private
         */
        _this._powerupTypes = _Powerup2.default.getRandomTypes();

        /**
         * @type {number}
         * @private
         */
        _this._powerupIndex = 0;

        /**
         * @type {boolean}
         * @private
         */
        _this._inputPressed = false;

        /**
         * @type {boolean}
         * @private
         */
        _this._inputEnabled = inputEnabled;

        /**
         * @type {function}
         * @private
         */
        _this._inputFunc = null;

        var assets = _Common2.default.assets;
        var orb = new PIXI.Sprite(assets.getTexture("game_powerup_bg"));
        orb.anchor = new PIXI.Point(0.5, 0.5);
        orb.scale = new PIXI.Point(0.8, 0.8);
        _this.addChild(orb);
        return _this;
    }

    _createClass(PickupSelector, [{
        key: "destroy",
        value: function destroy(options) {
            this._inputEnabled && _Common2.default.input.signals.keyDown.remove(this._inputFunc);

            _get(PickupSelector.prototype.__proto__ || Object.getPrototypeOf(PickupSelector.prototype), "destroy", this).call(this, options);
        }

        /**
         */

    }, {
        key: "start",
        value: function start() {
            var count = p3.Utils.randomInt(6, 12);

            var icon = new PIXI.Sprite(PIXI.Texture.EMPTY);
            icon.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(icon);

            function next(t) {
                delay(function () {
                    this._powerupIndex++;
                    this._powerupIndex %= this._powerupTypes.length;
                    var type = this._powerupTypes[this._powerupIndex];

                    icon.texture = _Powerup2.default.getTexture(type);
                    icon.scale = new PIXI.Point(0.5, 0.5);
                    TweenMax.to(icon.scale, 0.18, {
                        x: 1,
                        y: 1,
                        ease: Back.easeOut,
                        easeParams: [4],
                        onComplete: function onComplete() {
                            if (--count > 0) {
                                next.call(this, 0.02);
                            } else {
                                TweenMax.to(this.scale, 0.34, {
                                    delay: 0.2,
                                    x: 0,
                                    y: 0,
                                    ease: Back.easeIn,
                                    easeParams: [1],
                                    onComplete: function onComplete() {
                                        this.destroy();
                                    },
                                    onCompleteScope: this
                                });

                                var _type = this._powerupTypes[this._powerupIndex];
                                this.signals.select.dispatch(this, _type);

                                this.visible && _Common2.default.audio.playSound("sfx_powerup_selected_00");
                            }
                        },
                        onCompleteScope: this
                    });

                    this.visible && _Common2.default.audio.playSound("sfx_powerup_randomiser_loop_00");
                }, t, this);
            }
            next.call(this, 0);

            if (this._inputEnabled) {
                this._inputFunc = function (event) {
                    if (!this._inputPressed && event.keyCode === 32) {
                        this._inputPressed = true;
                        count = 0;
                    }
                };
                _Common2.default.input.signals.keyDown.add(this._inputFunc, this);
            }
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "inputEnabled",
        get: function get() {
            return this._inputEnabled;
        }
    }]);

    return PickupSelector;
}(PIXI.Container);

exports.default = PickupSelector;

},{"./Common":7,"./powerups/Powerup":44}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AudioParams = require("./AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _Input = require("./Input");

var _Input2 = _interopRequireDefault(_Input);

var _PussycatView = require("./cars/PussycatView");

var _PussycatView2 = _interopRequireDefault(_PussycatView);

var _RaceCar2 = require("./race/RaceCar");

var _RaceCar3 = _interopRequireDefault(_RaceCar2);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Player
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 22/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @memberOf race
 * @extends RaceCar
 */
var Player = function (_RaceCar) {
    _inherits(Player, _RaceCar);

    /**
     * @param {number} id
     * @param {RaceCarView} [view]
     */
    function Player(id, view) {
        _classCallCheck(this, Player);

        var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, id, view || new _PussycatView2.default()));

        _this.turnAccel = 12000;
        _this.turnDamping = 0.94;

        /**
         * @type {Audio}
         * @private
         */
        _this._engineSFX = null;

        /**
         * @type {Audio}
         * @private
         */
        _this._offroadSFX = null;

        /**
         * @type {boolean}
         * @private
         */
        _this._playOffroadSFX = false;

        /**
         * @type {number}
         * @private
         */
        _this._hitTime = window.performance.now();
        return _this;
    }

    /**
     */


    _createClass(Player, [{
        key: "init",
        value: function init() {
            _get(Player.prototype.__proto__ || Object.getPrototypeOf(Player.prototype), "init", this).call(this);
        }

        /**
         */

    }, {
        key: "destroy",
        value: function destroy() {
            this.stopEngineSFX();
            this.stopOffroadSFX();

            _get(Player.prototype.__proto__ || Object.getPrototypeOf(Player.prototype), "destroy", this).call(this);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            this.turnSpeed = 0;

            var input = _Common2.default.input;

            if (_ismobilejs2.default.any) {
                if (input.touch) {
                    console.log(input.touch.x, p3.View.width * 0.5);
                    if (input.touch.x < (p3.View.width - p3.View.width * 0.4) * 0.5) {
                        this.turnSpeed = -this.turnAccel;
                    }
                    if (input.touch.x > (p3.View.width + p3.View.width * 0.4) * 0.5) {
                        this.turnSpeed = this.turnAccel;
                    }
                }
            } else {
                if (input.isKeyDown(_Input2.default.keys.A) || input.isKeyDown(_Input2.default.keys.LEFT)) {
                    this.turnSpeed = -this.turnAccel;
                }
                if (input.isKeyDown(_Input2.default.keys.D) || input.isKeyDown(_Input2.default.keys.RIGHT)) {
                    this.turnSpeed = this.turnAccel;
                }
                if (input.isKeyDown(_Input2.default.keys.S) || input.isKeyDown(_Input2.default.keys.DOWN)) {
                    //this.brake();
                }
            }

            if (this._offroad) {
                this.engine.camera.applyShake(0.1);
                !this._offroadSFX && this.startOffroadSFX();
                this._playOffroadSFX = true;
            } else {
                this._offroadSFX && this.stopOffroadSFX();
                if (this._playOffroadSFX) {
                    this._playOffroadSFX = false;
                    _Common2.default.audio.playSound(["sfx_hit_gravel_00", "sfx_hit_gravel_01", "sfx_hit_gravel_02"]);
                }
            }
            _get(Player.prototype.__proto__ || Object.getPrototypeOf(Player.prototype), "update", this).call(this, dt);

            //console.log("PLAYER:", this.getTotalDistance(), this.distance, this.engine.track.length, this.lap);
        }

        /**
         * @param {boolean} [playSound=true]
         */

    }, {
        key: "takeHit",
        value: function takeHit() {
            var playSound = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            _get(Player.prototype.__proto__ || Object.getPrototypeOf(Player.prototype), "takeHit", this).call(this, playSound);

            _Common2.default.audio.playSound("sfx_car_slowdown_skid_00");
        }

        /**
         * @param {RaceCollision} collision
         * @param {RaceCar} car
         */

    }, {
        key: "onCollisionBegin",
        value: function onCollisionBegin(collision, car) {
            _get(Player.prototype.__proto__ || Object.getPrototypeOf(Player.prototype), "onCollisionBegin", this).call(this, collision, car);

            if (window.performance.now() - this._hitTime > 4000) {
                this._hitTime = window.performance.now();
                _Common2.default.audio.playSound(["sfx_carhorn_00", "sfx_carhorn_01", "sfx_carhorn_02", "sfx_carhorn_03"]);
                this.engine.camera.applyShake(1, 30);
            }
        }

        /**
         */

    }, {
        key: "startEngineSFX",
        value: function startEngineSFX() {
            this.stopEngineSFX();

            var name = void 0;
            switch (this._id) {
                case 0:
                    {
                        name = "sfx_pussycat_loop_01";
                        break;
                    }
                case 1:
                    {
                        name = "sfx_turbo_loop_00";
                        break;
                    }
                case 2:
                    {
                        name = "sfx_dastardly_loop_00";
                        break;
                    }
                case 3:
                    {
                        name = "sfx_grusome_loop_01";
                        break;
                    }
                case 4:
                    {
                        name = "sfx_iq_loop_01";
                        break;
                    }
            }

            var params = new _AudioParams2.default();
            params.loop = true;
            this._engineSFX = _Common2.default.audio.playSound(name, params);
        }
    }, {
        key: "stopEngineSFX",
        value: function stopEngineSFX() {
            if (!this._engineSFX) return;
            this._engineSFX.destroy();
        }
    }, {
        key: "startOffroadSFX",
        value: function startOffroadSFX() {
            this.stopOffroadSFX();
            var params = new _AudioParams2.default();
            params.loop = true;
            this._offroadSFX = _Common2.default.audio.playSound("sfx_offtrack_loop_00", params);
        }
    }, {
        key: "stopOffroadSFX",
        value: function stopOffroadSFX() {
            if (!this._offroadSFX) return;
            this._offroadSFX.destroy();
            this._offroadSFX = null;
        }
    }]);

    return Player;
}(_RaceCar3.default);

exports.default = Player;

},{"./AudioParams":6,"./Common":7,"./Input":9,"./cars/PussycatView":21,"./race/RaceCar":53,"ismobilejs":1}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _Powerup = require("./powerups/Powerup");

var _Powerup2 = _interopRequireDefault(_Powerup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  RaceAvatar
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 09/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var RaceAvatar = function (_PIXI$Container) {
    _inherits(RaceAvatar, _PIXI$Container);

    /**
     * @param {number} id
     * @param {PIXI.Texture} texture
     * @param {RaceCar} car
     */
    function RaceAvatar(id, texture, car) {
        _classCallCheck(this, RaceAvatar);

        /**
         * @type {number}
         */
        var _this = _possibleConstructorReturn(this, (RaceAvatar.__proto__ || Object.getPrototypeOf(RaceAvatar)).call(this));

        _this.lastRacePos = 0;

        /**
         * @type {number}
         * @private
         */
        _this._id = id;

        /**
         * @type {RaceCar}
         * @private
         */
        _this._car = car;

        /**
         * @type {PIXI.Texture}
         * @private
         */
        _this._texture = texture;

        /**
         * @type {PIXI.Container}
         */
        _this.view = new PIXI.Container();
        _this.addChild(_this.view);

        var assets = _Common2.default.assets;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._hit = new PIXI.Sprite(assets.getTexture("ui_icon_char_hit"));
        _this._hit.anchor = new PIXI.Point(0.5, 0.5);
        _this._hit.visible = false;
        _this.view.addChild(_this._hit);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._player = new PIXI.Sprite(assets.getTexture("ui_icon_char_player_bg"));
        _this._player.anchor = new PIXI.Point(0.5, 0.5);
        _this._player.visible = _this._car.isPlayer;
        _this.view.addChild(_this._player);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._character = new PIXI.Sprite(texture);
        _this._character.anchor = new PIXI.Point(0.5, 0.5);
        _this.view.addChild(_this._character);

        /**
         * @type {PIXI.BitmapText}
         */
        //this._racePosLabel = new PIXI.BitmapText("0", font(32, "left"));
        _this._racePosLabel = new PIXI.BitmapText("0", { font: "32px Antique Olive Std", align: "left" });
        _this._racePosLabel.x = -4;
        _this._racePosLabel.pivot.x = _this._racePosLabel.textWidth * 0.5;
        _this._racePosLabel.pivot.y = _this._racePosLabel.textHeight * 0.5;
        _this.view.addChild(_this._racePosLabel);
        return _this;
    }

    /**
     * @param {number} type
     * @param {boolean} [hit=false]
     */


    _createClass(RaceAvatar, [{
        key: "usePowerup",
        value: function usePowerup(type) {
            var hit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var icon = new PIXI.Sprite(_Powerup2.default.getTexture(type));
            icon.x = 60;
            icon.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(icon);

            var tl = new TimelineMax();

            icon.scale = new PIXI.Point();
            tl.append(TweenMax.to(icon.scale, 0.32, {
                x: 0.4,
                y: 0.4,
                ease: Back.easeOut,
                easeParams: [4]
            }));
            tl.append(TweenMax.to(icon.scale, 0.2, {
                delay: 0.4,
                x: 0,
                y: 0,
                ease: Back.easeIn
            }));

            if (hit) {
                var _tl = new TimelineMax();
                _tl.append(TweenMax.to(this.view.scale, 0.2, {
                    x: 1.24,
                    y: 1.24,
                    ease: Power0.easeNone
                }));
                _tl.append(TweenMax.to(this.view.scale, 0.24, {
                    x: 1,
                    y: 1,
                    ease: Power2.easeOut
                }));

                this._hit.alpha = 0;
                this._hit.visible = true;
                TweenMax.to(this._hit, 0.2, {
                    alpha: 1,
                    ease: Power2.easeInOut,
                    yoyo: true,
                    repeat: 3,
                    onComplete: function onComplete() {
                        this._hit.visible = false;
                    },
                    onCompleteScope: this
                });
            }
        }

        /**
         * @param {number} value
         */

    }, {
        key: "setRacePos",
        value: function setRacePos(value) {
            this._racePosLabel.text = value.toString();
            this._racePosLabel.validate();
            this._racePosLabel.pivot.x = this._racePosLabel.textWidth * 0.5;
            this._racePosLabel.pivot.y = this._racePosLabel.textHeight * 0.5;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "id",
        get: function get() {
            return this._id;
        }

        /**
         * @returns {RaceCar}
         */

    }, {
        key: "car",
        get: function get() {
            return this._car;
        }
    }]);

    return RaceAvatar;
}(PIXI.Container);

exports.default = RaceAvatar;

},{"./Common":7,"./powerups/Powerup":44}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceAvatar = require("./RaceAvatar");

var _RaceAvatar2 = _interopRequireDefault(_RaceAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  RaceLadder
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 09/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends PIXI.Container
 */
var RaceLadder = function (_PIXI$Container) {
    _inherits(RaceLadder, _PIXI$Container);

    function RaceLadder() {
        _classCallCheck(this, RaceLadder);

        /**
         * @type {*}
         */
        var _this = _possibleConstructorReturn(this, (RaceLadder.__proto__ || Object.getPrototypeOf(RaceLadder)).call(this));

        _this.signals = {};

        /**
         * @type {*}
         */
        _this.signals.change = new signals.Signal();

        /**
         * @type {Array}
         * @private
         */
        _this._avatars = [];

        /**
         * @type {number}
         * @private
         */
        _this._spacing = 66;
        return _this;
    }

    /**
     */


    _createClass(RaceLadder, [{
        key: "init",
        value: function init() {
            var cars = _Common2.default.game.getCars();
            for (var i = 0; i < cars.length; ++i) {
                var car = cars[i];
                var texture = RaceLadder.getAvatarTexture(car.id);
                var avatar = new _RaceAvatar2.default(car.id, texture, car);
                avatar.y = this._spacing * i;
                avatar.lastRacePos = i;
                this.addChild(avatar);
                this._avatars.push(avatar);
            }
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {}

        /**
         * @param {function} [callback]
         * @param {*} scope
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {}

        /**
         */

    }, {
        key: "update",
        value: function update() {
            this._avatars.sort(function (a, b) {
                return b.car.getTotalDistance() - a.car.getTotalDistance();
            });

            for (var i = 0; i < this._avatars.length; ++i) {
                var avatar = this._avatars[i];
                avatar.y = this._spacing * i;
                avatar.setRacePos(i + 1);
                if (avatar.lastRacePos !== i) {
                    avatar.lastRacePos = i;
                    this.signals.change.dispatch(avatar, i);
                }
            }
        }

        /**
         * @param {number} type
         * @param {RaceCar} car
         * @param {boolean} hit
         */

    }, {
        key: "usePowerup",
        value: function usePowerup(type, car, hit) {
            for (var i = 0; i < this._avatars.length; ++i) {
                var avatar = this._avatars[i];
                if (avatar.car === car) {
                    avatar.usePowerup(type, hit);
                }
            }
        }

        /**
         * @param {number} id
         * @returns {PIXI.Texture}
         */

    }], [{
        key: "getAvatarTexture",
        value: function getAvatarTexture(id) {
            var assets = _Common2.default.assets;
            var characters = _Common2.default.config.characters;
            for (var i = 0; i < characters.length; ++i) {
                var character = characters[i];
                if (character.id === id) {
                    return assets.getTexture(character.avatar.texture);
                }
            }
        }
    }]);

    return RaceLadder;
}(PIXI.Container);

exports.default = RaceLadder;

},{"./Common":7,"./RaceAvatar":14}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Skybox
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 31/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var Skybox = function (_PIXI$Container) {
        _inherits(Skybox, _PIXI$Container);

        function Skybox() {
                _classCallCheck(this, Skybox);

                var _this = _possibleConstructorReturn(this, (Skybox.__proto__ || Object.getPrototypeOf(Skybox)).call(this));

                _this.createMainLayer();

                _this.update(1);
                return _this;
        }

        _createClass(Skybox, [{
                key: "resize",
                value: function resize() {}

                /**
                 * @param {number} [ease]
                 */

        }, {
                key: "update",
                value: function update(ease) {
                        ease = ease || 0.04;

                        var engine = _Common2.default.engine;
                        var camera = engine.camera;
                        var target = camera.target;

                        var angle = camera.angle;
                        if (angle < 0) angle += Math.PI * 2;
                        if (angle > Math.PI * 2) angle -= Math.PI * 2;
                        angle /= Math.PI * 2;

                        this._mainLayer.x = -angle * this._mainLayer.tileWidth * this._mainLayer.tileCount;

                        var diff = -40 + engine.getTrackGradient(target.distance) * 240 * 2 - this._mainLayer.y;
                        this._mainLayer.y += diff * ease;
                }

                /**
                 */

        }, {
                key: "createMainLayer",
                value: function createMainLayer() {
                        var assets = _Common2.default.assets;

                        var texture = assets.getTexture("skybox");

                        this._mainLayer = new PIXI.Container();
                        this.addChild(this._mainLayer);

                        var count = 3;

                        var tile = void 0;
                        for (var i = 0; i < count; ++i) {
                                tile = new PIXI.Sprite(texture);
                                tile.anchor = new PIXI.Point(0.5, 0.5);
                                this._mainLayer.addChild(tile);

                                var aspectRatio = tile.width / tile.height;
                                tile.width = p3.View.height * aspectRatio;
                                tile.height = p3.View.height;

                                tile.x = _Common2.default.STAGE_WIDTH * 0.5 + tile.width * i;
                                tile.y = tile.height * 0.5;
                        }

                        this._mainLayer.tileWidth = tile.width;
                        this._mainLayer.tileCount = count - 1;
                }
        }]);

        return Skybox;
}(PIXI.Container);

exports.default = Skybox;

},{"./Common":7}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("./Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  StartingLights
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 08/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var StartingLights = function (_PIXI$Container) {
    _inherits(StartingLights, _PIXI$Container);

    function StartingLights() {
        _classCallCheck(this, StartingLights);

        /**
         * @type {Array.<PIXI.Sprite>}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (StartingLights.__proto__ || Object.getPrototypeOf(StartingLights)).call(this));

        _this._lights = [];

        /**
         * @type {Array.<TweenMax>}
         * @private
         */
        _this._tweens = [];

        var assets = _Common2.default.assets;

        var bg = new PIXI.Sprite(assets.getTexture("wr_race_lights_bg"));
        bg.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(bg);

        var positions = [new PIXI.Point(-88, 48), new PIXI.Point(-35, 48), new PIXI.Point(35, 48), new PIXI.Point(84, 48)];

        for (var i = 0; i < positions.length; ++i) {
            var light = new PIXI.Sprite(assets.getTexture("wr_race_lights_red"));
            light.position = positions[i].clone();
            light.scale.x = i < 2 ? 1 : -1;
            light.anchor = new PIXI.Point(0.5, 0.5);
            light.visible = false;
            _this.addChild(light);
            _this._lights.push(light);
        }
        for (var _i = 0; _i < positions.length; ++_i) {
            var _light = new PIXI.Sprite(assets.getTexture("wr_race_lights_green"));
            _light.position = positions[_i].clone();
            _light.scale.x = _i < 2 ? 1 : -1;
            _light.anchor = new PIXI.Point(0.5, 0.5);
            _light.visible = false;
            _this.addChild(_light);
            _this._lights.push(_light);
        }
        return _this;
    }

    _createClass(StartingLights, [{
        key: "destroy",
        value: function destroy() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.kill();
            }
            this._tweens.length = 0;

            _get(StartingLights.prototype.__proto__ || Object.getPrototypeOf(StartingLights.prototype), "destroy", this).call(this, { removeChildren: true });
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            var to = this.y;
            this.y -= 200;
            this._tweens.push(TweenMax.to(this, 0.4, {
                y: to,
                ease: Back.easeOut,
                easeParams: [1],
                onComplete: callback,
                onCompleteScope: scope
            }));
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {
            var to = this.y - 200;
            this._tweens.push(TweenMax.to(this, 0.4, {
                delay: 0.4,
                y: to,
                ease: Back.easeIn,
                onComplete: callback,
                onCompleteScope: scope
            }));
        }

        /**
         * @param {number} [time]
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "start",
        value: function start(time, callback, scope) {
            var index = 0;

            red.call(this);
            function red() {
                var light = this._lights[index];
                light.alpha = 0;
                light.visible = true;

                this._tweens.push(TweenMax.to(light, 0.04, {
                    delay: time,
                    alpha: 1,
                    ease: Power2.easeInOut,
                    onComplete: function onComplete() {
                        if (++index < 4) {
                            red.call(this);
                            _Common2.default.audio.playSound("sfx_race_lights_count_00");
                        } else {
                            delay(green, 1, this);
                            _Common2.default.audio.playSound("sfx_race_lights_count_00");
                        }
                    },
                    onCompleteScope: this
                }));
            }

            function green() {
                for (var i = 0; i < 4; ++i) {
                    var light = this._lights[i];
                    light.visible = false;
                }
                for (var _i2 = 4; _i2 < this._lights.length; ++_i2) {
                    var _light2 = this._lights[_i2];
                    _light2.visible = true;

                    _light2.alpha = 0;
                    this._tweens.push(TweenMax.to(_light2, 0.04, {
                        alpha: 1,
                        ease: Power2.easeInOut
                    }));
                }
                callback && callback.call(scope);

                _Common2.default.audio.playSound("sfx_race_lights_go_00");
            }
        }
    }, {
        key: "resume",
        value: function resume() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.resume();
            }
        }
    }, {
        key: "pause",
        value: function pause() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.pause();
            }
        }
    }]);

    return StartingLights;
}(PIXI.Container);

exports.default = StartingLights;

},{"./Common":7}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceCarView2 = require("../race/RaceCarView");

var _RaceCarView3 = _interopRequireDefault(_RaceCarView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  DoomBuggyView
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceCarView
 * @memberOf race
 */
var DoomBuggyView = function (_RaceCarView) {
    _inherits(DoomBuggyView, _RaceCarView);

    function DoomBuggyView() {
        _classCallCheck(this, DoomBuggyView);

        var _this = _possibleConstructorReturn(this, (DoomBuggyView.__proto__ || Object.getPrototypeOf(DoomBuggyView)).call(this));

        _this._shadow.y = 122;

        _this._front.offset.y = -152;
        _this._back.offset.y = -152;

        _this._wheels.front.left.offset = new PIXI.Point(-200, -20);
        _this._wheels.front.right.offset = new PIXI.Point(200, -20);

        _this._wheels.rear.left.offset = new PIXI.Point(-200, 20);
        _this._wheels.rear.right.offset = new PIXI.Point(200, 20);

        /**
         * @type {Object}
         * @private
         */
        _this._axles = {};

        /**
         * @type {Object}
         */
        _this._axles.front = {};

        /**
         * @type {Object}
         */
        _this._axles.rear = {};

        /**
         * @type {Sprite}
         */
        _this._axles.front.left = _this.createFrontAxle();
        _this._axles.front.left.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChildAt(_this._axles.front.left, 0);

        /**
         * @type {Sprite}
         */
        _this._axles.front.right = _this.createFrontAxle();
        _this._axles.front.right.anchor = new PIXI.Point(0.5, 0.5);
        _this._axles.front.right.scale.x = -1;
        _this.addChildAt(_this._axles.front.right, 0);

        /**
         * @type {Sprite}
         */
        _this._axles.rear.left = _this.createRearAxle();
        _this._axles.rear.left.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChildAt(_this._axles.rear.left, 6);

        /**
         * @type {Sprite}
         */
        _this._axles.rear.right = _this.createRearAxle();
        _this._axles.rear.right.anchor = new PIXI.Point(0.5, 0.5);
        _this._axles.rear.right.scale.x = -1;
        _this.addChildAt(_this._axles.rear.right, 6);
        return _this;
    }

    _createClass(DoomBuggyView, [{
        key: "init",
        value: function init() {}
    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {}

        /**
         * @param {number} dt
         * @param {number} distance
         * @param {number} curvature
         * @param {number} gradient
         * @param {number} velocity
         * @param {number} turnVelocity
         * @param {number} jumpOffset
         */

    }, {
        key: "update",
        value: function update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
            _get(DoomBuggyView.prototype.__proto__ || Object.getPrototypeOf(DoomBuggyView.prototype), "update", this).call(this, dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset);

            var scalar = 140;

            this._curvature += (turnVelocity + curvature - this._curvature) * 0.4;
            this._curvature = Math.max(-scalar, Math.min(scalar, this._curvature));

            this._front.x = this._curvature * 0.3 + this._front.offset.x;
            this._front.y = -gradient * scalar * 1.6 + this._front.offset.y - jumpOffset * 136;

            this._back.x = -this._curvature * 0.1 + this._back.offset.x;
            this._back.y = gradient * scalar + this._back.offset.y - jumpOffset * 118;

            this._front.rotation = this._curvature * 0.0012;
            this._back.rotation = this._curvature * 0.0012;

            this._wheels.front.left.x = this._front.x + this._wheels.front.left.offset.x;
            this._wheels.front.left.y = gradient * scalar + this._wheels.front.left.offset.y - jumpOffset * 74;

            this._wheels.front.right.x = this._front.x + this._wheels.front.right.offset.x;
            this._wheels.front.right.y = gradient * scalar + this._wheels.front.right.offset.y - jumpOffset * 74;

            this._wheels.rear.left.x = this._back.x + this._wheels.rear.left.offset.x;
            this._wheels.rear.left.y = gradient * scalar + this._wheels.rear.left.offset.y - jumpOffset * 72;

            this._wheels.rear.right.x = this._back.x + this._wheels.rear.right.offset.x;
            this._wheels.rear.right.y = gradient * scalar + this._wheels.rear.right.offset.y - jumpOffset * 72;

            velocity = Math.max(0, velocity) / 0.2;
            this._wheels.front.left.animationSpeed = velocity;
            this._wheels.front.right.animationSpeed = velocity;
            this._wheels.rear.left.animationSpeed = velocity;
            this._wheels.rear.right.animationSpeed = velocity;

            this.updateAxles();
        }
    }, {
        key: "updateAxles",
        value: function updateAxles() {
            // front axles
            var offset = new PIXI.Point(26, 84);
            var center = new PIXI.Point(this._front.x, this._front.y);
            var angle = this._front.rotation;
            var la = new PIXI.Point(center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x));
            var ra = new PIXI.Point(center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x));

            offset = new PIXI.Point(74, 0);
            center = new PIXI.Point(this._wheels.front.left.x, this._wheels.front.left.y);
            angle = this._wheels.front.left.rotation;
            var lb = new PIXI.Point(center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x));

            center = new PIXI.Point(this._wheels.front.right.x, this._wheels.front.right.y);
            angle = this._wheels.front.right.rotation;
            var rb = new PIXI.Point(center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x));

            var axle = new PIXI.Point(la.x + (lb.x - la.x) * 0.5, la.y + (lb.y - la.y) * 0.5);
            var axleAngle = Math.atan2(la.y - lb.y, la.x - lb.x);

            this._axles.front.left.x = axle.x;
            this._axles.front.left.y = axle.y;
            this._axles.front.left.rotation = axleAngle;

            axle = new PIXI.Point(ra.x + (rb.x - ra.x) * 0.5, ra.y + (rb.y - ra.y) * 0.5);
            axleAngle = Math.atan2(rb.y - ra.y, rb.x - ra.x);

            this._axles.front.right.x = axle.x;
            this._axles.front.right.y = axle.y;
            this._axles.front.right.rotation = axleAngle;

            // rear axles
            offset = new PIXI.Point(26, 112);
            center = new PIXI.Point(this._back.x, this._back.y);
            angle = this._back.rotation;
            la = new PIXI.Point(center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x));
            ra = new PIXI.Point(center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x));

            offset = new PIXI.Point(74, 0);
            center = new PIXI.Point(this._wheels.rear.left.x, this._wheels.rear.left.y);
            angle = this._wheels.rear.left.rotation;
            lb = new PIXI.Point(center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x));

            center = new PIXI.Point(this._wheels.rear.right.x, this._wheels.rear.right.y);
            angle = this._wheels.rear.right.rotation;
            rb = new PIXI.Point(center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x));

            axle = new PIXI.Point(la.x + (lb.x - la.x) * 0.5, la.y + (lb.y - la.y) * 0.5);
            axleAngle = Math.atan2(la.y - lb.y, la.x - lb.x);

            this._axles.rear.left.x = axle.x;
            this._axles.rear.left.y = axle.y;
            this._axles.rear.left.rotation = axleAngle;

            axle = new PIXI.Point(ra.x + (rb.x - ra.x) * 0.5, ra.y + (rb.y - ra.y) * 0.5);
            axleAngle = Math.atan2(rb.y - ra.y, rb.x - ra.x);

            this._axles.rear.right.x = axle.x;
            this._axles.rear.right.y = axle.y;
            this._axles.rear.right.rotation = axleAngle;
        }

        /**
         */

    }, {
        key: "startEngine",
        value: function startEngine() {
            this.stopEngine();

            TweenMax.to(this._front.offset, 0.05, {
                y: this._front.offset.y - 5.0,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._back.offset, 0.05, {
                y: this._back.offset.y - 7.0,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._front.scale, 0.04, {
                y: this._front.scale.y - 0.04,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._back.scale, 0.04, {
                delay: 0.02,
                y: this._back.scale.y - 0.02,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._wheels.front.left.offset, 0.04, {
                y: this._wheels.front.left.offset.y - 4.0,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._wheels.front.right.offset, 0.04, {
                y: this._wheels.front.right.offset.y - 4.0,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._wheels.rear.left.offset, 0.03, {
                y: this._wheels.rear.left.offset.y - 6.0,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._wheels.rear.right.offset, 0.03, {
                y: this._wheels.rear.right.offset.y - 6.0,
                yoyo: true,
                repeat: -1
            });
        }

        /**
         */

    }, {
        key: "stopEngine",
        value: function stopEngine() {
            TweenMax.killTweensOf(this._front.offset);
            TweenMax.killTweensOf(this._back.offset);
            TweenMax.killTweensOf(this._front.scale);
            TweenMax.killTweensOf(this._back.scale);
            TweenMax.killTweensOf(this._wheels.front.left.offset);
            TweenMax.killTweensOf(this._wheels.front.right.offset);
            TweenMax.killTweensOf(this._wheels.rear.left.offset);
            TweenMax.killTweensOf(this._wheels.rear.right.offset);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createFrontLayer",
        value: function createFrontLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("grusome_front_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createBackLayer",
        value: function createBackLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("grusome_rear_00"));
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createFrontWheel",
        value: function createFrontWheel() {
            var assets = _Common2.default.assets;
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("grusome_front_wheel_spin_00"), assets.getTexture("grusome_front_wheel_spin_01")]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createRearWheel",
        value: function createRearWheel() {
            var assets = _Common2.default.assets;
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("grusome_rear_wheel_spin_00"), assets.getTexture("grusome_rear_wheel_spin_01")]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createShadow",
        value: function createShadow() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("grusome_shadow_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createFrontAxle",
        value: function createFrontAxle() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("grusome_front_axle_bottom_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createRearAxle",
        value: function createRearAxle() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("grusome_rear_axle_bottom_00"));
        }
    }]);

    return DoomBuggyView;
}(_RaceCarView3.default);

exports.default = DoomBuggyView;

},{"../Common":7,"../race/RaceCarView":54}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceCarView2 = require("../race/RaceCarView");

var _RaceCarView3 = _interopRequireDefault(_RaceCarView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  IQView
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 03/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceCarView
 * @memberOf race
 */
var IQView = function (_RaceCarView) {
    _inherits(IQView, _RaceCarView);

    function IQView() {
        _classCallCheck(this, IQView);

        var _this = _possibleConstructorReturn(this, (IQView.__proto__ || Object.getPrototypeOf(IQView)).call(this));

        _this._wheels.front.left.offset = new PIXI.Point(-120, 30);
        _this._wheels.front.right.offset = new PIXI.Point(120, 30);

        _this._wheels.rear.left.offset = new PIXI.Point(-140, 58);
        _this._wheels.rear.right.offset = new PIXI.Point(140, 58);
        return _this;
    }

    _createClass(IQView, [{
        key: "init",
        value: function init() {}
    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {}

        /**
         * @param {number} dt
         * @param {number} distance
         * @param {number} curvature
         * @param {number} gradient
         * @param {number} velocity
         * @param {number} turnVelocity
         * @param {number} jumpOffset
         */

    }, {
        key: "update",
        value: function update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
            _get(IQView.prototype.__proto__ || Object.getPrototypeOf(IQView.prototype), "update", this).call(this, dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset);

            var scalar = 140;

            this._curvature += (turnVelocity + curvature - this._curvature) * 0.4;
            this._curvature = Math.max(-scalar, Math.min(scalar, this._curvature));

            this._front.x = this._curvature * 0.3 + this._front.offset.x;
            this._front.y = -gradient * scalar * 1.6 + this._front.offset.y - jumpOffset * 136;

            this._back.x = -this._curvature * 0.1 + this._back.offset.x;
            this._back.y = gradient * scalar + this._back.offset.y - jumpOffset * 118;

            this._front.rotation = this._curvature * 0.0012;
            this._back.rotation = this._curvature * 0.0012;
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createFrontLayer",
        value: function createFrontLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("iq_front_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createBackLayer",
        value: function createBackLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("iq_rear_00"));
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createFrontWheel",
        value: function createFrontWheel() {
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([PIXI.Texture.EMPTY]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createRearWheel",
        value: function createRearWheel() {
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([PIXI.Texture.EMPTY]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createShadow",
        value: function createShadow() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("iq_shadow_00"));
        }
    }]);

    return IQView;
}(_RaceCarView3.default);

exports.default = IQView;

},{"../Common":7,"../race/RaceCarView":54}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceCarView2 = require("../race/RaceCarView");

var _RaceCarView3 = _interopRequireDefault(_RaceCarView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  MeanMachineView
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceCarView
 * @memberOf race
 */
var MeanMachineView = function (_RaceCarView) {
    _inherits(MeanMachineView, _RaceCarView);

    function MeanMachineView() {
        _classCallCheck(this, MeanMachineView);

        var _this = _possibleConstructorReturn(this, (MeanMachineView.__proto__ || Object.getPrototypeOf(MeanMachineView)).call(this));

        _this._shadow.y = 152;

        _this._front.offset.y = -50;
        _this._back.offset.y = -50;

        _this._wheels.front.left.offset = new PIXI.Point(-200, 66);
        _this._wheels.front.right.offset = new PIXI.Point(200, 66);

        _this._wheels.rear.left.offset = new PIXI.Point(-190, 92);
        _this._wheels.rear.right.offset = new PIXI.Point(190, 92);
        return _this;
    }

    _createClass(MeanMachineView, [{
        key: "init",
        value: function init() {}
    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {}

        /**
         * @param {number} dt
         * @param {number} distance
         * @param {number} curvature
         * @param {number} gradient
         * @param {number} velocity
         * @param {number} turnVelocity
         * @param {number} jumpOffset
         */

    }, {
        key: "update",
        value: function update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
            _get(MeanMachineView.prototype.__proto__ || Object.getPrototypeOf(MeanMachineView.prototype), "update", this).call(this, dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset);

            var scalar = 140;

            this._curvature += (turnVelocity + curvature - this._curvature) * 0.4;
            this._curvature = Math.max(-scalar, Math.min(scalar, this._curvature));

            this._front.x = this._curvature * 0.3 + this._front.offset.x;
            this._front.y = -gradient * scalar * 1.6 + this._front.offset.y - jumpOffset * 128;

            this._back.x = -this._curvature * 0.1 + this._back.offset.x;
            this._back.y = gradient * scalar + this._back.offset.y - jumpOffset * 118;

            this._front.rotation = this._curvature * 0.0012;
            this._back.rotation = this._curvature * 0.0012;

            this._wheels.front.left.x = this._front.x + this._wheels.front.left.offset.x;
            this._wheels.front.left.y = gradient * scalar + this._wheels.front.left.offset.y - jumpOffset * 104;

            this._wheels.front.right.x = this._front.x + this._wheels.front.right.offset.x;
            this._wheels.front.right.y = gradient * scalar + this._wheels.front.right.offset.y - jumpOffset * 104;

            this._wheels.rear.left.x = this._back.x + this._wheels.rear.left.offset.x;
            this._wheels.rear.left.y = gradient * scalar + this._wheels.rear.left.offset.y - jumpOffset * 92;

            this._wheels.rear.right.x = this._back.x + this._wheels.rear.right.offset.x;
            this._wheels.rear.right.y = gradient * scalar + this._wheels.rear.right.offset.y - jumpOffset * 92;

            velocity = Math.max(0, velocity) / 0.2;
            this._wheels.front.left.animationSpeed = velocity;
            this._wheels.front.right.animationSpeed = velocity;
            this._wheels.rear.left.animationSpeed = velocity;
            this._wheels.rear.right.animationSpeed = velocity;
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createFrontLayer",
        value: function createFrontLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("dastardly_front_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createBackLayer",
        value: function createBackLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("dastardly_rear_00"));
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createFrontWheel",
        value: function createFrontWheel() {
            var assets = _Common2.default.assets;
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("dastardly_front_wheel_00")]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createRearWheel",
        value: function createRearWheel() {
            var assets = _Common2.default.assets;
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("dastardly_rear_wheel_00")]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createShadow",
        value: function createShadow() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("dastardly_shadow_00"));
        }
    }]);

    return MeanMachineView;
}(_RaceCarView3.default);

exports.default = MeanMachineView;

},{"../Common":7,"../race/RaceCarView":54}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceCarView2 = require("../race/RaceCarView");

var _RaceCarView3 = _interopRequireDefault(_RaceCarView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  PussycatView
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceCarView
 * @memberOf race
 */
var PussycatView = function (_RaceCarView) {
    _inherits(PussycatView, _RaceCarView);

    function PussycatView() {
        _classCallCheck(this, PussycatView);

        var _this = _possibleConstructorReturn(this, (PussycatView.__proto__ || Object.getPrototypeOf(PussycatView)).call(this));

        _this._shadow.y = 114;

        _this._wheels.front.left.offset = new PIXI.Point(-120, 30);
        _this._wheels.front.right.offset = new PIXI.Point(120, 30);

        _this._wheels.rear.left.offset = new PIXI.Point(-140, 58);
        _this._wheels.rear.right.offset = new PIXI.Point(140, 58);
        return _this;
    }

    _createClass(PussycatView, [{
        key: "init",
        value: function init() {}
    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {}

        /**
         * @param {number} dt
         * @param {number} distance
         * @param {number} curvature
         * @param {number} gradient
         * @param {number} velocity
         * @param {number} turnVelocity
         * @param {number} jumpOffset
         */

    }, {
        key: "update",
        value: function update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
            _get(PussycatView.prototype.__proto__ || Object.getPrototypeOf(PussycatView.prototype), "update", this).call(this, dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset);

            var scalar = 140;

            this._curvature += (turnVelocity + curvature - this._curvature) * 0.4;
            this._curvature = Math.max(-scalar, Math.min(scalar, this._curvature));

            this._front.x = this._curvature * 0.3 + this._front.offset.x;
            this._front.y = -gradient * scalar * 1.6 + this._front.offset.y - jumpOffset * 136;

            this._back.x = -this._curvature * 0.1 + this._back.offset.x;
            this._back.y = gradient * scalar + this._back.offset.y - jumpOffset * 118;

            this._front.rotation = this._curvature * 0.0012;
            this._back.rotation = this._curvature * 0.0012;

            this._wheels.front.left.x = this._front.x + this._wheels.front.left.offset.x;
            this._wheels.front.left.y = gradient * scalar + this._wheels.front.left.offset.y - jumpOffset * 86;

            this._wheels.front.right.x = this._front.x + this._wheels.front.right.offset.x;
            this._wheels.front.right.y = gradient * scalar + this._wheels.front.right.offset.y - jumpOffset * 86;

            this._wheels.rear.left.x = this._back.x + this._wheels.rear.left.offset.x;
            this._wheels.rear.left.y = gradient * scalar + this._wheels.rear.left.offset.y - jumpOffset * 72;

            this._wheels.rear.right.x = this._back.x + this._wheels.rear.right.offset.x;
            this._wheels.rear.right.y = gradient * scalar + this._wheels.rear.right.offset.y - jumpOffset * 72;

            velocity = Math.max(0, velocity) / 0.2;
            this._wheels.front.left.animationSpeed = velocity;
            this._wheels.front.right.animationSpeed = velocity;
            this._wheels.rear.left.animationSpeed = velocity;
            this._wheels.rear.right.animationSpeed = velocity;
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createFrontLayer",
        value: function createFrontLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("pussycat_front_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createBackLayer",
        value: function createBackLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("pussycat_rear_00"));
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createFrontWheel",
        value: function createFrontWheel() {
            var assets = _Common2.default.assets;
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("pussycat_front_wheel_spin_00"), assets.getTexture("pussycat_front_wheel_spin_01")]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createRearWheel",
        value: function createRearWheel() {
            var assets = _Common2.default.assets;
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("pussycat_rear_wheel_spin_00"), assets.getTexture("pussycat_rear_wheel_spin_01")]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createShadow",
        value: function createShadow() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("pussycat_shadow_00"));
        }
    }]);

    return PussycatView;
}(_RaceCarView3.default);

exports.default = PussycatView;

},{"../Common":7,"../race/RaceCarView":54}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceCarView2 = require("../race/RaceCarView");

var _RaceCarView3 = _interopRequireDefault(_RaceCarView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TurboView
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceCarView
 * @memberOf race
 */
var TurboView = function (_RaceCarView) {
    _inherits(TurboView, _RaceCarView);

    function TurboView() {
        _classCallCheck(this, TurboView);

        var _this = _possibleConstructorReturn(this, (TurboView.__proto__ || Object.getPrototypeOf(TurboView)).call(this));

        _this._shadow.y = 126;

        _this._front.offset.y = -58;
        _this._back.offset.y = -20;

        _this._wheels.front.left.offset = new PIXI.Point(-148, 28);
        _this._wheels.front.right.offset = new PIXI.Point(148, 28);

        _this._wheels.rear.left.offset = new PIXI.Point(-190, 24);
        _this._wheels.rear.right.offset = new PIXI.Point(190, 24);

        /**
         * @type {Object}
         * @private
         */
        _this._axles = {};

        /**
         * @type {Object}
         */
        _this._axles.top = {};

        /**
         * @type {Object}
         */
        _this._axles.bottom = {};

        /**
         * @type {Sprite}
         */
        _this._axles.top.left = _this.createTopAxel();
        _this._axles.top.left.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._axles.top.left);

        /**
         * @type {Sprite}
         */
        _this._axles.top.right = _this.createTopAxel();
        _this._axles.top.right.anchor = new PIXI.Point(0.5, 0.5);
        _this._axles.top.right.scale.x = -1;
        _this.addChild(_this._axles.top.right);

        /**
         * @type {Sprite}
         */
        _this._axles.bottom.left = _this.createBottomAxel();
        _this._axles.bottom.left.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._axles.bottom.left);

        /**
         * @type {Sprite}
         */
        _this._axles.bottom.right = _this.createBottomAxel();
        _this._axles.bottom.right.anchor = new PIXI.Point(0.5, 0.5);
        _this._axles.bottom.right.scale.x = -1;
        _this.addChild(_this._axles.bottom.right);
        return _this;
    }

    _createClass(TurboView, [{
        key: "init",
        value: function init() {}
    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {}

        /**
         * @param {number} dt
         * @param {number} distance
         * @param {number} curvature
         * @param {number} gradient
         * @param {number} velocity
         * @param {number} turnVelocity
         * @param {number} jumpOffset
         */

    }, {
        key: "update",
        value: function update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
            _get(TurboView.prototype.__proto__ || Object.getPrototypeOf(TurboView.prototype), "update", this).call(this, dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset);

            var scalar = 140;

            this._curvature += (turnVelocity + curvature - this._curvature) * 0.4;
            this._curvature = Math.max(-scalar, Math.min(scalar, this._curvature));

            this._front.x = this._curvature * 0.3 + this._front.offset.x;
            this._front.y = -gradient * scalar * 1.6 + this._front.offset.y - jumpOffset * 136;

            this._back.x = -this._curvature * 0.1 + this._back.offset.x;
            this._back.y = gradient * scalar + this._back.offset.y - jumpOffset * 118;
            this._back.rotation = this._curvature * 0.0016;

            this._wheels.front.left.x = this._front.x + this._wheels.front.left.offset.x;
            this._wheels.front.left.y = gradient * scalar + this._wheels.front.left.offset.y - jumpOffset * 136;

            this._wheels.front.right.x = this._front.x + this._wheels.front.right.offset.x;
            this._wheels.front.right.y = gradient * scalar + this._wheels.front.right.offset.y - jumpOffset * 136;

            this._wheels.rear.left.x = this._back.x + this._wheels.rear.left.offset.x;
            this._wheels.rear.left.y = gradient * scalar + this._wheels.rear.left.offset.y - jumpOffset * 72;

            this._wheels.rear.right.x = this._back.x + this._wheels.rear.right.offset.x;
            this._wheels.rear.right.y = gradient * scalar + this._wheels.rear.right.offset.y - jumpOffset * 72;

            velocity = Math.max(0, velocity) / 0.2;
            this._wheels.front.left.animationSpeed = velocity;
            this._wheels.front.right.animationSpeed = velocity;
            this._wheels.rear.left.animationSpeed = velocity;
            this._wheels.rear.right.animationSpeed = velocity;

            this.updateAxles();
        }
    }, {
        key: "updateAxles",
        value: function updateAxles() {
            // top axles
            var center = new PIXI.Point(this._back.x, this._back.y);
            var angle = this._back.rotation;
            var offset = new PIXI.Point(68, 70);
            var la = new PIXI.Point(center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x));
            var ra = new PIXI.Point(center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x));

            center = new PIXI.Point(this._wheels.rear.left.x, this._wheels.rear.left.y);
            angle = this._wheels.rear.left.rotation;
            offset = new PIXI.Point(56, 0);
            var lb = new PIXI.Point(center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x));

            center = new PIXI.Point(this._wheels.rear.right.x, this._wheels.rear.right.y);
            angle = this._wheels.rear.right.rotation;
            var rb = new PIXI.Point(center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x));

            var axle = new PIXI.Point(la.x + (lb.x - la.x) * 0.5, la.y + (lb.y - la.y) * 0.5);
            var axleAngle = Math.atan2(la.y - lb.y, la.x - lb.x);

            this._axles.top.left.x = axle.x;
            this._axles.top.left.y = axle.y;
            this._axles.top.left.rotation = axleAngle;

            axle = new PIXI.Point(ra.x + (rb.x - ra.x) * 0.5, ra.y + (rb.y - ra.y) * 0.5);
            axleAngle = Math.atan2(rb.y - ra.y, rb.x - ra.x);

            this._axles.top.right.x = axle.x;
            this._axles.top.right.y = axle.y;
            this._axles.top.right.rotation = axleAngle;

            // bottom axles
            center = new PIXI.Point(this._back.x, this._back.y);
            angle = this._back.rotation;
            offset = new PIXI.Point(54, 120);
            la = new PIXI.Point(center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x));
            ra = new PIXI.Point(center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x));

            center = new PIXI.Point(this._wheels.rear.left.x, this._wheels.rear.left.y);
            angle = this._wheels.rear.left.rotation;
            offset = new PIXI.Point(54, 34);
            lb = new PIXI.Point(center.x + (Math.cos(angle) * offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * offset.x));

            center = new PIXI.Point(this._wheels.rear.right.x, this._wheels.rear.right.y);
            angle = this._wheels.rear.right.rotation;
            rb = new PIXI.Point(center.x + (Math.cos(angle) * -offset.x - Math.sin(angle) * offset.y), center.y + (Math.cos(angle) * offset.y + Math.sin(angle) * -offset.x));

            axle = new PIXI.Point(la.x + (lb.x - la.x) * 0.5, la.y + (lb.y - la.y) * 0.5);
            axleAngle = Math.atan2(la.y - lb.y, la.x - lb.x);

            this._axles.bottom.left.x = axle.x;
            this._axles.bottom.left.y = axle.y;
            this._axles.bottom.left.rotation = axleAngle;

            axle = new PIXI.Point(ra.x + (rb.x - ra.x) * 0.5, ra.y + (rb.y - ra.y) * 0.5);
            axleAngle = Math.atan2(rb.y - ra.y, rb.x - ra.x);

            this._axles.bottom.right.x = axle.x;
            this._axles.bottom.right.y = axle.y;
            this._axles.bottom.right.rotation = axleAngle;
        }

        /**
         */

    }, {
        key: "startEngine",
        value: function startEngine() {
            this.stopEngine();

            TweenMax.to(this._front.scale, 0.04, {
                y: this._front.scale.y - 0.04,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._back.offset, 0.044, {
                y: this._back.offset.y - 8.0,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._back.scale, 0.04, {
                delay: 0.02,
                y: this._back.scale.y - 0.02,
                yoyo: true,
                repeat: -1
            });
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createFrontLayer",
        value: function createFrontLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("turbo_front_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createBackLayer",
        value: function createBackLayer() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("turbo_rear_00"));
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createFrontWheel",
        value: function createFrontWheel() {
            var assets = _Common2.default.assets;
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("turbo_front_wheel_spin_00"), assets.getTexture("turbo_front_wheel_spin_01")]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createRearWheel",
        value: function createRearWheel() {
            var assets = _Common2.default.assets;
            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("turbo_rear_wheel_spin_00"), assets.getTexture("turbo_rear_wheel_spin_01")]);
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createShadow",
        value: function createShadow() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("turbo_shadow_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createTopAxel",
        value: function createTopAxel() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("turbo_rear_axle_top_00"));
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createBottomAxel",
        value: function createBottomAxel() {
            var assets = _Common2.default.assets;
            return new PIXI.Sprite(assets.getTexture("turbo_rear_axle_bottom_00"));
        }
    }]);

    return TurboView;
}(_RaceCarView3.default);

exports.default = TurboView;

},{"../Common":7,"../race/RaceCarView":54}],23:[function(require,module,exports){
(function (global){
'use strict';

var _Main = require('./Main');

var _Main2 = _interopRequireDefault(_Main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

global.Main = _Main2.default;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./Main":10}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  AOE
 *
 *  Created by Legman on 25/04/2017.
 *
 */

/**
 * @class
 * @extends PIXI.Container
 */
var AOE = function (_PIXI$Container) {
  _inherits(AOE, _PIXI$Container);

  /**
   * @param owner
   */
  function AOE(owner) {
    _classCallCheck(this, AOE);

    /**
     * @member {number}
     */
    var _this = _possibleConstructorReturn(this, (AOE.__proto__ || Object.getPrototypeOf(AOE)).call(this));

    _this.duration = 8;

    /**
     * @member {number}
     */
    _this.range = 4;

    /**
     * @member {number}
     */
    _this.slow = 0.998;

    /**
     * @member {number}
     */
    _this.swerve = 0.64;

    /**
     * @member {RaceEntity}
     * @private
     */
    _this._owner = owner;

    /**
     * @type {PIXI.Sprite}
     * @private
     */
    _this._view = null;
    return _this;
  }

  /**
   */


  _createClass(AOE, [{
    key: "init",
    value: function init() {
      this._view = new PIXI.Graphics();
      this._view.beginFill(0x0000FF, 0.2);
      this._view.drawCircle(0, 0, 340);
      this._view.endFill();
      this.addChild(this._view);

      TweenMax.to(this.scale, 0.6, {
        x: 0.8,
        y: 0.8,
        ease: Power1.easeInOut,
        yoyo: true,
        repeat: -1
      });
    }

    /**
     * @param {number} dt
     */

  }, {
    key: "update",
    value: function update(dt) {
      // override
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _get(AOE.prototype.__proto__ || Object.getPrototypeOf(AOE.prototype), "destroy", this).call(this, { removeChildren: true });
    }

    /**
     * @returns {RaceEntity}
     */

  }, {
    key: "owner",
    get: function get() {
      return this._owner;
    }
  }]);

  return AOE;
}(PIXI.Container);

exports.default = AOE;

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AOE = require("./AOE");

var _AOE2 = _interopRequireDefault(_AOE);

var _Powerup2 = require("./Powerup");

var _Powerup3 = _interopRequireDefault(_Powerup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  AOEPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 25/04/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var AOEPowerup = function (_Powerup) {
    _inherits(AOEPowerup, _Powerup);

    /**
     * @param collector
     */
    function AOEPowerup(collector) {
        _classCallCheck(this, AOEPowerup);

        /**
         * @type {AOE}
         * @protected
         */
        var _this = _possibleConstructorReturn(this, (AOEPowerup.__proto__ || Object.getPrototypeOf(AOEPowerup)).call(this, collector));

        _this._aoe = null;
        return _this;
    }

    /**
     * @param {number} dt
     */


    _createClass(AOEPowerup, [{
        key: "update",
        value: function update(dt) {
            _get(AOEPowerup.prototype.__proto__ || Object.getPrototypeOf(AOEPowerup.prototype), "update", this).call(this, dt);

            if (this._aoe) {
                this._aoe.update(dt);
                if (!this._aoe.parent) {
                    this.destroyNextFrame = true;
                }
            }
        }

        /**
         * @returns {AOE}
         */

    }, {
        key: "aoe",
        get: function get() {
            return this._aoe;
        }
    }]);

    return AOEPowerup;
}(_Powerup3.default);

exports.default = AOEPowerup;

},{"./AOE":24,"./Powerup":44}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceMover2 = require("../race/RaceMover");

var _RaceMover3 = _interopRequireDefault(_RaceMover2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Bomb
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 20/04/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceMover
 */
var Bomb = function (_RaceMover) {
    _inherits(Bomb, _RaceMover);

    /**
     * @param {RaceCar} owner
     */
    function Bomb(owner) {
        _classCallCheck(this, Bomb);

        var temp = new PIXI.Sprite(_Common2.default.assets.getTexture("game_powerup_bomb"));
        temp.anchor = new PIXI.Point(0.5, 0.5);

        var _this = _possibleConstructorReturn(this, (Bomb.__proto__ || Object.getPrototypeOf(Bomb)).call(this, temp));

        _this.collisionWidth = 60;
        _this.collisionLength = 34;

        /**
         * @member {number}
         */
        _this.armDelay = 1;

        /**
         * @member {RaceCar}
         * @protected
         */
        _this._owner = owner;

        /**
         * @member {PIXI.particles.Emitter}
         * @protected
         */
        _this._emitter = null;

        /**
         * @member {boolean}
         * @private
         */
        _this._isEmitterFinished = false;

        /**
         * @member {boolean}
         * @private
         */
        _this._armed = false;

        /**
         * @member {boolean}
         * @private
         */
        _this._arming = false;

        /**
         * @member {number}
         * @private
         */
        _this._armBlinkFrame = 0;

        /**
         * @member {number}
         * @private
         */
        _this._armBlinkRate = 8;
        return _this;
    }

    _createClass(Bomb, [{
        key: "init",
        value: function init() {
            this._startDist = this.distance;
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            this._emitter && this._emitter.update(dt);
            if (this._emitter && !this._emitter.emit) {
                if (!this._isEmitterFinished) {
                    this._isEmitterFinished = true;

                    // delay the destroy by one frame so the particles can fade
                    delay(function () {
                        this.destroyNextFrame = true;
                    }, 1, this);
                }
            }

            if (this._arming) {
                if (++this._armBlinkFrame % this._armBlinkRate === 0) {
                    this.alpha = !this.alpha ? 1 : 0;
                }
            }
        }
    }, {
        key: "arm",
        value: function arm() {
            delay(function () {
                this._armed = true;
                this._arming = false;
                this.alpha = 1;
            }, this.armDelay, this);
            this._arming = true;
        }
    }, {
        key: "explode",
        value: function explode() {
            this._armed = false;
            this._view.texture = PIXI.Texture.EMPTY;

            this._createEmitter();
            this._emitter.playOnceAndDestroy();

            this._view.visible && this._playSound();
        }
    }, {
        key: "_createEmitter",
        value: function _createEmitter() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_explosion_00");

            var holder = new PIXI.Container();
            holder.scale = new PIXI.Point(2, 2);
            this._view.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_explosion_smoke_00"), assets.getTexture("particle_explosion_smoke_01"), assets.getTexture("particle_explosion_smoke_02")], config);
            this._emitter.emit = false;
        }
    }, {
        key: "_playSound",
        value: function _playSound() {
            _Common2.default.audio.playSound(["sfx_bomb_explode_big_00", "sfx_bomb_explode_big_01"]);
        }

        /**
         * @returns {RaceCar}
         */

    }, {
        key: "owner",
        get: function get() {
            return this._owner;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "armed",
        get: function get() {
            return this._armed;
        }
    }]);

    return Bomb;
}(_RaceMover3.default);

exports.default = Bomb;

},{"../Common":7,"../race/RaceMover":58}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Bomb = require("./Bomb");

var _Bomb2 = _interopRequireDefault(_Bomb);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Powerup2 = require("./Powerup");

var _Powerup3 = _interopRequireDefault(_Powerup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  BombPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 02/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var BombPowerup = function (_Powerup) {
    _inherits(BombPowerup, _Powerup);

    /**
     * @param {RaceCar} collector
     */
    function BombPowerup(collector) {
        _classCallCheck(this, BombPowerup);

        /**
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, (BombPowerup.__proto__ || Object.getPrototypeOf(BombPowerup)).call(this, collector));

        _this.launchDistance = 11;

        /**
         * @member {number}
         */
        _this.launchHeight = 300;

        /**
         * @member {number}
         */
        _this.launchDuration = 0.6;
        return _this;
    }

    /**
     * @param {number} dt
     */


    _createClass(BombPowerup, [{
        key: "update",
        value: function update(dt) {
            _get(BombPowerup.prototype.__proto__ || Object.getPrototypeOf(BombPowerup.prototype), "update", this).call(this, dt);
            if (this._bomb && this._bomb.destroyNextFrame) {
                this.destroyNextFrame = true;
            }
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "activate",
        value: function activate() {
            var activated = _get(BombPowerup.prototype.__proto__ || Object.getPrototypeOf(BombPowerup.prototype), "activate", this).call(this);
            if (activated) {
                this._bomb = this._createBomb();
                this._bomb.powerupType = this.type;
                this._bomb.offset.x = this._collector.offset.x;
                this._bomb.offset.y = -120;
                this._bomb.moving = true;
                this._bomb.lap = this._collector.lap;
                this._bomb.zDepthOffset = 1;
                this._collector.engine.addEntity(this._bomb, this._collector.distance + 1, false);

                delay(function () {
                    this._collector.usingPowerup = false;
                }, 1, this);

                var tl = new TimelineMax({
                    onComplete: function onComplete() {
                        this._bomb.arm();
                    },
                    onCompleteScope: this
                });

                tl.insert(TweenMax.to(this._bomb, this.launchDuration, {
                    distance: this._bomb.distance + Math.max(0, this.launchDistance),
                    ease: Power1.easeOut
                }));
                tl.insert(TweenMax.to(this._bomb.offset, this.launchDuration * 0.5, {
                    y: this._bomb.offset.y - Math.max(0, this.launchHeight),
                    ease: Power1.easeOut,
                    yoyo: true,
                    repeat: 1
                }));

                this._playSound();
            }
            return activated;
        }

        /**
         * @returns {Bomb}
         * @protected
         */

    }, {
        key: "_createBomb",
        value: function _createBomb() {
            return new _Bomb2.default(this._collector);
        }
    }, {
        key: "_playSound",
        value: function _playSound() {
            _Common2.default.audio.playSound(["sfx_launch_object_00", "sfx_launch_object_01", "sfx_launch_object_02", "sfx_launch_object_03", "sfx_launch_object_04", "sfx_launch_object_05"]);
        }

        /**
         * @returns {Bomb}
         */

    }, {
        key: "bomb",
        get: function get() {
            return this._bomb;
        }
    }]);

    return BombPowerup;
}(_Powerup3.default);

exports.default = BombPowerup;

},{"../Common":7,"./Bomb":26,"./Powerup":44}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  Boost
 *
 *  Created by Legman on 07/06/2017.
 *
 */

/**
 * @class
 * @extends PIXI.Container
 */
var Boost = function (_PIXI$Container) {
    _inherits(Boost, _PIXI$Container);

    /**
     * @param owner
     */
    function Boost(owner) {
        _classCallCheck(this, Boost);

        /**
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, (Boost.__proto__ || Object.getPrototypeOf(Boost)).call(this));

        _this.duration = 1;

        /**
         * @member {number}
         */
        _this.multiplier = 1.6;

        /**
         * @param {RaceCar}
         */
        _this._owner = owner;

        /**
         * @type {number}
         * @private
         */
        _this._timeout = 0;

        /**
         * @type {boolean}
         * @private
         */
        _this._active = false;
        return _this;
    }

    _createClass(Boost, [{
        key: "init",
        value: function init() {
            this._startBoost();
        }

        /**
         * @param options
         */

    }, {
        key: "destroy",
        value: function destroy(options) {
            _get(Boost.prototype.__proto__ || Object.getPrototypeOf(Boost.prototype), "destroy", this).call(this, options);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            if (this._active) {
                if (this._timeout <= 0) {
                    this._stopBoost();
                } else this._timeout -= dt;
            }
        }

        /**
         * @protected
         */

    }, {
        key: "_startBoost",
        value: function _startBoost() {
            this._owner.startBoost(this.multiplier);
            this._timeout = this.duration;
            this._active = true;
        }

        /**
         * @protected
         */

    }, {
        key: "_stopBoost",
        value: function _stopBoost() {
            this._owner.stopBoost();
            this._owner.usingPowerup = false;
            this._active = false;
        }

        /**
         * @returns {RaceEntity}
         */

    }, {
        key: "owner",
        get: function get() {
            return this._owner;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "active",
        get: function get() {
            return this._active;
        }
    }]);

    return Boost;
}(PIXI.Container);

exports.default = Boost;

},{}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Boost = require("./Boost");

var _Boost2 = _interopRequireDefault(_Boost);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Powerup2 = require("./Powerup");

var _Powerup3 = _interopRequireDefault(_Powerup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  BoostPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 20/04/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var BoostPowerup = function (_Powerup) {
    _inherits(BoostPowerup, _Powerup);

    /**
     * @param collector
     */
    function BoostPowerup(collector) {
        _classCallCheck(this, BoostPowerup);

        return _possibleConstructorReturn(this, (BoostPowerup.__proto__ || Object.getPrototypeOf(BoostPowerup)).call(this, collector));
    }

    /**
     * @param {number} dt
     */


    _createClass(BoostPowerup, [{
        key: "update",
        value: function update(dt) {
            _get(BoostPowerup.prototype.__proto__ || Object.getPrototypeOf(BoostPowerup.prototype), "update", this).call(this, dt);

            if (this._boost) {
                this._boost.update(dt);
                if (!this._boost.parent) {
                    this.destroyNextFrame = true;
                }
            }
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "activate",
        value: function activate() {
            var activated = _get(BoostPowerup.prototype.__proto__ || Object.getPrototypeOf(BoostPowerup.prototype), "activate", this).call(this);
            if (activated) {
                this._boost = this._createBoost();
                this._boost.powerupType = this.type;
                this._boost.init();
                this._collector.view.addChild(this._boost);

                this._collector.view.visible && _Common2.default.audio.playSound("sfx_powerup_speedup_tyre_screech_00");
            }
            return activated;
        }

        /**
         * @returns {Boost}
         * @protected
         */

    }, {
        key: "_createBoost",
        value: function _createBoost() {
            return new _Boost2.default(this._collector);
        }

        /**
         * @returns {Boost}
         */

    }, {
        key: "boost",
        get: function get() {
            return this._boost;
        }
    }]);

    return BoostPowerup;
}(_Powerup3.default);

exports.default = BoostPowerup;

},{"../Common":7,"./Boost":28,"./Powerup":44}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AOE2 = require("./AOE");

var _AOE3 = _interopRequireDefault(_AOE2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Bubbles
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 30/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Bubbles = function (_AOE) {
    _inherits(Bubbles, _AOE);

    /**
     * @param {RaceCar} owner
     */
    function Bubbles(owner) {
        _classCallCheck(this, Bubbles);

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (Bubbles.__proto__ || Object.getPrototypeOf(Bubbles)).call(this, owner));

        _this._emitter = null;
        return _this;
    }

    _createClass(Bubbles, [{
        key: "init",
        value: function init() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_powerup_bubbles2");

            var holder = new PIXI.Container();
            holder.y = 100;
            this.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particles_powerup_bubble_00"), assets.getTexture("particles_powerup_bubble_01")], config);
        }
    }, {
        key: "destroy",
        value: function destroy(options) {
            this._emitter.destroy();
            _get(Bubbles.prototype.__proto__ || Object.getPrototypeOf(Bubbles.prototype), "destroy", this).call(this, options);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            _get(Bubbles.prototype.__proto__ || Object.getPrototypeOf(Bubbles.prototype), "update", this).call(this, dt);
            this._emitter.update(dt);
        }
    }, {
        key: "start",
        value: function start() {
            this._emitter.emit = true;
        }
    }, {
        key: "stop",
        value: function stop() {
            this._emitter.emit = false;
        }
    }]);

    return Bubbles;
}(_AOE3.default);

exports.default = Bubbles;

},{"../Common":7,"./AOE":24}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AOEPowerup2 = require("./AOEPowerup");

var _AOEPowerup3 = _interopRequireDefault(_AOEPowerup2);

var _AudioParams = require("../AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

var _Bubbles = require("./Bubbles");

var _Bubbles2 = _interopRequireDefault(_Bubbles);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  BubblesPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 31/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var BubblesPowerup = function (_AOEPowerup) {
    _inherits(BubblesPowerup, _AOEPowerup);

    /**
     * @param collector
     */
    function BubblesPowerup(collector) {
        _classCallCheck(this, BubblesPowerup);

        /**
         * @type {Audio}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (BubblesPowerup.__proto__ || Object.getPrototypeOf(BubblesPowerup)).call(this, collector));

        _this._loopSFX = null;
        return _this;
    }

    _createClass(BubblesPowerup, [{
        key: "destroy",
        value: function destroy() {
            this._stopLoopSFX();

            _get(BubblesPowerup.prototype.__proto__ || Object.getPrototypeOf(BubblesPowerup.prototype), "destroy", this).call(this);
        }
    }, {
        key: "activate",
        value: function activate() {
            var activated = _get(BubblesPowerup.prototype.__proto__ || Object.getPrototypeOf(BubblesPowerup.prototype), "activate", this).call(this);
            if (activated) {
                this._aoe = new _Bubbles2.default(this._collector);
                this._aoe.powerupType = this.type;
                this._aoe.init();
                this._collector.view.addChild(this._aoe);

                this._aoe.start();

                delay(function () {
                    this._collector.usingPowerup = false;
                    this._aoe.stop();

                    // gives time for particles to fade
                    delay(function () {
                        this._aoe.parent.removeChild(this._aoe);
                        this._aoe.destroy();

                        this._stopLoopSFX();
                    }, 1, this);
                }, this._aoe.duration, this);

                this._collector.view.visible && this._playLoopSFX();
            }
            return activated;
        }
    }, {
        key: "pause",
        value: function pause() {
            _get(BubblesPowerup.prototype.__proto__ || Object.getPrototypeOf(BubblesPowerup.prototype), "pause", this).call(this);
            this._stopLoopSFX();
        }
    }, {
        key: "resume",
        value: function resume() {
            _get(BubblesPowerup.prototype.__proto__ || Object.getPrototypeOf(BubblesPowerup.prototype), "resume", this).call(this);
            this._playLoopSFX();
        }

        /**
         * @private
         */

    }, {
        key: "_playLoopSFX",
        value: function _playLoopSFX() {
            this._stopLoopSFX();

            var params = new _AudioParams2.default();
            params.loop = true;
            this._loopSFX = _Common2.default.audio.playSound("sfx_powerup_bubbles_00", params);
        }

        /**
         * @private
         */

    }, {
        key: "_stopLoopSFX",
        value: function _stopLoopSFX() {
            this._loopSFX && this._loopSFX.stop();
        }
    }]);

    return BubblesPowerup;
}(_AOEPowerup3.default);

exports.default = BubblesPowerup;

},{"../AudioParams":6,"../Common":7,"./AOEPowerup":25,"./Bubbles":30}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AOE2 = require("./AOE");

var _AOE3 = _interopRequireDefault(_AOE2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Butterflies
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 30/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Butterflies = function (_AOE) {
    _inherits(Butterflies, _AOE);

    /**
     * @param {RaceCar} owner
     */
    function Butterflies(owner) {
        _classCallCheck(this, Butterflies);

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (Butterflies.__proto__ || Object.getPrototypeOf(Butterflies)).call(this, owner));

        _this._emitter = null;
        return _this;
    }

    _createClass(Butterflies, [{
        key: "init",
        value: function init() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_powerup_butterflies2");

            var holder = new PIXI.Container();
            this.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particles_powerup_butterfly_00"), assets.getTexture("particles_powerup_butterfly_01"), assets.getTexture("particles_powerup_butterfly_02")], config);
        }
    }, {
        key: "destroy",
        value: function destroy(options) {
            this._emitter.destroy();
            _get(Butterflies.prototype.__proto__ || Object.getPrototypeOf(Butterflies.prototype), "destroy", this).call(this, options);
        }
    }, {
        key: "update",
        value: function update(dt) {
            _get(Butterflies.prototype.__proto__ || Object.getPrototypeOf(Butterflies.prototype), "update", this).call(this, dt);
            this._emitter.update(dt);
        }
    }, {
        key: "start",
        value: function start() {
            this._emitter.emit = true;
        }
    }, {
        key: "stop",
        value: function stop() {
            this._emitter.emit = false;
        }
    }]);

    return Butterflies;
}(_AOE3.default);

exports.default = Butterflies;

},{"../Common":7,"./AOE":24}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AOEPowerup2 = require("./AOEPowerup");

var _AOEPowerup3 = _interopRequireDefault(_AOEPowerup2);

var _AudioParams = require("../AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

var _Butterflies = require("./Butterflies");

var _Butterflies2 = _interopRequireDefault(_Butterflies);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ButterfliesPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 30/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var ButterfliesPowerup = function (_AOEPowerup) {
    _inherits(ButterfliesPowerup, _AOEPowerup);

    /**
     * @param collector
     */
    function ButterfliesPowerup(collector) {
        _classCallCheck(this, ButterfliesPowerup);

        /**
         * @type {Audio}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (ButterfliesPowerup.__proto__ || Object.getPrototypeOf(ButterfliesPowerup)).call(this, collector));

        _this._loopSFX = null;
        return _this;
    }

    _createClass(ButterfliesPowerup, [{
        key: "destroy",
        value: function destroy() {
            this._stopLoopSFX();

            _get(ButterfliesPowerup.prototype.__proto__ || Object.getPrototypeOf(ButterfliesPowerup.prototype), "destroy", this).call(this);
        }
    }, {
        key: "activate",
        value: function activate() {
            var activated = _get(ButterfliesPowerup.prototype.__proto__ || Object.getPrototypeOf(ButterfliesPowerup.prototype), "activate", this).call(this);
            if (activated) {
                this._aoe = new _Butterflies2.default(this._collector);
                this._aoe.powerupType = this.type;
                this._aoe.init();
                this._collector.view.addChild(this._aoe);

                this._aoe.start();

                delay(function () {
                    this._collector.usingPowerup = false;
                    this._aoe.stop();

                    // gives time for particles to fade
                    delay(function () {
                        this._aoe.parent.removeChild(this._aoe);
                        this._aoe.destroy();

                        this._stopLoopSFX();
                    }, 1, this);
                }, this._aoe.duration, this);

                this._collector.view.visible && this._playLoopSFX();
            }
            return activated;
        }
    }, {
        key: "pause",
        value: function pause() {
            _get(ButterfliesPowerup.prototype.__proto__ || Object.getPrototypeOf(ButterfliesPowerup.prototype), "pause", this).call(this);
            this._stopLoopSFX();
        }
    }, {
        key: "resume",
        value: function resume() {
            _get(ButterfliesPowerup.prototype.__proto__ || Object.getPrototypeOf(ButterfliesPowerup.prototype), "resume", this).call(this);
            this._playLoopSFX();
        }
    }, {
        key: "_playLoopSFX",
        value: function _playLoopSFX() {
            var params = new _AudioParams2.default();
            params.loop = true;
            this._loopSFX = _Common2.default.audio.playSound("sfx_powerup_butterflies_01", params);
        }
    }, {
        key: "_stopLoopSFX",
        value: function _stopLoopSFX() {
            this._loopSFX && this._loopSFX.stop();
        }
    }]);

    return ButterfliesPowerup;
}(_AOEPowerup3.default);

exports.default = ButterfliesPowerup;

},{"../AudioParams":6,"../Common":7,"./AOEPowerup":25,"./Butterflies":32}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Bomb2 = require("./Bomb");

var _Bomb3 = _interopRequireDefault(_Bomb2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Candy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 06/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Bomb
 */
var Candy = function (_Bomb) {
    _inherits(Candy, _Bomb);

    /**
     * @param {RaceCar} owner
     */
    function Candy(owner) {
        _classCallCheck(this, Candy);

        var _this = _possibleConstructorReturn(this, (Candy.__proto__ || Object.getPrototypeOf(Candy)).call(this, owner));

        _this._view.texture = _Common2.default.assets.getTexture("game_powerup_candies");
        return _this;
    }

    _createClass(Candy, [{
        key: "arm",
        value: function arm() {
            this._view.texture = _Common2.default.assets.getTexture("powerup_patch_candy");
            this.offset.y += 80;
            this.scale = new PIXI.Point(2, 2);

            _get(Candy.prototype.__proto__ || Object.getPrototypeOf(Candy.prototype), "arm", this).call(this);
        }
    }, {
        key: "_createEmitter",
        value: function _createEmitter() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_candy_blast_00");

            var holder = new PIXI.Container();
            this._view.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particles_powerup_candy_00"), assets.getTexture("particles_powerup_candy_01"), assets.getTexture("particles_powerup_candy_02"), assets.getTexture("particles_powerup_candy_03"), assets.getTexture("particles_powerup_candy_04")], config);
        }
    }, {
        key: "_playSound",
        value: function _playSound() {
            _Common2.default.audio.playSound("sfx_hit_candy_02");
        }
    }]);

    return Candy;
}(_Bomb3.default);

exports.default = Candy;

},{"../Common":7,"./Bomb":26}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BombPowerup2 = require("./BombPowerup");

var _BombPowerup3 = _interopRequireDefault(_BombPowerup2);

var _Candy = require("./Candy");

var _Candy2 = _interopRequireDefault(_Candy);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  CandyPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 06/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var CandyPowerup = function (_BombPowerup) {
    _inherits(CandyPowerup, _BombPowerup);

    /**
     * @param {RaceCar} collector
     */
    function CandyPowerup(collector) {
        _classCallCheck(this, CandyPowerup);

        return _possibleConstructorReturn(this, (CandyPowerup.__proto__ || Object.getPrototypeOf(CandyPowerup)).call(this, collector));
    }

    /**
     * @returns {Candy}
     * @private
     */


    _createClass(CandyPowerup, [{
        key: "_createBomb",
        value: function _createBomb() {
            return new _Candy2.default(this._collector);
        }
    }, {
        key: "_playSound",
        value: function _playSound() {
            _Common2.default.audio.playSound("sfx_powerup_candy_00");
        }
    }]);

    return CandyPowerup;
}(_BombPowerup3.default);

exports.default = CandyPowerup;

},{"../Common":7,"./BombPowerup":27,"./Candy":34}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Boost2 = require("./Boost");

var _Boost3 = _interopRequireDefault(_Boost2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  FlameBoost
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 07/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Boost
 */
var FlameBoost = function (_Boost) {
    _inherits(FlameBoost, _Boost);

    /**
     * @param owner
     */
    function FlameBoost(owner) {
        _classCallCheck(this, FlameBoost);

        /**
         * @type {null}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (FlameBoost.__proto__ || Object.getPrototypeOf(FlameBoost)).call(this, owner));

        _this._emitter = null;
        return _this;
    }

    _createClass(FlameBoost, [{
        key: "init",
        value: function init() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_flameon_00");

            var holder = new PIXI.Container();
            holder.y = 40;
            this.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_powerup_flameon_00"), assets.getTexture("particle_powerup_flameon_01"), assets.getTexture("particle_powerup_flameon_02"), assets.getTexture("particle_powerup_flameon_03"), assets.getTexture("particle_powerup_flameon_04"), assets.getTexture("particle_powerup_flameon_05")], config);

            _get(FlameBoost.prototype.__proto__ || Object.getPrototypeOf(FlameBoost.prototype), "init", this).call(this);
        }
    }, {
        key: "destroy",
        value: function destroy(options) {
            _get(FlameBoost.prototype.__proto__ || Object.getPrototypeOf(FlameBoost.prototype), "destroy", this).call(this, options);

            this._emitter.destroy();
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            _get(FlameBoost.prototype.__proto__ || Object.getPrototypeOf(FlameBoost.prototype), "update", this).call(this, dt);
            this._emitter.update(dt);
        }

        /**
         * @protected
         */

    }, {
        key: "_startBoost",
        value: function _startBoost() {
            _get(FlameBoost.prototype.__proto__ || Object.getPrototypeOf(FlameBoost.prototype), "_startBoost", this).call(this);

            this._emitter.emit = true;
        }

        /**
         * @protected
         */

    }, {
        key: "_stopBoost",
        value: function _stopBoost() {
            _get(FlameBoost.prototype.__proto__ || Object.getPrototypeOf(FlameBoost.prototype), "_stopBoost", this).call(this);

            delay(function () {
                this._emitter.emit = false;
            }, 1, this);

            delay(function () {
                this.parent && this.parent.removeChild(this);
            }, 2, this);
        }
    }]);

    return FlameBoost;
}(_Boost3.default);

exports.default = FlameBoost;

},{"../Common":7,"./Boost":28}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BoostPowerup2 = require("./BoostPowerup");

var _BoostPowerup3 = _interopRequireDefault(_BoostPowerup2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _FlameBoost = require("./FlameBoost");

var _FlameBoost2 = _interopRequireDefault(_FlameBoost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  FlamePowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 07/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var FlamePowerup = function (_BoostPowerup) {
    _inherits(FlamePowerup, _BoostPowerup);

    /**
     * @param collector
     */
    function FlamePowerup(collector) {
        _classCallCheck(this, FlamePowerup);

        return _possibleConstructorReturn(this, (FlamePowerup.__proto__ || Object.getPrototypeOf(FlamePowerup)).call(this, collector));
    }

    _createClass(FlamePowerup, [{
        key: "activate",
        value: function activate() {
            var activated = _get(FlamePowerup.prototype.__proto__ || Object.getPrototypeOf(FlamePowerup.prototype), "activate", this).call(this);
            this._collector.view.visible && _Common2.default.audio.playSound("sfx_powerup_flame_00");
            return activated;
        }

        /**
         * @returns {FlameBoost}
         * @private
         */

    }, {
        key: "_createBoost",
        value: function _createBoost() {
            return new _FlameBoost2.default(this._collector);
        }
    }]);

    return FlamePowerup;
}(_BoostPowerup3.default);

exports.default = FlamePowerup;

},{"../Common":7,"./BoostPowerup":29,"./FlameBoost":36}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Bomb2 = require("./Bomb");

var _Bomb3 = _interopRequireDefault(_Bomb2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Glue
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 07/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Bomb
 */
var Glue = function (_Bomb) {
    _inherits(Glue, _Bomb);

    /**
     * @param {RaceCar} owner
     */
    function Glue(owner) {
        _classCallCheck(this, Glue);

        var _this = _possibleConstructorReturn(this, (Glue.__proto__ || Object.getPrototypeOf(Glue)).call(this, owner));

        _this._view.texture = _Common2.default.assets.getTexture("particles_powerup_glue_00");
        return _this;
    }

    _createClass(Glue, [{
        key: "arm",
        value: function arm() {
            this._view.texture = _Common2.default.assets.getTexture("powerup_patch_glue");
            this.offset.y += 80;
            this.scale = new PIXI.Point(2, 2);

            _get(Glue.prototype.__proto__ || Object.getPrototypeOf(Glue.prototype), "arm", this).call(this);
        }
    }, {
        key: "_createEmitter",
        value: function _createEmitter() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_glue_puddle_00");

            var holder = new PIXI.Container();
            this._view.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particles_powerup_glue_00")], config);
        }
    }, {
        key: "_playSound",
        value: function _playSound() {
            _Common2.default.audio.playSound("sfx_hit_glue_00");
        }
    }]);

    return Glue;
}(_Bomb3.default);

exports.default = Glue;

},{"../Common":7,"./Bomb":26}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BombPowerup2 = require("./BombPowerup");

var _BombPowerup3 = _interopRequireDefault(_BombPowerup2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Glue = require("./Glue");

var _Glue2 = _interopRequireDefault(_Glue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  GluePowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 06/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var GluePowerup = function (_BombPowerup) {
    _inherits(GluePowerup, _BombPowerup);

    /**
     * @param {RaceCar} collector
     */
    function GluePowerup(collector) {
        _classCallCheck(this, GluePowerup);

        return _possibleConstructorReturn(this, (GluePowerup.__proto__ || Object.getPrototypeOf(GluePowerup)).call(this, collector));
    }

    /**
     * @returns {Tacs}
     * @private
     */


    _createClass(GluePowerup, [{
        key: "_createBomb",
        value: function _createBomb() {
            return new _Glue2.default(this._collector);
        }
    }, {
        key: "_playSound",
        value: function _playSound() {
            _Common2.default.audio.playSound("sfx_launch_glue_00");
        }
    }]);

    return GluePowerup;
}(_BombPowerup3.default);

exports.default = GluePowerup;

},{"../Common":7,"./BombPowerup":27,"./Glue":38}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Boost2 = require("./Boost");

var _Boost3 = _interopRequireDefault(_Boost2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  LightningBoost
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 07/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Boost
 */
var LightningBoost = function (_Boost) {
    _inherits(LightningBoost, _Boost);

    /**
     * @param owner
     */
    function LightningBoost(owner) {
        _classCallCheck(this, LightningBoost);

        /**
         * @type {null}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (LightningBoost.__proto__ || Object.getPrototypeOf(LightningBoost)).call(this, owner));

        _this._emitter = null;
        return _this;
    }

    _createClass(LightningBoost, [{
        key: "init",
        value: function init() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_lightning_speed_00");

            var holder = new PIXI.Container();
            holder.y = 40;
            this.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_powerup_lightningspeed_01")], config);

            _get(LightningBoost.prototype.__proto__ || Object.getPrototypeOf(LightningBoost.prototype), "init", this).call(this);
        }
    }, {
        key: "destroy",
        value: function destroy(options) {
            _get(LightningBoost.prototype.__proto__ || Object.getPrototypeOf(LightningBoost.prototype), "destroy", this).call(this, options);

            this._emitter.destroy();
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            _get(LightningBoost.prototype.__proto__ || Object.getPrototypeOf(LightningBoost.prototype), "update", this).call(this, dt);
            this._emitter.update(dt);
        }

        /**
         * @protected
         */

    }, {
        key: "_startBoost",
        value: function _startBoost() {
            _get(LightningBoost.prototype.__proto__ || Object.getPrototypeOf(LightningBoost.prototype), "_startBoost", this).call(this);

            this._emitter.emit = true;
        }

        /**
         * @protected
         */

    }, {
        key: "_stopBoost",
        value: function _stopBoost() {
            _get(LightningBoost.prototype.__proto__ || Object.getPrototypeOf(LightningBoost.prototype), "_stopBoost", this).call(this);

            delay(function () {
                this._emitter.emit = false;
            }, 1, this);

            delay(function () {
                this.parent && this.parent.removeChild(this);
            }, 2, this);
        }
    }]);

    return LightningBoost;
}(_Boost3.default);

exports.default = LightningBoost;

},{"../Common":7,"./Boost":28}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BoostPowerup2 = require("./BoostPowerup");

var _BoostPowerup3 = _interopRequireDefault(_BoostPowerup2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _LightningBoost = require("./LightningBoost");

var _LightningBoost2 = _interopRequireDefault(_LightningBoost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  LightningPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 07/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var LightningPowerup = function (_BoostPowerup) {
    _inherits(LightningPowerup, _BoostPowerup);

    /**
     * @param collector
     */
    function LightningPowerup(collector) {
        _classCallCheck(this, LightningPowerup);

        return _possibleConstructorReturn(this, (LightningPowerup.__proto__ || Object.getPrototypeOf(LightningPowerup)).call(this, collector));
    }

    _createClass(LightningPowerup, [{
        key: "activate",
        value: function activate() {
            var activated = _get(LightningPowerup.prototype.__proto__ || Object.getPrototypeOf(LightningPowerup.prototype), "activate", this).call(this);
            this._collector.view.visible && _Common2.default.audio.playSound("sfx_powerup_lightning_01");
            return activated;
        }

        /**
         * @returns {LightningBoost}
         * @private
         */

    }, {
        key: "_createBoost",
        value: function _createBoost() {
            return new _LightningBoost2.default(this._collector);
        }
    }]);

    return LightningPowerup;
}(_BoostPowerup3.default);

exports.default = LightningPowerup;

},{"../Common":7,"./BoostPowerup":29,"./LightningBoost":40}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceMover2 = require("../race/RaceMover");

var _RaceMover3 = _interopRequireDefault(_RaceMover2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Missile
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 20/04/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceMover
 */
var Missile = function (_RaceMover) {
    _inherits(Missile, _RaceMover);

    /**
     * @param {RaceCar} owner
     */
    function Missile(owner) {
        _classCallCheck(this, Missile);

        var temp = new PIXI.Sprite(_Common2.default.assets.getTexture("powerup_missile_normal_object_01"));
        temp.anchor = new PIXI.Point(0.5, 0.5);
        temp.tint = 0xFF0000;

        var _this = _possibleConstructorReturn(this, (Missile.__proto__ || Object.getPrototypeOf(Missile)).call(this, temp));

        _this.acceleration = 16;
        _this.velocity = _this.acceleration;
        _this.linearDamping = 0.994;
        _this.collisionWidth = 60;
        _this.collisionLength = 60;

        /**
         * @type {number}
         */
        _this.powerupType = 0;

        /**
         * @member {number}
         */
        _this.life = 40;

        /**
         * @member {RaceCar}
         * @protected
         */
        _this._owner = owner;

        /**
         * @member {number}
         * @protected
         */
        _this._startDist = 0;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        _this._trailEmitter = null;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        _this._explosionEmitter = null;

        /**
         * @type {boolean}
         * @private
         */
        _this._armed = true;
        return _this;
    }

    /**
     */


    _createClass(Missile, [{
        key: "init",
        value: function init() {
            this._startDist = this.getTotalDistance();

            this._createTrailEmitter();
        }

        /**
         */

    }, {
        key: "destroy",
        value: function destroy() {
            this._trailEmitter.destroy();

            _get(Missile.prototype.__proto__ || Object.getPrototypeOf(Missile.prototype), "destroy", this).call(this);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            if (this._armed) {
                _get(Missile.prototype.__proto__ || Object.getPrototypeOf(Missile.prototype), "update", this).call(this, dt);
                var distance = this.getTotalDistance() - this._startDist;
                if (distance > this.life) {
                    this.explode();
                }
            }

            this._trailEmitter && this._trailEmitter.update(dt);
            this._explosionEmitter && this._explosionEmitter.update(dt);
            if (this._explosionEmitter && !this._explosionEmitter.emit) {
                this.destroyNextFrame = true;
            }
        }
    }, {
        key: "explode",
        value: function explode() {
            this._armed = false;

            this._createExplosionEmitter();
            this._explosionEmitter.playOnceAndDestroy();

            this._view.visible && _Common2.default.audio.playSound(["sfx_bomb_explode_big_00", "sfx_bomb_explode_big_01"]);
        }

        /**
         * @protected
         */

    }, {
        key: "_createTrailEmitter",
        value: function _createTrailEmitter() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_missile_normal_trail");

            var holder = new PIXI.Container();
            holder.scale = new PIXI.Point(2, 2);
            this._view.addChild(holder);

            this._trailEmitter = new PIXI.particles.Emitter(this._view, [assets.getTexture("particles_rockettrail_00"), assets.getTexture("particles_rockettrail_01"), assets.getTexture("particles_rockettrail_02"), assets.getTexture("particles_rockettrail_03")], config);
            this._trailEmitter.emit = true;
        }

        /**
         * @protected
         */

    }, {
        key: "_createExplosionEmitter",
        value: function _createExplosionEmitter() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_explosion_00");

            var holder = new PIXI.Container();
            holder.scale = new PIXI.Point(2, 2);
            this._view.addChild(holder);

            this._explosionEmitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_explosion_smoke_00"), assets.getTexture("particle_explosion_smoke_01"), assets.getTexture("particle_explosion_smoke_02")], config);
            this._explosionEmitter.emit = false;
        }

        /**
         * @returns {RaceCar}
         */

    }, {
        key: "owner",
        get: function get() {
            return this._owner;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "armed",
        get: function get() {
            return this._armed;
        }
    }]);

    return Missile;
}(_RaceMover3.default);

exports.default = Missile;

},{"../Common":7,"../race/RaceMover":58}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Missile = require("./Missile");

var _Missile2 = _interopRequireDefault(_Missile);

var _Powerup2 = require("./Powerup");

var _Powerup3 = _interopRequireDefault(_Powerup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  MissilePowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 20/04/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var MissilePowerup = function (_Powerup) {
    _inherits(MissilePowerup, _Powerup);

    /**
     * @param collector
     */
    function MissilePowerup(collector) {
        _classCallCheck(this, MissilePowerup);

        /**
         * @type {Missile}
         * @protected
         */
        var _this = _possibleConstructorReturn(this, (MissilePowerup.__proto__ || Object.getPrototypeOf(MissilePowerup)).call(this, collector));

        _this._missile = null;
        return _this;
    }

    /**
     */


    _createClass(MissilePowerup, [{
        key: "init",
        value: function init() {
            _get(MissilePowerup.prototype.__proto__ || Object.getPrototypeOf(MissilePowerup.prototype), "init", this).call(this);
        }

        /**
         */

    }, {
        key: "destroy",
        value: function destroy() {
            _get(MissilePowerup.prototype.__proto__ || Object.getPrototypeOf(MissilePowerup.prototype), "destroy", this).call(this);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            _get(MissilePowerup.prototype.__proto__ || Object.getPrototypeOf(MissilePowerup.prototype), "update", this).call(this, dt);

            if (this._missile && this._missile.destroyNextFrame) {
                this.destroyNextFrame = true;
            }
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "activate",
        value: function activate() {
            var activated = _get(MissilePowerup.prototype.__proto__ || Object.getPrototypeOf(MissilePowerup.prototype), "activate", this).call(this);
            if (activated) {
                this._missile = this._createMissile(this._collector);
                this._missile.powerupType = this.type;
                this._missile.offset.x = this._collector.offset.x;
                this._missile.offset.y = -120;
                this._missile.moving = true;
                this._missile.lap = this._collector.lap;
                this._collector.engine.addEntity(this._missile, this._collector.distance + 0.2, false);

                delay(function () {
                    this._collector.usingPowerup = false;
                }, 2, this);

                this._collector.view.visible && _Common2.default.audio.playSound(["sfx_launch_missile_00", "sfx_launch_missile_01"]);
            }
            return activated;
        }

        /**
         * @param {RaceCar} collector
         * @returns {Missile}
         * @private
         */

    }, {
        key: "_createMissile",
        value: function _createMissile(collector) {
            return new _Missile2.default(collector);
        }

        /**
         * @returns {Missile}
         */

    }, {
        key: "missile",
        get: function get() {
            return this._missile;
        }
    }]);

    return MissilePowerup;
}(_Powerup3.default);

exports.default = MissilePowerup;

},{"../Common":7,"./Missile":42,"./Powerup":44}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Powerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 21/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 */
var Powerup = function () {
    /**
     * @param {RaceCar} collector
     */
    function Powerup(collector) {
        _classCallCheck(this, Powerup);

        /**
         * @type {boolean}
         */
        this.destroyNextFrame = false;

        /**
         * @type {number}
         */
        this.type = 0;

        /**
         * @type {RaceCar}
         * @protected
         */
        this._collector = collector;

        /**
         * @type {boolean}
         * @protected
         */
        this._activated = false;
    }

    _createClass(Powerup, [{
        key: "destroy",
        value: function destroy() {}
        // override


        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            // override
        }
    }, {
        key: "pause",
        value: function pause() {
            // override
        }
    }, {
        key: "resume",
        value: function resume() {}
        // override


        /**
         * @returns {boolean}
         */

    }, {
        key: "activate",
        value: function activate() {
            if (!this._activated) {
                this._activated = true;
                return true;
            }
            return false;
        }

        /**
         * @returns {RaceCar}
         */

    }, {
        key: "collector",
        get: function get() {
            return this._collector;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "activated",
        get: function get() {
            return this._activated;
        }

        /**
         * @returns {Array}
         * @static
         */

    }], [{
        key: "getRandomTypes",
        value: function getRandomTypes() {
            var types = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            var arr = [];

            var count = types.length;
            for (var i = 0; i < count; ++i) {
                var index = Math.floor(Math.random() * types.length);
                var type = types[index];
                types.splice(index, 1);
                arr.push(type);
            }
            return arr;
        }

        /**
         * @param {number} id
         * @returns {PIXI.Texture}
         * @static
         */

    }, {
        key: "getTexture",
        value: function getTexture(id) {
            var assets = _Common2.default.assets;

            var name = void 0;
            switch (id) {
                case 0:
                    {
                        name = "ui_icon_powerup_bomb";
                        break;
                    }
                case 1:
                    {
                        name = "ui_icon_powerup_candies";
                        break;
                    }
                case 2:
                    {
                        name = "ui_icon_powerup_flame";
                        break;
                    }
                case 3:
                    {
                        name = "ui_icon_powerup_glue";
                        break;
                    }
                case 4:
                    {
                        name = "ui_icon_powerup_lightning";
                        break;
                    }
                case 5:
                    {
                        name = "ui_icon_powerup_missile";
                        break;
                    }
                case 6:
                    {
                        name = "ui_icon_powerup_nails";
                        break;
                    }
                case 7:
                    {
                        name = "ui_icon_powerup_smart_missile";
                        break;
                    }
                case 8:
                    {
                        name = "ui_icon_powerup_steam";
                        break;
                    }
                case 9:
                    {
                        name = "ui_icon_powerup_bubbles";
                        break;
                    }
                case 10:
                    {
                        name = "ui_icon_powerup_butterfly";
                        break;
                    }
            }
            return assets.getTexture(name);
        }
    }]);

    return Powerup;
}();

exports.default = Powerup;

},{"../Common":7}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Missile2 = require("./Missile");

var _Missile3 = _interopRequireDefault(_Missile2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  SmartMissile
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 21/04/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Missile
 */
var SmartMissile = function (_Missile) {
    _inherits(SmartMissile, _Missile);

    /**
     * @param {RaceCar} owner
     */
    function SmartMissile(owner) {
        _classCallCheck(this, SmartMissile);

        var _this = _possibleConstructorReturn(this, (SmartMissile.__proto__ || Object.getPrototypeOf(SmartMissile)).call(this, owner));

        _this.turnAccel = 12000;
        _this.turnDamping = 0.914;

        _this.view.texture = _Common2.default.assets.getTexture("powerup_missile_smart_object_01");
        _this.view.tint = 0x000099;

        /**
         * @member {number}
         */
        _this.minSeekDistance = 0;

        /**
         * @member {number}
         */
        _this.maxSeekDistance = 16;
        return _this;
    }

    /**
     */


    _createClass(SmartMissile, [{
        key: "init",
        value: function init() {
            _get(SmartMissile.prototype.__proto__ || Object.getPrototypeOf(SmartMissile.prototype), "init", this).call(this);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            if (this._armed) {
                var car = this.seekTarget();
                if (car) {
                    var target = car.offset.x;

                    var width = 580;
                    if (Math.abs(target) > width) {
                        target = target / Math.abs(target) * width;
                    }

                    var distance = target - this.offset.x;
                    var direction = distance / Math.abs(distance);
                    var time = 1.6;

                    var radius = 280;
                    if (distance > radius) {
                        this.turnSpeed = direction * this.turnAccel;
                    } else {
                        this.turnSpeed = direction * (this.turnAccel * Math.min(1, Math.abs(distance / radius)));
                    }
                    this.turnSpeed /= time;
                }
            }
            _get(SmartMissile.prototype.__proto__ || Object.getPrototypeOf(SmartMissile.prototype), "update", this).call(this, dt);
        }

        /**
         * @returns {RaceEntity}
         */

    }, {
        key: "seekTarget",
        value: function seekTarget() {
            var minDistance = Number.MAX_SAFE_INTEGER;
            var result = null;
            var cars = _Common2.default.game.getCars();

            for (var i = 0; i < cars.length; ++i) {
                var car = cars[i];
                if (car === this._owner) continue;

                var diff = this.getDistanceTo(car);
                if (diff > this.minSeekDistance && diff < this.maxSeekDistance) {
                    if (diff < minDistance) {
                        result = car;
                        minDistance = diff;
                    }
                }
            }
            return result;
        }

        /**
         * @protected
         */

    }, {
        key: "_createTrailEmitter",
        value: function _createTrailEmitter() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_missile_smart_trail");
            this._trailEmitter = new PIXI.particles.Emitter(this._view, [assets.getTexture("particles_rockettrail_00"), assets.getTexture("particles_rockettrail_01"), assets.getTexture("particles_rockettrail_02"), assets.getTexture("particles_rockettrail_03")], config);
            this._trailEmitter.emit = true;
        }
    }]);

    return SmartMissile;
}(_Missile3.default);

exports.default = SmartMissile;

},{"../Common":7,"./Missile":42}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MissilePowerup2 = require("./MissilePowerup");

var _MissilePowerup3 = _interopRequireDefault(_MissilePowerup2);

var _SmartMissile = require("./SmartMissile");

var _SmartMissile2 = _interopRequireDefault(_SmartMissile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  MissilePowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 20/04/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var SmartMissilePowerup = function (_MissilePowerup) {
  _inherits(SmartMissilePowerup, _MissilePowerup);

  /**
   * @param collector
   */
  function SmartMissilePowerup(collector) {
    _classCallCheck(this, SmartMissilePowerup);

    return _possibleConstructorReturn(this, (SmartMissilePowerup.__proto__ || Object.getPrototypeOf(SmartMissilePowerup)).call(this, collector));
  }

  /**
   * @param {RaceCar} collector
   * @private
   */


  _createClass(SmartMissilePowerup, [{
    key: "_createMissile",
    value: function _createMissile(collector) {
      return new _SmartMissile2.default(collector);
    }
  }]);

  return SmartMissilePowerup;
}(_MissilePowerup3.default);

exports.default = SmartMissilePowerup;

},{"./MissilePowerup":43,"./SmartMissile":45}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Boost2 = require("./Boost");

var _Boost3 = _interopRequireDefault(_Boost2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  SteamBoost
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 07/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Boost
 */
var SteamBoost = function (_Boost) {
    _inherits(SteamBoost, _Boost);

    /**
     * @param owner
     */
    function SteamBoost(owner) {
        _classCallCheck(this, SteamBoost);

        /**
         * @type {null}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (SteamBoost.__proto__ || Object.getPrototypeOf(SteamBoost)).call(this, owner));

        _this._emitter = null;
        return _this;
    }

    _createClass(SteamBoost, [{
        key: "init",
        value: function init() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_powerup_steamahead");

            var holder = new PIXI.Container();
            holder.y = 40;
            this.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particles_steam_00"), assets.getTexture("particles_steam_01"), assets.getTexture("particles_steam_02"), assets.getTexture("particles_steam_03")], config);

            _get(SteamBoost.prototype.__proto__ || Object.getPrototypeOf(SteamBoost.prototype), "init", this).call(this);
        }
    }, {
        key: "destroy",
        value: function destroy(options) {
            _get(SteamBoost.prototype.__proto__ || Object.getPrototypeOf(SteamBoost.prototype), "destroy", this).call(this, options);

            this._emitter.destroy();
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            _get(SteamBoost.prototype.__proto__ || Object.getPrototypeOf(SteamBoost.prototype), "update", this).call(this, dt);
            this._emitter.update(dt);
        }

        /**
         * @protected
         */

    }, {
        key: "_startBoost",
        value: function _startBoost() {
            _get(SteamBoost.prototype.__proto__ || Object.getPrototypeOf(SteamBoost.prototype), "_startBoost", this).call(this);

            this._emitter.emit = true;
        }

        /**
         * @protected
         */

    }, {
        key: "_stopBoost",
        value: function _stopBoost() {
            _get(SteamBoost.prototype.__proto__ || Object.getPrototypeOf(SteamBoost.prototype), "_stopBoost", this).call(this);

            delay(function () {
                this._emitter.emit = false;
            }, 1, this);

            delay(function () {
                this.parent && this.parent.removeChild(this);
            }, 2, this);
        }
    }]);

    return SteamBoost;
}(_Boost3.default);

exports.default = SteamBoost;

},{"../Common":7,"./Boost":28}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BoostPowerup2 = require("./BoostPowerup");

var _BoostPowerup3 = _interopRequireDefault(_BoostPowerup2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _SteamBoost = require("./SteamBoost");

var _SteamBoost2 = _interopRequireDefault(_SteamBoost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  SteamPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 07/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var SteamPowerup = function (_BoostPowerup) {
    _inherits(SteamPowerup, _BoostPowerup);

    /**
     * @param collector
     */
    function SteamPowerup(collector) {
        _classCallCheck(this, SteamPowerup);

        return _possibleConstructorReturn(this, (SteamPowerup.__proto__ || Object.getPrototypeOf(SteamPowerup)).call(this, collector));
    }

    _createClass(SteamPowerup, [{
        key: "activate",
        value: function activate() {
            var activated = _get(SteamPowerup.prototype.__proto__ || Object.getPrototypeOf(SteamPowerup.prototype), "activate", this).call(this);
            this._collector.view.visible && _Common2.default.audio.playSound("sfx_powerup_steam_01");
            return activated;
        }

        /**
         * @returns {SteamBoost}
         * @private
         */

    }, {
        key: "_createBoost",
        value: function _createBoost() {
            return new _SteamBoost2.default(this._collector);
        }
    }]);

    return SteamPowerup;
}(_BoostPowerup3.default);

exports.default = SteamPowerup;

},{"../Common":7,"./BoostPowerup":29,"./SteamBoost":47}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Bomb2 = require("./Bomb");

var _Bomb3 = _interopRequireDefault(_Bomb2);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Tacs
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 06/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Bomb
 */
var Tacs = function (_Bomb) {
    _inherits(Tacs, _Bomb);

    /**
     * @param {RaceCar} owner
     */
    function Tacs(owner) {
        _classCallCheck(this, Tacs);

        var _this = _possibleConstructorReturn(this, (Tacs.__proto__ || Object.getPrototypeOf(Tacs)).call(this, owner));

        _this._view.texture = _Common2.default.assets.getTexture("game_powerup_nails");
        return _this;
    }

    _createClass(Tacs, [{
        key: "arm",
        value: function arm() {
            this._view.texture = _Common2.default.assets.getTexture("powerup_patch_tacks");
            this.offset.y += 80;
            this.scale = new PIXI.Point(2, 2);

            _get(Tacs.prototype.__proto__ || Object.getPrototypeOf(Tacs.prototype), "arm", this).call(this);
        }
    }, {
        key: "_createEmitter",
        value: function _createEmitter() {
            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_candy_blast_00");

            var holder = new PIXI.Container();
            this._view.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particles_powerup_nail_00")], config);
        }
    }]);

    return Tacs;
}(_Bomb3.default);

exports.default = Tacs;

},{"../Common":7,"./Bomb":26}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BombPowerup2 = require("./BombPowerup");

var _BombPowerup3 = _interopRequireDefault(_BombPowerup2);

var _Tacs = require("./Tacs");

var _Tacs2 = _interopRequireDefault(_Tacs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TacsPowerup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 06/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Powerup
 */
var TacsPowerup = function (_BombPowerup) {
  _inherits(TacsPowerup, _BombPowerup);

  /**
   * @param {RaceCar} collector
   */
  function TacsPowerup(collector) {
    _classCallCheck(this, TacsPowerup);

    return _possibleConstructorReturn(this, (TacsPowerup.__proto__ || Object.getPrototypeOf(TacsPowerup)).call(this, collector));
  }

  /**
   * @returns {Tacs}
   * @private
   */


  _createClass(TacsPowerup, [{
    key: "_createBomb",
    value: function _createBomb() {
      return new _Tacs2.default(this._collector);
    }
  }]);

  return TacsPowerup;
}(_BombPowerup3.default);

exports.default = TacsPowerup;

},{"./BombPowerup":27,"./Tacs":49}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  Point4
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @extends PIXI.Point
 * @memberOf race
 */
var Point4 = function (_PIXI$Point) {
    _inherits(Point4, _PIXI$Point);

    /**
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
     * @param {number} [z=0] - position of the point on the z axis
     * @param {number} [w=0] - homogeneous w property
     */
    function Point4() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        _classCallCheck(this, Point4);

        /**
         * @member {number}
         * @default 0
         */
        var _this = _possibleConstructorReturn(this, (Point4.__proto__ || Object.getPrototypeOf(Point4)).call(this, x, y));

        _this.z = z;

        /**
         * @member {number}
         * @default 0
         */
        _this.w = w;
        return _this;
    }

    /**
     * @returns {Point4}
     */


    _createClass(Point4, [{
        key: "clone",
        value: function clone() {
            return new Point4(this.x, this.y, this.z, this.w);
        }

        /**
         * @param {Point4} p
         */

    }, {
        key: "copy",
        value: function copy(p) {
            this.set(p.x, p.y, p.z, p.w);
        }

        /**
         * @param {Point4} p
         * @returns {boolean}
         */

    }, {
        key: "equals",
        value: function equals(p) {
            return p.x === this.x && p.y === this.y && p.z === this.z && p.w && this.w;
        }

        /**
         * @param {!number} [x=0]
         * @param {!number} [y=0]
         * @param {!number} [z=0]
         * @param {!number} [w=0]
         */

    }, {
        key: "set",
        value: function set(x, y, z, w) {
            this.x = x || 0;
            this.y = y || (y !== 0 ? this.x : 0);
            this.z = z || (z !== 0 ? this.x : 0);
            this.w = w || (w !== 0 ? this.x : 0);
        }
    }]);

    return Point4;
}(PIXI.Point);

exports.default = Point4;

},{}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  RaceCamera
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 21/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Point = require("./Point4");

var _Point2 = _interopRequireDefault(_Point);

var _RaceEntity = require("./RaceEntity");

var _RaceEntity2 = _interopRequireDefault(_RaceEntity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf race
 */
var RaceCamera = function () {
  /**
   * @param {Point4} [position]
   * @param {!number} [angle=0]
   */
  function RaceCamera(position) {
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, RaceCamera);

    /**
     * @member {RaceEntity}
     */
    this.target = null;

    /**
     * @member {Point4}
     */
    this.position = position || new _Point2.default();

    /**
     * @member {number}
     * @default 0
     */
    this.angle = angle;

    /**
     * @member {PIXI.Point}
     */
    this.vanishingPoint = new PIXI.Point();

    /**
     * @member {number}
     * @default 90
     */
    this.fieldOfView = 90;

    /**
     * @member {number}
     * @default 2.5
     */
    this.focus = 2.5;

    /**
     * @member {number}
     * @default 30
     */
    this.zoom = 30;

    /**
     * @member {number}
     * @default -2
     */
    this.height = -2;

    /**
     * @member {PIXI.Point}
     */
    this.offset = new PIXI.Point();

    /**
     * @member {number}
     * @default 1
     */
    this.distance = 2;

    /**
     * @member {number}
     * @default 1.6
     */
    this.tilt = 1.6;

    /**
     * @member {number}
     * @default 0.03
     */
    this.tiltEase = 0.01;

    /**
     * @member {PIXI.Point}
     */
    this.shake = new PIXI.Point();

    /**
     * @member {PIXI.Point}
     */
    this.shakeOffset = new PIXI.Point();

    /**
     * @member {number}
     * @default 0.14
     */
    this.shakeEase = 0.14;

    /**
     * @member {number}
     * @default 14
     */
    this.shakeMagnitiude = 14;

    /**
     * @member {number}
     */
    this.shakeElapsed = 0;

    /**
     * @member {number}
     */
    this.shakeDuration = 0;
  }

  /**
   * @param {!number} [duration=1]
   * @param {!number} [magnitude=14]
   */


  _createClass(RaceCamera, [{
    key: "applyShake",
    value: function applyShake() {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var magnitude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;

      this.shakeDuration = duration;
      this.shakeMagnitiude = magnitude;
      this.shakeElapsed = 0;
    }
  }]);

  return RaceCamera;
}();

exports.default = RaceCamera;

},{"./Point4":51,"./RaceEntity":57}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _RaceMover2 = require("./RaceMover");

var _RaceMover3 = _interopRequireDefault(_RaceMover2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  RaceCar
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 21/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceMover
 * @memberOf race
 */
var RaceCar = function (_RaceMover) {
    _inherits(RaceCar, _RaceMover);

    /**
     * @param {number} id
     * @param {RaceCarView} view
     */
    function RaceCar(id, view) {
        _classCallCheck(this, RaceCar);

        var _this = _possibleConstructorReturn(this, (RaceCar.__proto__ || Object.getPrototypeOf(RaceCar)).call(this, view));

        _this.acceleration = 3.4;
        _this.turnAccel = 10000;
        _this.linearDamping = 0.994;
        _this.turnDamping = 0.94;
        _this.collisionWidth = 400;
        _this.collisionLength = 50;

        /**
         * @member {signals.Signal}
         */
        _this.signals.boost = new signals.Signal();

        /**
         * @type {number}
         */
        _this.speedModifer = 1;

        /**
         * @member {number}
         */
        _this.brakeDamping = 0.97;

        /**
         * @member {number}
         */
        _this.minBrakeSpeed = 2;

        /**
         * @member {boolean}
         */
        _this.usingPowerup = false;

        /**
         * @member {number}
         */
        _this.offroadStart = 1240;

        /**
         * @member {number}
         */
        _this.offroadCoef = 0.994;

        /**
         * @member {number}
         */
        _this.roadLimit = 1420;

        /**
         * @member {number}
         * @protected
         */
        _this._id = id;

        /**
         * @member {boolean}
         * @protected
         */
        _this._boostActive = false;

        /**
         * @member {number}
         * @protected
         */
        _this._boostMultiplier = 1.4;

        /**
         * @member {boolean}
         * @protected
         */
        _this._jumping = false;

        /**
         * @member {number}
         * @protected
         */
        _this._debuffDuration = 0;

        /**
         * @member {number}
         * @protected
         */
        _this._debuffSlow = 0;

        /**
         * @member {number}
         * @protected
         */
        _this._debuffSwerve = 0;

        /**
         * @member {number}
         * @protected
         */
        _this._debuffTime = -1;

        /**
         * @type {number}
         * @protected
         */
        _this._jumpOffset = 0;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        _this._dustEmitter = null;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        _this._impactLeftEmitter = null;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        _this._impactRightEmitter = null;

        /**
         * @type {number}
         * @private
         */
        _this._impactTime = 0;
        return _this;
    }

    _createClass(RaceCar, [{
        key: "init",
        value: function init() {
            this._view.startEngine();

            this._createDustEmitter();
            this._createImpactLeftEmitter();
            this._createImpactRightEmitter();
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this.signals.boost.dispose();

            _get(RaceCar.prototype.__proto__ || Object.getPrototypeOf(RaceCar.prototype), "destroy", this).call(this);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            if (this.moving) {
                var acceleration = this.acceleration * this.speedModifer;
                if (this._boostActive) {
                    acceleration *= this._boostMultiplier;
                }
                this.velocity += acceleration * dt;
            }
            this.velocity *= this.linearDamping;
            this.distance += this.velocity * dt;

            var coef = Math.min(1, this.velocity / 12);
            this.turnVelocity += this.turnSpeed * coef * dt;
            this.turnVelocity *= this.turnDamping;
            this.offset.x += this.turnVelocity * dt;

            coef = this.velocity / 6;
            this.offset.x -= this.engine.getTrackCurvature(this.distance) * 6200 * coef * deltaTime;

            this.offset.x = Math.max(-this.roadLimit, Math.min(this.roadLimit, this.offset.x));
            if (Math.abs(this.offset.x) > this.offroadStart) {
                this._offroad = true;
                this.velocity *= this.offroadCoef;
                this._dustEmitter.emit = true;
            } else if (this._offroad) {
                this._offroad = false;
                this._dustEmitter.emit = false;
            }

            if (Math.abs(this.velocity) < 0.01) this.velocity = 0;
            if (Math.abs(this.turnVelocity) < 0.01) this.turnVelocity = 0;

            this.updateDebuff(dt);
            this.updateView(dt);
            this.updateLap(dt);

            this._dustEmitter.update(dt);
            this._impactLeftEmitter.update(dt);
            this._impactRightEmitter.update(dt);

            /*if (isNaN(this._view.position.x + this._view.position.y + this._view.scale.x + this._view.scale.y)) {
                alert("WE GOT A NAN IN THE HOUSE");
            }
            console.log(this._view.position, this._view.scale);
            */
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "updateDebuff",
        value: function updateDebuff(dt) {
            if (this._debuffDuration <= 0) {
                this._debuffDuration = this._debuffSlow = this._debuffSwerve = 0;
                this._debuffTime = -1;
            } else {
                this._debuffDuration -= dt;
                this.turnVelocity += Math.sin(++this._debuffTime * 0.012) * Math.random() * this.turnAccel * this._debuffSwerve * dt;
                this.velocity *= this._debuffSlow;
            }
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "updateView",
        value: function updateView(dt) {
            var curvature = 2 * this.engine.getTrackCurvature(this.distance);
            var gradient = this.engine.getTrackGradient(this.distance);
            this._view.update(dt, this.distance, curvature * 160, gradient * 0.56, this.velocity, this.turnVelocity * 0.026, this._jumpOffset);
        }
    }, {
        key: "brake",
        value: function brake() {
            if (this.velocity > this.minBrakeSpeed) {
                this.velocity *= this.brakeDamping;
            }
        }

        /**
         * @param {boolean} [hit=true]
         */

    }, {
        key: "jump",
        value: function jump() {
            var hit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (this._jumping) return;
            this._jumping = true;

            var tl = new TimelineMax({ onComplete: function onComplete() {
                    this._jumping = false;
                }, onCompleteScope: this });

            tl.append(TweenMax.to(this, 0.3, {
                _jumpOffset: hit ? 2 : 1,
                ease: Power2.easeOut
            }));
            tl.append(TweenMax.to(this, 0.2, {
                _jumpOffset: 0,
                ease: Power1.easeIn,
                onComplete: function onComplete() {
                    hit && this.view.visible && _Common2.default.audio.playSound("sfx_car_land_00");
                },
                onCompleteScope: this
            }));
            tl.append(TweenMax.to(this, 0.1, {
                _jumpOffset: 0.12,
                ease: Power1.easeInOut
            }));
            tl.append(TweenMax.to(this, 0.08, {
                _jumpOffset: 0,
                ease: Power1.easeInOut
            }));

            this.view.visible && _Common2.default.audio.playSound("sfx_btn_nextcar_00");
        }

        /**
         * @param {number} [multiplier=1.4]
         */

    }, {
        key: "startBoost",
        value: function startBoost() {
            var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.4;

            this._boostMultiplier = multiplier;
            this._boostActive = true;

            console.log("start boost", this);
        }
    }, {
        key: "stopBoost",
        value: function stopBoost() {
            if (!this._boostActive) return;
            this._boostActive = false;

            console.log("stop boost", this);
        }

        /**
         * @param {number} [duration=1]
         * @param {number} [slow=0.996]
         * @param {number} [swerve=0.64]
         */

    }, {
        key: "applyDebuff",
        value: function applyDebuff() {
            var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var slow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.996;
            var swerve = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.64;

            this._debuffDuration = Math.max(0, duration);
            this._debuffSlow = slow;
            this._debuffSwerve = swerve;

            if (this._debuffTime === -1) {
                this._debuffTime = Math.random() * Number.MAX_VALUE;
            }
        }

        /**
         * @param {boolean} [playSound=true]
         */

    }, {
        key: "takeHit",
        value: function takeHit() {
            var playSound = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.velocity *= 0.6;
            this.jump();

            playSound && _Common2.default.audio.playSound(["sfx_car_hit_00", "sfx_car_hit_01", "sfx_car_hit_02", "sfx_car_hit_03", "sfx_car_hit_04", "sfx_car_hit_05", "sfx_car_hit_06", "sfx_car_hit_07", "sfx_car_hit_08", "sfx_car_hit_09", "sfx_car_hit_10"]);
        }

        /**
         * @param {RaceCollision} collision
         * @param {RaceCar} car
         */

    }, {
        key: "onCollisionBegin",
        value: function onCollisionBegin(collision, car) {
            var velocity = Math.abs(this.turnVelocity + car.turnVelocity);
            if (window.performance.now() - this._impactTime > 4000 && velocity > 1000) {
                this._impactTime = window.performance.now();

                var dx = car.offset.x - this.offset.x;
                var sign = dx / Math.abs(dx);

                if (sign === -1) {
                    this._impactLeftEmitter.emit = true;
                } else if (sign === 1) {
                    this._impactRightEmitter.emit = true;
                }

                this._view.visible && _Common2.default.audio.playSound(["sfx_car_hit_00", "sfx_car_hit_01", "sfx_car_hit_02", "sfx_car_hit_03", "sfx_car_hit_04", "sfx_car_hit_05", "sfx_car_hit_06", "sfx_car_hit_07", "sfx_car_hit_08", "sfx_car_hit_09", "sfx_car_hit_10"]);
            }
        }
    }, {
        key: "onCollisionEnd",
        value: function onCollisionEnd() {}
    }, {
        key: "_createDustEmitter",
        value: function _createDustEmitter() {
            var holder = new PIXI.Container();
            holder.y = 80;
            holder.scale = new PIXI.Point(2, 2);
            this._view.addChild(holder);

            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_offtrack_dust_00");
            this._dustEmitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particles_car_dust_00"), assets.getTexture("particles_car_dust_01"), assets.getTexture("particles_car_dust_02"), assets.getTexture("particles_car_dust_03")], config);
            this._dustEmitter.emit = false;
        }
    }, {
        key: "_createImpactLeftEmitter",
        value: function _createImpactLeftEmitter() {
            var holder = new PIXI.Container();
            holder.y = 80;
            holder.scale = new PIXI.Point(2, 2);
            this._view.addChild(holder);

            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_impact_left_00");
            this._impactLeftEmitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_impact_star_orange"), assets.getTexture("particle_impact_star_white"), assets.getTexture("particle_impact_star_yellow")], config);
            this._impactLeftEmitter.emit = false;
        }
    }, {
        key: "_createImpactRightEmitter",
        value: function _createImpactRightEmitter() {
            var holder = new PIXI.Container();
            holder.y = 80;
            holder.scale = new PIXI.Point(2, 2);
            this._view.addChild(holder);

            var assets = _Common2.default.assets;
            var config = assets.getJSON("particle_emitter_impact_right_00");
            this._impactRightEmitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_impact_star_orange"), assets.getTexture("particle_impact_star_white"), assets.getTexture("particle_impact_star_yellow")], config);
            this._impactRightEmitter.emit = false;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "id",
        get: function get() {
            return this._id;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "offroad",
        get: function get() {
            return this._offroad;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "debuffed",
        get: function get() {
            return this._debuffDuration > 0;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "isPlayer",
        get: function get() {
            return this._id === _Common2.default.playerDriverId;
        }
    }]);

    return RaceCar;
}(_RaceMover3.default);

exports.default = RaceCar;

},{"../Common":7,"./RaceMover":58}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  RaceCarView
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends PIXI.Container
 * @memberOf race
 */
var RaceCarView = function (_PIXI$Container) {
    _inherits(RaceCarView, _PIXI$Container);

    function RaceCarView() {
        _classCallCheck(this, RaceCarView);

        /**
         * @type {number}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (RaceCarView.__proto__ || Object.getPrototypeOf(RaceCarView)).call(this));

        _this._curvature = 0;

        /**
         * @type {PIXI.Sprite}
         * @protected
         */
        _this._shadow = _this.createShadow();
        _this._shadow.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._shadow);

        /**
         * @member {Object}
         * @protected
         */
        _this._wheels = {};

        /**
         * @member {Object}
         * @protected
         */
        _this._wheels.front = {};

        /**
         * @member {Object}
         * @protected
         */
        _this._wheels.rear = {};

        /**
         * @member {p3.MovieClip}
         * @protected
         */
        _this._wheels.front.left = _this.createFrontWheel();
        _this._wheels.front.left.anchor = new PIXI.Point(0.5, 0.5);
        _this._wheels.front.left.offset = new PIXI.Point();
        _this._wheels.front.left.looping = true;
        _this._wheels.front.left.play();
        _this.addChild(_this._wheels.front.left);

        /**
         * @member {p3.MovieClip}
         * @protected
         */
        _this._wheels.front.right = _this.createFrontWheel();
        _this._wheels.front.right.anchor = new PIXI.Point(0.5, 0.5);
        _this._wheels.front.right.offset = new PIXI.Point();
        _this._wheels.front.right.looping = true;
        _this._wheels.front.right.scale.x = -1;
        _this._wheels.front.right.play();
        _this.addChild(_this._wheels.front.right);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._front = _this.createFrontLayer();
        _this._front.anchor = new PIXI.Point(0.5, 0.5);
        _this._front.offset = new PIXI.Point();
        _this.addChild(_this._front);

        /**
         * @member {p3.MovieClip}
         * @protected
         */
        _this._wheels.rear.left = _this.createRearWheel();
        _this._wheels.rear.left.anchor = new PIXI.Point(0.5, 0.5);
        _this._wheels.rear.left.offset = new PIXI.Point();
        _this._wheels.rear.left.looping = true;
        _this._wheels.rear.left.play();
        _this.addChild(_this._wheels.rear.left);

        /**
         * @member {p3.MovieClip}
         * @protected
         */
        _this._wheels.rear.right = _this.createRearWheel();
        _this._wheels.rear.right.anchor = new PIXI.Point(0.5, 0.5);
        _this._wheels.rear.right.offset = new PIXI.Point();
        _this._wheels.rear.right.looping = true;
        _this._wheels.rear.right.scale.x = -1;
        _this._wheels.rear.right.play();
        _this.addChild(_this._wheels.rear.right);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._back = _this.createBackLayer();
        _this._back.anchor = new PIXI.Point(0.5, 0.5);
        _this._back.offset = new PIXI.Point();
        _this.addChild(_this._back);
        return _this;
    }

    /**
     */


    _createClass(RaceCarView, [{
        key: "init",
        value: function init() {}

        /**
         * @param destroyChildren
         */

    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {
            this.stopEngine();
        }

        /**
         * @param {number} dt
         * @param {number} distance
         * @param {number} curvature
         * @param {number} gradient
         * @param {number} velocity
         * @param {number} turnVelocity
         * @param {number} jumpOffset
         */

    }, {
        key: "update",
        value: function update(dt, distance, curvature, gradient, velocity, turnVelocity, jumpOffset) {
            if (this._shadow) {
                this._shadow.alpha = 1 - jumpOffset * 0.8;
            }
        }

        /**
         */

    }, {
        key: "startEngine",
        value: function startEngine() {
            this.stopEngine();

            TweenMax.to(this._front.scale, 0.04, {
                y: this._front.scale.y - 0.04,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._back.offset, 0.03, {
                y: this._back.offset.y - 4.0,
                yoyo: true,
                repeat: -1
            });

            TweenMax.to(this._back.scale, 0.04, {
                delay: 0.02,
                y: this._back.scale.y - 0.02,
                yoyo: true,
                repeat: -1
            });
        }

        /**
         */

    }, {
        key: "stopEngine",
        value: function stopEngine() {
            TweenMax.killTweensOf(this._front.scale);
            TweenMax.killTweensOf(this._back.offset);
            TweenMax.killTweensOf(this._back.scale);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createFrontLayer",
        value: function createFrontLayer() {
            return new PIXI.Sprite();
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createBackLayer",
        value: function createBackLayer() {
            return new PIXI.Sprite();
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createFrontWheel",
        value: function createFrontWheel() {
            var sequence = new p3.MovieClipSequence();
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {p3.MovieClip}
         */

    }, {
        key: "createRearWheel",
        value: function createRearWheel() {
            var sequence = new p3.MovieClipSequence();
            return new p3.MovieClip(sequence);
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "createShadow",
        value: function createShadow() {
            return new PIXI.Sprite(PIXI.Texture.EMPTY);
        }

        /**
         */

    }, {
        key: "showBubblesEffect",
        value: function showBubblesEffect() {}

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "front",
        get: function get() {
            return this._front;
        }

        /**
         * @returns {PIXI.Sprite}
         */

    }, {
        key: "back",
        get: function get() {
            return this._back;
        }
    }]);

    return RaceCarView;
}(PIXI.Container);

exports.default = RaceCarView;

},{"../Common":7}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  RaceCollision
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @memberOf race
 */
var RaceCollision =
/**
 * @param {boolean} [left=false]
 * @param {boolean} [right=false]
 * @param {boolean} [top=false]
 * @param {boolean} [bottom=false]
 */
function RaceCollision() {
  var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var bottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  _classCallCheck(this, RaceCollision);

  /**
   * @member {boolean}
   * @default false
   */
  this.left = left;

  /**
   * @member {boolean}
   * @default false
   */
  this.right = right;

  /**
   * @member {boolean}
   * @default false
   */
  this.top = top;

  /**
   * @member {boolean}
   * @default false
   */
  this.bottom = bottom;
};

exports.default = RaceCollision;

},{}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  RaceEngine
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 20/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Point = require("./Point4");

var _Point2 = _interopRequireDefault(_Point);

var _RaceCamera = require("./RaceCamera");

var _RaceCamera2 = _interopRequireDefault(_RaceCamera);

var _RaceCollision = require("./RaceCollision");

var _RaceCollision2 = _interopRequireDefault(_RaceCollision);

var _RaceEntity = require("./RaceEntity");

var _RaceEntity2 = _interopRequireDefault(_RaceEntity);

var _RaceSegment = require("./RaceSegment");

var _RaceSegment2 = _interopRequireDefault(_RaceSegment);

var _RaceTrack = require("./RaceTrack");

var _RaceTrack2 = _interopRequireDefault(_RaceTrack);

var _RaceView = require("./RaceView");

var _RaceView2 = _interopRequireDefault(_RaceView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf race
 */
var RaceEngine = function () {
    /**
     * @param {RaceTrack} track
     * @param {RaceView} view
     */
    function RaceEngine(track, view) {
        _classCallCheck(this, RaceEngine);

        /**
         * @member {RaceCamera}
         * @private
         */
        this._camera = null;

        /**
         * @member {RaceTrack}
         * @private
         */
        this._track = track;

        /**
         * @member {RaceView}
         * @private
         */
        this._view = view;

        /**
         * @member {Array.<RaceSegment>}
         * @private
         */
        this._trackSegments = [];

        /**
         * @member {Array.<number>}
         * @private
         */
        this._trackGradients = [];

        /**
         * @member {Array}
         * @private
         */
        this._trackCells = [];

        /**
         * @member {Array.<RaceEntity>}
         * @private
         */
        this._entities = [];

        /**
         * @member {Array}
         * @private
         */
        this._tempCache = [];
    }

    _createClass(RaceEngine, [{
        key: "init",
        value: function init() {
            this._camera = new _RaceCamera2.default();

            for (var i = 0; i < this.track.length; ++i) {
                var data = this.track.textures[i];
                var segment = new _RaceSegment2.default(RaceEngine.getTexture(data.rM), RaceEngine.getTexture(data.rL), RaceEngine.getTexture(data.rR), RaceEngine.getTexture(data.sL), RaceEngine.getTexture(data.sR));
                segment.worldPosition = new _Point2.default(this.track.track[i].x, this.track.track[i].y, this.track.track[i].h);
                segment.distance = i;
                segment.view.visible = false;
                this._view.addChildAt(segment.view, 0);
                this._trackSegments.push(segment);
                this._trackCells.push([]);
            }
            for (var _i = 0; _i < this._trackSegments.length; ++_i) {
                var _segment = this._trackSegments[_i];
                _segment.next = _i < this._trackSegments.length - 1 ? this._trackSegments[_i + 1] : this._trackSegments[0];
                _segment.previous = _i > 0 ? this._trackSegments[_i - 1] : this._trackSegments[this._trackSegments.length - 1];
            }
            this.calculateTrackGradients();
        }

        /**
         * @param {RaceEntity} entity
         * @param {!number} [distance=0]
         * @param {boolean} [cached=false]
         */

    }, {
        key: "addEntity",
        value: function addEntity(entity) {
            var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var cached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (this._entities.indexOf(entity) !== -1) {
                this.removeEntity(entity);
            }

            entity.engine = this;
            entity.distance = distance;
            entity.worldPosition = this.getPointAt(distance, 0);
            entity.view.visible = !cached;
            this._view.addChild(entity.view);

            entity.init();

            if (cached) {
                this._trackCells[Math.floor(entity.distance)].push(entity);
            } else {
                this.updateTransform(entity);
                this._view.updateRoadEntity(entity);
                this._entities.push(entity);
            }
        }

        /**
         * @param {RaceEntity} entity
         * @param {boolean} [destroy=false]
         */

    }, {
        key: "removeEntity",
        value: function removeEntity(entity) {
            var destroy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            for (var i = 0; i < this._entities.length; ++i) {
                if (this._entities[i] === entity) {
                    destroy && entity.destroy();
                    this._entities.splice(i, 1);
                }
            }
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            for (var i = 0; i < this._tempCache.length; ++i) {
                var temp = this._tempCache[i];
                temp.view.visible = false;
            }
            this._tempCache.length = 0;

            // update entities - non cached
            for (var _i2 = this._entities.length - 1; _i2 >= 0; --_i2) {
                var entity = this._entities[_i2];
                if (entity.destroyNextFrame) {
                    entity.destroy();
                    this._entities.splice(_i2, 1);
                } else {
                    entity.preTransform();
                    entity.type === _RaceEntity2.default.TYPE_MOVING && entity.update(dt);

                    // loops distance to allow for laps
                    entity.distance %= this.track.length;

                    // updates 3d position in world based on distance
                    entity.worldPosition = this.getPointAt(entity.distance, 0);
                    entity.position = RaceEngine.shiftAndRotate(entity.worldPosition, this._camera.position.x, this._camera.position.y, -this._camera.angle);
                    entity.screenPosition = this.getProjectionFrom3d(entity.position);
                    if (entity.zDepth !== 0) {
                        entity.screenPosition.x += entity.offset.x / entity.zDepth;
                        entity.screenPosition.y += entity.offset.y / entity.zDepth;
                    }

                    entity.postTransform();
                }
            }

            this.updateCamera(dt);

            var d = this._camera.target ? Math.floor(this._camera.target.distance) : 0;
            var start = d - 1;
            start = start < 0 ? start + this._track.length : start;
            var end = start + this._view.drawDistance * 2;

            // update cached entities
            for (var _i3 = start; _i3 < end; ++_i3) {
                var cell = this._trackCells[_i3 % this._track.length];
                for (var j = 0; j < cell.length; ++j) {
                    var _entity = cell[j];
                    if (_entity.type === _RaceEntity2.default.TYPE_MOVING) {
                        _entity.update(dt);
                    }

                    // loops distance to allow for laps
                    _entity.distance %= this.track.length;

                    // updates 3d position in world based on distance
                    _entity.worldPosition = this.getPointAt(_entity.distance, 0);
                    _entity.position = RaceEngine.shiftAndRotate(_entity.worldPosition, this._camera.position.x, this._camera.position.y, -this._camera.angle);
                    _entity.screenPosition = this.getProjectionFrom3d(_entity.position);
                    if (_entity.zDepth !== 0) {
                        _entity.screenPosition.x += _entity.offset.x / _entity.zDepth;
                        _entity.screenPosition.y += _entity.offset.y / _entity.zDepth;
                    }
                    this._tempCache.push(_entity);
                }
            }

            for (var _i4 = start; _i4 < end; ++_i4) {
                var segment = this._trackSegments[_i4 % this._track.length];
                segment.position = RaceEngine.shiftAndRotate(segment.worldPosition, this._camera.position.x, this._camera.position.y, -this._camera.angle);
                segment.screenPosition = this.getProjectionFrom3d(segment.position);
                segment.width = this._view.segmentWidth / segment.zDepth;
                this._tempCache.push(segment);
            }

            // sort z depths
            this.sortDepths();

            // update entity views - cached
            for (var _i5 = 0; _i5 < this._entities.length; ++_i5) {
                var _entity2 = this._entities[_i5];
                this._view.updateRoadEntity(_entity2);
            }

            // update cached entity views
            for (var _i6 = start; _i6 < end; ++_i6) {
                var _cell = this._trackCells[_i6 % this._track.length];
                for (var _j = 0; _j < _cell.length; ++_j) {
                    var _entity3 = _cell[_j];
                    this._view.updateRoadEntity(_entity3);
                }
            }

            // update road segment views
            for (var _i7 = start; _i7 < end; ++_i7) {
                var _segment2 = this._trackSegments[_i7 % this._track.length];
                var heading = this._camera.target && this._camera.target.getHeading ? this._camera.target.getHeading() : null;
                this._view.updateRoadSegment(_segment2, heading);
            }
        }

        /**
         * @param {RaceEntity} entity
         */

    }, {
        key: "updateTransform",
        value: function updateTransform(entity) {
            // loops distance to allow for laps
            entity.distance %= this.track.length;

            // updates 3d position in world based on distance
            entity.worldPosition = this.getPointAt(entity.distance, 0);
            entity.position = RaceEngine.shiftAndRotate(entity.worldPosition, this._camera.position.x, this._camera.position.y, -this._camera.angle);
            entity.screenPosition = this.getProjectionFrom3d(entity.position);
            if (entity.zDepth !== 0) {
                entity.screenPosition.x += entity.offset.x / entity.zDepth;
                entity.screenPosition.y += entity.offset.y / entity.zDepth;
            }
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "updateCamera",
        value: function updateCamera(dt) {
            if (!this._camera.target) return;

            var position = this.getPointAt(this._camera.target.distance - this._camera.distance, 0);
            position.z = this._camera.target.worldPosition.z - this._camera.height;
            this._camera.offset.x = -this._camera.target.offset.x / 30;

            this._camera.position.x = position.x;
            this._camera.position.y = position.y;
            this._camera.position.z = position.z;
            this._camera.angle = position.w;

            if (this._camera.shakeDuration > 0) {
                if (this._camera.shakeElapsed < this._camera.shakeDuration) {
                    this._camera.shakeElapsed += dt;

                    var magnitude = this._camera.shakeMagnitiude;
                    this._camera.shake = new PIXI.Point(this._camera.shakeOffset.x + Math.random() * (magnitude - -magnitude) + -magnitude, this._camera.shakeOffset.y + Math.random() * (magnitude - -magnitude) + -magnitude);
                    this._view.x += (this._camera.shake.x - this._view.x) * this._camera.shakeEase;
                    this._view.y += (this._camera.shake.y - this._view.y) * this._camera.shakeEase;
                } else this._camera.shakeDuration = 0;
            }

            var curve = this.getTrackCurvature(this._camera.target.distance);
            var coef = (this._camera.target.velocity ? this._camera.target.velocity : 0) / 4;
            var ease = curve * this._camera.tilt - this.view.rotation;
            this.view.rotation += ease * this._camera.tiltEase * coef;
        }
    }, {
        key: "sortDepths",
        value: function sortDepths() {
            var depth = this._entities.concat(this._tempCache);
            depth.sort(function (a, b) {
                return b.zDepth - b.zDepthOffset - (a.zDepth - a.zDepthOffset);
            });
            for (var i = depth.length - 1; i >= 0; --i) {
                this.view.addChildAt(depth[i].view, 0);
            }
        }
    }, {
        key: "calculateTrackGradients",
        value: function calculateTrackGradients() {
            this._trackGradients = [];

            for (var i = 0; i < this.track.length; ++i) {
                var h1 = this.track.track[i].h;
                var h2 = i === this.track.length - 1 ? this.track.track[0].h : this.track.track[i + 1].h;
                this._trackGradients.push(h1 - h2);
            }
        }

        /**
         * @param {!number} l
         * @param {!number} [focus=0]
         * @returns {Point4}
         */

    }, {
        key: "getPointAt",
        value: function getPointAt(l) {
            var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            if (l < 0) l += this.track.length;

            var index = Math.floor(l);
            var w2 = l % 1;
            var w1 = 1 - w2;

            var i1 = index;
            var i2 = index + 1;
            i1 %= this.track.length;
            i2 %= this.track.length;

            var w3 = (l + focus) % 1;
            var w4 = 1 - w3;

            index = Math.floor(l + focus);
            var i3 = index;
            var i4 = index + 1;
            i3 %= this.track.length;
            i4 %= this.track.length;

            var p1 = this.track.track[i1];
            var p2 = this.track.track[i2];
            var p3 = this.track.track[i3];
            var p4 = this.track.track[i4];

            return new _Point2.default(w1 * p1.x + w2 * p2.x, w1 * p1.y + w2 * p2.y, w4 * p3.h + w3 * p4.h, RaceEngine.angleAverage(p1.a, p2.a, w1, w2));
        }

        /**
         * @param point
         * @returns {PIXI.Point}
         */

    }, {
        key: "getProjectionFrom3d",
        value: function getProjectionFrom3d(point) {
            var z = point.x;
            var y = -point.z * 40;
            var x = point.y;
            var fov = -this._camera.position.z * 40 + this._camera.fieldOfView;
            return new PIXI.Point(this._camera.zoom * (x * 20 + this._camera.offset.x) / z + this._camera.vanishingPoint.x, -this._camera.zoom * (y - fov) / z + this._camera.vanishingPoint.y);
        }

        /**
         * @param {!number} distance
         * @returns {number}
         */

    }, {
        key: "getTrackCurvature",
        value: function getTrackCurvature(distance) {
            var a1 = this.track.track[Math.floor(distance) % this.track.length].a;
            var a2 = this.track.track[Math.floor(distance + 1) % this.track.length].a;
            var diff = a2 - a1;
            diff = Math.max(-Math.PI * 2, Math.min(Math.PI * 2, diff));
            if (diff > Math.PI) {
                diff -= Math.PI * 2;
            } else if (diff < -Math.PI) {
                diff += Math.PI * 2;
            }
            return diff;
        }

        /**
         * @param {!number} distance
         * @param {number} [samples=3]
         * @returns {number}
         */

    }, {
        key: "getAverageTrackCurvature",
        value: function getAverageTrackCurvature(distance) {
            var samples = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

            if (distance < 0) {
                distance += this.track.length;
            }
            var average = 0;
            for (var i = 0; i < samples; ++i) {
                average += this.getTrackCurvature(distance + i);
            }

            // todo COULD BE THE CAUSE OF THE BUG

            return average / samples;
        }

        /**
         * @param {!number} distance
         * @returns {number}
         */

    }, {
        key: "getTrackGradient",
        value: function getTrackGradient(distance) {
            var g1 = this._trackGradients[Math.floor(distance) % this.track.length];
            var g2 = this._trackGradients[Math.ceil(distance) % this.track.length];
            var w1 = distance % 1;
            var w2 = 1 - w1;
            return w2 * g1 + w1 * g2;
        }

        /**
         * @param {PIXI.Point} p1
         * @param {PIXI.Point} p2
         * @param {PIXI.Point} size1
         * @param {PIXI.Point} size2
         * @returns {RaceCollision}
         */

    }, {
        key: "testCollision",
        value: function testCollision(p1, p2, size1, size2) {
            var w = (size1.x + size2.x) * 0.5;
            var h = size1.y + size2.y;
            var dx = p1.x - p2.x;
            var dy = (p1.y - p2.y) * this._view.segmentHeight;

            var collision = void 0;
            if (Math.abs(dx) < w && Math.abs(dy) < h) {
                collision = new _RaceCollision2.default();

                var wy = w * dy;
                var hx = h * dx;
                if (wy > hx) {
                    if (wy > -hx) collision.top = true;else collision.left = true;
                } else {
                    if (wy > -hx) collision.right = true;else collision.bottom = true;
                }
            }
            return collision;
        }

        /**
         * @static
         * @param {string} url
         * @returns {PIXI.Texture}
         */

    }, {
        key: "camera",


        /**
         * @returns {RaceCamera}
         */
        get: function get() {
            return this._camera;
        }

        /**
         * @returns {RaceTrack}
         */

    }, {
        key: "track",
        get: function get() {
            return this._track;
        }

        /**
         * @returns {RaceView}
         */

    }, {
        key: "view",
        get: function get() {
            return this._view;
        }
    }], [{
        key: "getTexture",
        value: function getTexture(url) {
            return PIXI.Texture.EMPTY;
        }

        /**
         * @static
         * @param {Point4} point
         * @param {number} angle
         */

    }, {
        key: "rotateAboutOrigin",
        value: function rotateAboutOrigin(point, angle) {
            var x = point.x * Math.cos(angle) - point.y * Math.sin(angle);
            var y = point.y * Math.cos(angle) + point.x * Math.sin(angle);
            point.x = x;
            point.y = y;
            point.w = point.w + angle;
        }

        /**
         * @static
         * @param {Point4} point
         * @param {number} x
         * @param {number} y
         * @param {number} angle
         * @returns {Point4}
         */

    }, {
        key: "shiftAndRotate",
        value: function shiftAndRotate(point, x, y, angle) {
            point = point.clone();
            point.x -= x;
            point.y -= y;
            RaceEngine.rotateAboutOrigin(point, angle);
            return point;
        }

        /**
         * @static
         * @param {number} theta1
         * @param {number} theta2
         * @param {number} w1
         * @param {number} w2
         * @returns {number}
         */

    }, {
        key: "angleAverage",
        value: function angleAverage(theta1, theta2, w1, w2) {
            var x = w1 * Math.cos(theta1) + w2 * Math.cos(theta2);
            var y = w1 * Math.sin(theta1) + w2 * Math.sin(theta2);
            return Math.atan2(y, x);
        }
    }]);

    return RaceEngine;
}();

exports.default = RaceEngine;

},{"./Point4":51,"./RaceCamera":52,"./RaceCollision":55,"./RaceEntity":57,"./RaceSegment":59,"./RaceTrack":61,"./RaceView":62}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  RaceEntity
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  Created by Legman on 21/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _Point = require("./Point4");

var _Point2 = _interopRequireDefault(_Point);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf race
 */
var RaceEntity = function () {
  /**
   * @param {number} [type]
   * @param {PIXI.DisplayObject} [view]
   */
  function RaceEntity(type, view) {
    _classCallCheck(this, RaceEntity);

    /**
     * @member {*}
     */
    this.signals = {};

    /**
     * @member {RaceEngine}
     */
    this.engine = null;

    /**
     * @member {PIXI.Point}
     */
    this.screenPosition = new PIXI.Point();

    /**
     * @member {Point4}
     */
    this.position = new _Point2.default();

    /**
     * @member {Point4}
     */
    this.worldPosition = new _Point2.default();

    /**
     * @member {number}
     */
    this.distance = 0;

    /**
     * @member {PIXI.Point}
     */
    this.offset = new PIXI.Point();

    /**
     * @member {PIXI.Point}
     */
    this.scale = new PIXI.Point(1, 1);

    /**
     * @member {number}
     * @default 1
     */
    this.alpha = 1;

    /**
     * @member {boolean}
     * @default true
     */
    this.renderToWorld = true;

    /**
     * @member {number}
     * @default 0
     */
    this.zDepthOffset = 0;

    /**
     * @member {number}
     * @default 0
     */
    this.collisionWidth = 0;

    /**
     * @member {number}
     * @default 0
     */
    this.collisionLength = 0;

    /**
     * @member {boolean}
     * @default 0
     */
    this.destroyNextFrame = false;

    /**
     * @member {number}
     * @protected
     */
    this._type = type;

    /**
     * @member {PIXI.DisplayObject}
     * @protected
     */
    this._view = view;
  }

  /**
   */


  _createClass(RaceEntity, [{
    key: "init",
    value: function init() {}

    /**
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this._view.parent && this._view.parent.removeChild(this._view);
      this.engine = null;
    }

    /**
     */

  }, {
    key: "preTransform",
    value: function preTransform() {}

    /**
     * @param {number} dt
     */

  }, {
    key: "update",
    value: function update(dt) {}

    /**
     */

  }, {
    key: "postTransform",
    value: function postTransform() {}

    /**
     * @returns {number}
     */

  }, {
    key: "type",
    get: function get() {
      return this._type;
    }

    /**
     * @returns {PIXI.DisplayObject}
     */

  }, {
    key: "view",
    get: function get() {
      return this._view;
    }

    /**
     * @returns {number}
     */

  }, {
    key: "zDepth",
    get: function get() {
      return this.position.x;
    }
  }]);

  return RaceEntity;
}();

/**
 * @static
 * @type {number}
 * @const
 */


exports.default = RaceEntity;
RaceEntity.TYPE_STATIC = 0;

/**
 * @static
 * @type {number}
 * @const
 */
RaceEntity.TYPE_MOVING = 1;

/**
 * @static
 * @type {number}
 * @const
 */
RaceEntity.TYPE_SEGMENT = 2;

},{"./Point4":51}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Point = require("./Point4");

var _Point2 = _interopRequireDefault(_Point);

var _RaceEntity2 = require("./RaceEntity");

var _RaceEntity3 = _interopRequireDefault(_RaceEntity2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  RaceMover
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 21/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceEntity
 * @memberOf race
 */
var RaceMover = function (_RaceEntity) {
    _inherits(RaceMover, _RaceEntity);

    /**
     * @param {DisplayObject} view
     */
    function RaceMover(view) {
        _classCallCheck(this, RaceMover);

        /**
         * @member {signals.Signal}
         */
        var _this = _possibleConstructorReturn(this, (RaceMover.__proto__ || Object.getPrototypeOf(RaceMover)).call(this, _RaceEntity3.default.TYPE_MOVING, view));

        _this.signals.lap = new signals.Signal();

        /**
         * @member {number}
         */
        _this.acceleration = 0;

        /**
         * @member {number}
         */
        _this.turnAccel = 0;

        /**
         * @member {number}
         */
        _this.turnSpeed = 0;

        /**
         * @member {number}
         */
        _this.velocity = 0;

        /**
         * @member {number}
         */
        _this.turnVelocity = 0;

        /**
         * @member {number}
         */
        _this.linearDamping = 0.99;

        /**
         * @member {number}
         */
        _this.turnDamping = 0.99;

        /**
         * @member {boolean}
         */
        _this.moving = false;

        /**
         * @member {number}
         */
        _this.lap = 0;

        /**
         * @member {Point4}
         * @protected
         */
        _this._heading = new _Point2.default();

        /**
         * @type {number}
         * @protected
         */
        _this._lastDistance = 0;
        return _this;
    }

    /**
     */


    _createClass(RaceMover, [{
        key: "init",
        value: function init() {
            this._lastDistance = this.distance;
        }

        /**
         */

    }, {
        key: "destroy",
        value: function destroy() {
            this.signals.lap.dispose();

            _get(RaceMover.prototype.__proto__ || Object.getPrototypeOf(RaceMover.prototype), "destroy", this).call(this);
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            _get(RaceMover.prototype.__proto__ || Object.getPrototypeOf(RaceMover.prototype), "update", this).call(this, dt);

            this.moving && (this.velocity += this.acceleration * dt);
            this.velocity *= this.linearDamping;
            this.distance += this.velocity * dt;

            this.turnVelocity += this.turnSpeed * dt;
            this.turnVelocity *= this.turnDamping;
            this.offset.x += this.turnVelocity * dt;

            if (Math.abs(this.velocity) < 0.01) this.velocity = 0;
            if (Math.abs(this.turnVelocity) < 0.01) this.turnVelocity = 0;
        }

        /**
         */

    }, {
        key: "postTransform",
        value: function postTransform() {
            this.updateLap();
        }

        /**
         */

    }, {
        key: "updateLap",
        value: function updateLap() {
            if (this.distance < this._lastDistance) {
                ++this.lap;
                this.signals.lap.dispatch(this, this.lap);
            }
            this._lastDistance = this.distance;
        }

        /**
         * @returns {Point4}
         */

    }, {
        key: "getHeading",
        value: function getHeading() {
            var p1 = this.worldPosition;
            var p2 = this.engine.getPointAt(this.distance + Math.max(0.001, this.velocity));

            this._heading.x = p2.x - p1.x;
            this._heading.y = p2.y - p1.y;
            this._heading.z = p2.z - p1.z;
            this._heading.w = 1;

            var length = Math.sqrt(this._heading.x * this._heading.x + this._heading.y * this._heading.y + this._heading.z * this._heading.z);

            this._heading.x /= length;
            this._heading.y /= length;
            this._heading.z /= length;

            if (isNaN(this._heading.x + this._heading.y + this._heading.z)) {
                alert(length);
            }
            return this._heading;
        }

        /**
         * @param {RaceMover} mover
         * @returns {number}
         */

    }, {
        key: "getDotTo",
        value: function getDotTo(mover) {
            var h1 = this.getHeading();
            var h2 = mover.getHeading();
            return h1.x * h2.x + h1.y * h2.y;
        }

        /**
         * @param {RaceCar} mover
         * @returns {number}
         */

    }, {
        key: "getPerpTo",
        value: function getPerpTo(mover) {
            var h1 = this.getHeading();
            var h2 = mover.getHeading();
            return h1.y * h2.x + -h1.x * h2.y;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "getTotalDistance",
        value: function getTotalDistance() {
            var d = this.distance;
            var l = this.engine.track.length * this.lap;
            return d + l;
        }

        /**
         * @param {RaceMover} mover
         */

    }, {
        key: "getDistanceTo",
        value: function getDistanceTo(mover) {
            var a = this.getTotalDistance();
            var b = mover.getTotalDistance();
            var diff = b - a;

            var sign = diff !== 0 ? diff / Math.abs(diff) : 0;
            if (sign === -1) {
                while (diff < this.engine.track.length * -0.5) {
                    diff += this.engine.track.length;
                }
            } else if (sign === 1) {
                while (diff > this.engine.track.length * 0.5) {
                    diff -= this.engine.track.length;
                }
            }
            return diff;
        }
    }]);

    return RaceMover;
}(_RaceEntity3.default);

exports.default = RaceMover;

},{"./Point4":51,"./RaceEntity":57}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Point = require("./Point4");

var _Point2 = _interopRequireDefault(_Point);

var _RaceEntity2 = require("./RaceEntity");

var _RaceEntity3 = _interopRequireDefault(_RaceEntity2);

var _RaceSegmentQuad = require("./RaceSegmentQuad");

var _RaceSegmentQuad2 = _interopRequireDefault(_RaceSegmentQuad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  RaceSegment
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 21/03/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends RaceEntity
 * @memberOf race
 */
var RaceSegment = function (_RaceEntity) {
        _inherits(RaceSegment, _RaceEntity);

        /**
         * @param {PIXI.Texture} roadMiddleTexture
         * @param {PIXI.Texture} [roadLeftTexture]
         * @param {PIXI.Texture} [roadRightTexture]
         * @param {PIXI.Texture} [grassLeftTexture]
         * @param {PIXI.Texture} [grassRightTexture]
         */
        function RaceSegment(roadMiddleTexture, roadLeftTexture, roadRightTexture, grassLeftTexture, grassRightTexture) {
                _classCallCheck(this, RaceSegment);

                // middle road segment
                var view = new PIXI.Sprite(roadMiddleTexture);

                // left grass segment
                view.grassLeft = new PIXI.Sprite(grassLeftTexture);
                view.grassLeft.anchor.x = 1;
                view.addChild(view.grassLeft);

                // right grass segment
                view.grassRight = new PIXI.Sprite(grassRightTexture);
                view.addChild(view.grassRight);

                // left road segment
                view.left = new PIXI.Sprite(roadLeftTexture);
                view.left.y = view.left.height * 0.5;
                view.left.anchor.x = 1.0;
                view.left.anchor.y = 0.5;
                view.addChild(view.left);

                //right road segment
                view.right = new PIXI.Sprite(roadRightTexture);
                view.right.x = view.width;
                view.right.y = view.right.height * 0.5;
                view.right.anchor.y = 0.5;
                view.addChild(view.right);

                /**
                 * @member {RaceSegment}
                 */
                var _this = _possibleConstructorReturn(this, (RaceSegment.__proto__ || Object.getPrototypeOf(RaceSegment)).call(this, _RaceEntity3.default.TYPE_SEGMENT, view));

                _this.next = null;

                /**
                 * @member {RaceSegment}
                 */
                _this.previous = null;

                /**
                 * @member {number}
                 */
                _this.width = 0;

                /**
                 * @type {RaceSegmentQuad}
                 * @private
                 */
                _this._quad = new _RaceSegmentQuad2.default();

                /**
                 * @type {Point4}
                 * @private
                 */
                _this._heading = new _Point2.default();
                return _this;
        }

        /**
         * @returns {RaceSegmentQuad}
         */


        _createClass(RaceSegment, [{
                key: "getQuad",
                value: function getQuad() {
                        this._quad.topLeft.x = this.screenPosition.x - this.width;
                        this._quad.topLeft.y = this.screenPosition.y;
                        this._quad.topRight.x = this.screenPosition.x + this.width;
                        this._quad.topRight.y = this.screenPosition.y;
                        this._quad.bottomLeft.x = this.previous.screenPosition.x - this.previous.width;
                        this._quad.bottomLeft.y = this.previous.screenPosition.y;
                        this._quad.bottomRight.x = this.previous.screenPosition.x + this.previous.width;
                        this._quad.bottomRight.y = this.previous.screenPosition.y;
                        return this._quad;
                }

                /**
                 * @returns {Point4}
                 */

        }, {
                key: "getHeading",
                value: function getHeading() {
                        this._heading.x = this.next.worldPosition.x - this.worldPosition.x;
                        this._heading.y = this.next.worldPosition.y - this.worldPosition.y;
                        this._heading.z = this.next.worldPosition.z - this.worldPosition.z;
                        this._heading.w = 1;

                        var length = Math.sqrt(this._heading.x * this._heading.x + this._heading.y * this._heading.y + this._heading.z * this._heading.z);

                        this._heading.x /= length;
                        this._heading.y /= length;
                        this._heading.z /= length;
                        return this._heading;
                }
        }]);

        return RaceSegment;
}(_RaceEntity3.default);

exports.default = RaceSegment;

},{"./Point4":51,"./RaceEntity":57,"./RaceSegmentQuad":60}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  RaceSegmentQuad
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @memberOf race
 */
var RaceSegmentQuad = function () {
  /**
   * @param {PIXI.Point} [topLeft]
   * @param {PIXI.Point} [topRight]
   * @param {PIXI.Point} [bottomLeft]
   * @param {PIXI.Point} [bottomRight]
   */
  function RaceSegmentQuad(topLeft, topRight, bottomLeft, bottomRight) {
    _classCallCheck(this, RaceSegmentQuad);

    /**
     * @member {PIXI.Point}
     */
    this.topLeft = topLeft || new PIXI.Point();

    /**
     * @member {PIXI.Point}
     */
    this.topRight = topRight || new PIXI.Point();

    /**
     * @member {PIXI.Point}
     */
    this.bottomLeft = bottomLeft || new PIXI.Point();

    /**
     * @member {PIXI.Point}
     */
    this.bottomRight = bottomRight || new PIXI.Point();
  }

  /**
   * @returns {RaceSegmentQuad}
   */


  _createClass(RaceSegmentQuad, [{
    key: "clone",
    value: function clone() {
      return new RaceSegmentQuad(this.topLeft, this.topRight, this.bottomLeft, this.bottomRight);
    }
  }]);

  return RaceSegmentQuad;
}();

exports.default = RaceSegmentQuad;

},{}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  RaceTrack
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @memberOf race
 */
var RaceTrack = function () {
  /**
   * @param {*} data
   */
  function RaceTrack(data) {
    _classCallCheck(this, RaceTrack);

    /**
     * @member {*}
     */
    this.meta = data.meta;

    /**
     * @member {*}
     */
    this.objects = data.objects;

    /**
     * @member {*}
     */
    this.track = data.track;

    /**
     * @member {*}
     */
    this.textures = data.textures;
  }

  /**
   * @returns {string}
   */


  _createClass(RaceTrack, [{
    key: "name",
    get: function get() {
      return this.meta.name;
    }

    /**
     * @returns {number}
     */

  }, {
    key: "length",
    get: function get() {
      return this.track.length;
    }
  }]);

  return RaceTrack;
}();

exports.default = RaceTrack;

},{}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  RaceView
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @extends PIXI.Container
 * @memberOf race
 */
var RaceView = function (_PIXI$Container) {
        _inherits(RaceView, _PIXI$Container);

        /**
         * @param {number} [segmentWidth=830]
         * @param {number} [segmentHeight=136]
         */
        function RaceView() {
                var segmentWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 830;
                var segmentHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 136;

                _classCallCheck(this, RaceView);

                /**
                 * @member {number}
                 * @private
                 * @default 830
                 */
                var _this = _possibleConstructorReturn(this, (RaceView.__proto__ || Object.getPrototypeOf(RaceView)).call(this));

                _this._segmentWidth = segmentWidth;

                /**
                 * @member {number}
                 * @private
                 * @default 136
                 */
                _this._segmentHeight = segmentHeight;

                /**
                 * @type {number}
                 * @default 14
                 */
                _this.drawDistance = 14;
                return _this;
        }

        /**
         * @param {RaceEntity} entity
         */


        _createClass(RaceView, [{
                key: "updateRoadEntity",
                value: function updateRoadEntity(entity) {
                        if (!entity.renderToWorld) return;

                        if (entity.zDepth > this.drawDistance) {
                                entity.view.visible = false;
                                return;
                        }

                        entity.view.x = entity.screenPosition.x;
                        entity.view.y = entity.screenPosition.y;

                        var inv = 1 / entity.zDepth;
                        entity.view.scale.x = inv * entity.scale.x;
                        entity.view.scale.y = inv * entity.scale.y;
                        entity.view.visible = (entity.view.scale.x * (1 / entity.scale.x) > 0 && entity.view.scale.y * (1 / entity.scale.y)) > 0;

                        var frac = (this.drawDistance - entity.zDepth) / (this.drawDistance * 0.05);
                        entity.view.alpha = Math.max(0, Math.min(1, frac)) * entity.alpha;
                }

                /**
                 * @param {RaceSegment} segment
                 * @param {Point4} [heading]
                 */

        }, {
                key: "updateRoadSegment",
                value: function updateRoadSegment(segment, heading) {
                        if (segment.zDepth < 0.7 || segment.zDepth > this.drawDistance) {
                                segment.view.visible = false;
                                return;
                        }

                        if (heading) {
                                var h = segment.getHeading();
                                var dot = h.x * heading.x + h.y * heading.y + h.z * heading.z;
                                if (dot < 0.1) {
                                        segment.view.visible = false;
                                        return;
                                }
                        }

                        var quad = segment.getQuad();
                        segment.view.x = quad.topLeft.x;
                        segment.view.y = quad.topLeft.y;

                        var sx = (quad.topRight.x - quad.topLeft.x) / this._segmentWidth;
                        var sy = (quad.bottomLeft.y - quad.topLeft.y) / this._segmentHeight;

                        segment.view.scale.x = sx * 2;
                        segment.view.scale.y = sy * 2;

                        var frac = (this.drawDistance - segment.zDepth) / (this.drawDistance * 0.05);
                        segment.view.alpha = Math.max(0, Math.min(1, frac));
                        segment.view.visible = true;

                        var sxl = (quad.topLeft.x - quad.bottomLeft.x) / 200;
                        var sxr = -(quad.topRight.x - quad.bottomRight.x) / 200;

                        var inv = 1 / sx;
                        sxl *= inv;
                        sxr *= inv;

                        if (segment.view.x + segment.view.texture.width * 0.5 * segment.view.scale.x > 0) {
                                segment.view.left.scale.x = Math.max(0, sxl);
                                segment.view.left.scale.y = sxl / Math.abs(sxl);

                                segment.view.right.scale.x = Math.abs(sxr);
                                segment.view.right.scale.y = sxr / Math.abs(sxr);
                        } else if (segment.view.x + segment.view.texture.width * 0.5 * segment.view.scale.x < 0) {
                                segment.view.left.scale.x = Math.abs(sxl);
                                segment.view.left.scale.y = sxl / Math.abs(sxl);

                                segment.view.right.scale.x = Math.max(0, sxr);
                                segment.view.right.scale.y = sxr / Math.abs(sxr);
                        }

                        segment.view.grassLeft.x = segment.view.left.x;
                        segment.view.grassRight.x = segment.view.right.x;

                        frac = 1 - (this.drawDistance - segment.zDepth) / (this.drawDistance * 1.04);
                        segment.view.grassLeft.scale.x = frac * 24;
                        segment.view.grassRight.scale.x = frac * 24;
                }

                /**
                 * @returns {number}
                 */

        }, {
                key: "segmentWidth",
                get: function get() {
                        return this._segmentWidth;
                }

                /**
                 * @returns {number}
                 */

        }, {
                key: "segmentHeight",
                get: function get() {
                        return this._segmentHeight;
                }
        }]);

        return RaceView;
}(PIXI.Container);

exports.default = RaceView;

},{}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  PreloaderScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 7/10/2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var BoomerangPreloaderScene = function (_p3$Scene) {
    _inherits(BoomerangPreloaderScene, _p3$Scene);

    function BoomerangPreloaderScene() {
        _classCallCheck(this, BoomerangPreloaderScene);

        /**
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, (BoomerangPreloaderScene.__proto__ || Object.getPrototypeOf(BoomerangPreloaderScene)).call(this));

        _this.loaded = 0;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._bar = null;

        /**
         * @member {PIXI.BitmapText}
         * @private
         */
        _this._text = null;

        /**
         *
         * @member {PIXI.extras.MovieClip}
         * @private
         */
        _this._logo = null;
        return _this;
    }

    _createClass(BoomerangPreloaderScene, [{
        key: "init",
        value: function init() {
            _get(BoomerangPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(BoomerangPreloaderScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var g = new PIXI.Graphics();
            g.clear();
            g.beginFill(0x872F87);
            g.drawRect(0, 0, _Common2.default.STAGE_WIDTH, _Common2.default.STAGE_HEIGHT);
            g.endFill();
            this.addChild(g);

            var holder = new PIXI.Container();
            holder.x = _Common2.default.STAGE_WIDTH * 0.5;
            holder.y = _Common2.default.STAGE_HEIGHT * 0.5 + 80;
            this.addChild(holder);

            var frames = [];
            for (var i = 1; i < 10; ++i) {
                frames.push(assets.getTexture("loader_animation000" + i));
            }
            frames.push(assets.getTexture("loader_animation0010"));

            var sequence = new p3.MovieClipSequence();
            sequence.addTextures(frames);

            this._logo = new p3.MovieClip(sequence);
            this._logo.x = 50;
            this._logo.y = 20;
            this._logo.anchor = new PIXI.Point(0.5, 1);
            this._logo.animationSpeed = 1 / 4;
            this._logo.looping = false;
            holder.addChild(this._logo);

            this._bar = new PIXI.Sprite(assets.getTexture("preloader_bg"));
            this._bar.y = 34;
            this._bar.anchor = new PIXI.Point(0.5, 0.5);
            holder.addChild(this._bar);

            this._bar.fill = new PIXI.Sprite(assets.getTexture("preloader_bar"));
            this._bar.fill.anchor = new PIXI.Point(0.5, 0.5);
            this._bar.addChild(this._bar.fill);

            this._bar.fill.mask = new PIXI.Graphics();
            this._bar.fill.mask.x = -this._bar.fill.texture.width * 0.5;
            this._bar.fill.mask.scale.x = 0;
            this._bar.fill.mask.beginFill(0xFF0000);
            this._bar.fill.mask.drawRect(0, -this._bar.fill.texture.height * 0.5, this._bar.fill.texture.width, this._bar.fill.texture.height);
            this._bar.fill.addChild(this._bar.fill.mask);

            this._bar.frame = new PIXI.Sprite(assets.getTexture("preloader_overlay"));
            this._bar.frame.anchor = new PIXI.Point(0.5, 0.5);
            this._bar.addChild(this._bar.frame);

            this._text = new PIXI.Text("0%", { fontSize: "32px", fontFamily: "Arial", fill: "#FFFFFF", align: "center" });
            this._text.y = this._bar.y + 60;
            this._text.pivot.x = this._text.width * 0.5;
            this._text.pivot.y = this._text.height * 0.5;
            holder.addChild(this._text);

            // google font loader
            var text = new PIXI.Text("", { fontSize: "1px", fontFamily: "Noto Kufi Arabic" });
            text.visible = false;
            this.addChild(text);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(BoomerangPreloaderScene.prototype.__proto__ || Object.getPrototypeOf(BoomerangPreloaderScene.prototype), "appear", this).call(this);

            this._logo.play();
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;
            //this.y = (p3.View.height - Common.STAGE_HEIGHT) * 0.5;
        }
    }, {
        key: "update",
        value: function update() {
            var loaded = Math.min(1, this.loaded);
            this._bar.fill.mask.scale.x += (loaded - this._bar.fill.mask.scale.x) * 0.4;

            this._text.text = "" + Math.round(loaded * 100) + "%";
            this._text.pivot.x = this._text.width * 0.5;
        }
    }]);

    return BoomerangPreloaderScene;
}(p3.Scene);

exports.default = BoomerangPreloaderScene;

},{"../Common":7}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  CharacterScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2016.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends p3.Scene
 */
var CharacterScene = function (_p3$Scene) {
    _inherits(CharacterScene, _p3$Scene);

    function CharacterScene() {
        _classCallCheck(this, CharacterScene);

        /**
         * @member {p3.Button}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (CharacterScene.__proto__ || Object.getPrototypeOf(CharacterScene)).call(this));

        _this._raceButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._homeButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._muteButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._nextButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._previousButton = null;

        /**
         * @member {number}
         * @private
         */
        _this._index = _Common2.default.playerDriverId;

        /**
         * @member {PIXI.Container}
         * @private
         */
        _this._nameplate = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._vehicle = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._driver = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._sidekick = null;
        return _this;
    }

    _createClass(CharacterScene, [{
        key: "init",
        value: function init() {
            _get(CharacterScene.prototype.__proto__ || Object.getPrototypeOf(CharacterScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(assets.getTexture("ui_char_bg"));
            this.addChild(bg);

            var holder = new PIXI.Container();
            holder.x = _Common2.default.STAGE_WIDTH * 0.5 - 100;
            holder.y = 480;
            this.addChild(holder);

            this._vehicle = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._vehicle.x = _Common2.default.STAGE_WIDTH * 0.5 - 100;
            this._vehicle.y = 480;
            this._vehicle.anchor = new PIXI.Point(0.5, 0.5);
            holder.addChild(this._vehicle);

            this._vehicle.shadow = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._vehicle.shadow.anchor = new PIXI.Point(0.5, 0.5);
            this._vehicle.shadow.blendMode = PIXI.BLEND_MODES.MULTIPLY;
            holder.addChildAt(this._vehicle.shadow, this._vehicle.parent.getChildIndex(this._vehicle));

            holder = new PIXI.Container();
            holder.y = p3.View.height;
            this.addChild(holder);

            this._sidekick = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._sidekick.anchor = new PIXI.Point(0.5, 1);
            holder.addChild(this._sidekick);

            this._driver = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._driver.anchor = new PIXI.Point(0.5, 1);
            holder.addChild(this._driver);

            this._nameplate = new PIXI.Sprite(assets.getTexture("ui_char_name_bg"));
            this._nameplate.x = _Common2.default.STAGE_WIDTH * 0.5 - 80;
            this._nameplate.y = 140;
            this._nameplate.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this._nameplate);

            if (language === "ar") {
                this._nameplate.first = new PIXI.Text("", {
                    fontSize: "36px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6 });
                this._nameplate.first.y = 3;
                this._nameplate.first.pivot.x = 160;
                this._nameplate.first.pivot.y = Math.round(this._nameplate.first.height * 0.8);
                this._nameplate.addChild(this._nameplate.first);
            } else {
                this._nameplate.first = new PIXI.BitmapText("", font(32, "center"));
                this._nameplate.first.y = 6;
                this._nameplate.first.pivot.x = 200 + 40;
                this._nameplate.first.pivot.y = Math.round(this._nameplate.first.textHeight * 0.8);
                this._nameplate.addChild(this._nameplate.first);
            }

            if (language === "ar") {
                this._nameplate.second = new PIXI.Text("", {
                    fontSize: "36px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6 });
                this._nameplate.second.y = 3;
                this._nameplate.second.pivot.x = 120;
                this._nameplate.addChild(this._nameplate.second);
            } else {
                this._nameplate.second = new PIXI.BitmapText("", font(32, "center"));
                this._nameplate.second.y = 6;
                this._nameplate.second.pivot.x = 120 + 40;
                this._nameplate.addChild(this._nameplate.second);
            }

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_big_out");
            states.over = assets.getTexture("ui_btn_big_over");
            states.down = assets.getTexture("ui_btn_big_down");
            states.icon = assets.getTexture("ui_icon_play");

            this._raceButton = new p3.Button(states);
            this._raceButton.visible = false;
            this._raceButton.interactive = false;
            this._raceButton.overSoundName = "sfx_btn_rollover_00";
            this._raceButton.clickSoundName = "sfx_btn_press_00";
            this._raceButton.signals.click.add(this.onRaceButtonClick, this);
            this.addChild(this._raceButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_out");
            states.over = assets.getTexture("ui_btn_over");
            states.down = assets.getTexture("ui_btn_down");
            states.icon = assets.getTexture("ui_icon_home");

            this._homeButton = new p3.Button(states);
            this._homeButton.visible = false;
            this._homeButton.interactive = false;
            this._homeButton.overSoundName = "sfx_btn_rollover_00";
            this._homeButton.clickSoundName = "sfx_btn_press_00";
            this._homeButton.signals.click.add(this.onHomeButtonClick, this);
            this.addChild(this._homeButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_out");
            states.over = assets.getTexture("ui_btn_over");
            states.down = assets.getTexture("ui_btn_down");
            states.icon = assets.getTexture("ui_icon_sound_on");
            states.iconAlt = assets.getTexture("ui_icon_sound_off");

            this._muteButton = new p3.MuteButton(states);
            this._muteButton.visible = false;
            this._muteButton.interactive = false;
            this._muteButton.overSoundName = "sfx_btn_rollover_00";
            this._muteButton.clickSoundName = "sfx_btn_press_00";
            this.addChild(this._muteButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_arrow_r");

            this._nextButton = new p3.Button(states);
            this._nextButton.visible = false;
            this._nextButton.interactive = false;
            this._nextButton.overSoundName = "sfx_btn_rollover_00";
            this._nextButton.clickSoundName = "sfx_btn_press_00";
            this._nextButton.signals.click.add(this.onNextButtonClick, this);
            this.addChild(this._nextButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_arrow_l");

            this._previousButton = new p3.Button(states);
            this._previousButton.visible = false;
            this._previousButton.interactive = false;
            this._previousButton.overSoundName = "sfx_btn_rollover_00";
            this._previousButton.clickSoundName = "sfx_btn_press_00";
            this._previousButton.signals.click.add(this.onPreviousButtonClick, this);
            this.addChild(this._previousButton);

            this.showCharacter(this._index);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            var input = _Common2.default.input;
            input.signals.swipeLeft.remove(this.onSwipeLeft, this);
            input.signals.swipeRight.remove(this.onSwipeRight, this);

            TweenMax.killTweensOf(this._driver.scale);
            TweenMax.killTweensOf(this._sidekick.scale);

            _get(CharacterScene.prototype.__proto__ || Object.getPrototypeOf(CharacterScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(CharacterScene.prototype.__proto__ || Object.getPrototypeOf(CharacterScene.prototype), "appear", this).call(this);

            var input = _Common2.default.input;
            input.signals.swipeLeft.add(this.onSwipeLeft, this);
            input.signals.swipeRight.add(this.onSwipeRight, this);

            _Common2.default.audio.playMusic("music_garage_loop_00");
            _Common2.default.audio.playSound("sfx_muttly_giggle_00");
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            this._homeButton.scale = new PIXI.Point();
            TweenMax.to(this._homeButton.scale, 0.4, {
                delay: 0.1,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._homeButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._homeButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._muteButton.scale = new PIXI.Point();
            TweenMax.to(this._muteButton.scale, 0.4, {
                delay: 0.1 + 0.06,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._muteButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._muteButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._previousButton.scale = new PIXI.Point();
            TweenMax.to(this._previousButton.scale, 0.4, {
                delay: 0.1 + 0.06 * 2,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [3],
                onStart: function onStart() {
                    this._previousButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._previousButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._nextButton.scale = new PIXI.Point();
            TweenMax.to(this._nextButton.scale, 0.4, {
                delay: 0.1 + 0.06 * 2,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [3],
                onStart: function onStart() {
                    this._nextButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._nextButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._raceButton.scale = new PIXI.Point();
            TweenMax.to(this._raceButton.scale, 0.4, {
                delay: 0.1 + 0.06 * 4,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [4],
                onStart: function onStart() {
                    this._raceButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._raceButton.interactive = true;
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;

            this._driver.parent.x = _Common2.default.STAGE_WIDTH * 0.5 + p3.View.width * 0.24;

            this._raceButton.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._raceButton.y = p3.View.height - 120;

            this._homeButton.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
            this._homeButton.y = 100;

            this._muteButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
            this._muteButton.y = 100;

            this._nextButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
            this._nextButton.y = _Common2.default.STAGE_HEIGHT * 0.5;

            this._previousButton.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
            this._previousButton.y = _Common2.default.STAGE_HEIGHT * 0.5;
        }
    }, {
        key: "update",
        value: function update() {
            var input = _Common2.default.input;
            if (input.isKeyPressed(37)) {
                this.onPreviousButtonClick(null);
            }
            if (input.isKeyPressed(39)) {
                this.onNextButtonClick(null);
            }
            if (input.isKeyPressed(32)) {
                this.onRaceButtonClick(null);
            }
        }

        /**
         * @param {number} index
         */

    }, {
        key: "showCharacter",
        value: function showCharacter(index) {
            var assets = _Common2.default.assets;
            var character = _Common2.default.config.characters[index];

            this._nameplate.first.text = translate(character.names.first);
            this._nameplate.second.text = translate(character.names.second);

            this._driver.texture = assets.getTexture(character.driver.texture);
            this._driver.x = character.driver.offset.x;
            this._driver.y = character.driver.offset.y;

            if (character.sidekick) {
                this._sidekick.texture = assets.getTexture(character.sidekick.texture);
                this._sidekick.x = character.sidekick.offset.x;
                this._sidekick.y = character.sidekick.offset.y;
            } else {
                this._sidekick.texture = PIXI.Texture.EMPTY;
            }

            this._vehicle.texture = assets.getTexture(character.vehicle.texture);
            this._vehicle.x = character.vehicle.offset.x;
            this._vehicle.y = character.vehicle.offset.y;

            this._vehicle.shadow.texture = assets.getTexture(character.vehicle.shadow.texture);
            this._vehicle.shadow.x = this._vehicle.x + character.vehicle.shadow.offset.x;
            this._vehicle.shadow.y = this._vehicle.y + character.vehicle.shadow.offset.y;

            // fade vehicle
            this._vehicle.alpha = 0;
            TweenMax.killTweensOf(this._vehicle);
            TweenMax.to(this._vehicle, 0.32, {
                alpha: 1,
                ease: Power1.easeInOut,
                onStart: function onStart() {
                    _Common2.default.audio.playSound("sfx_btn_nextcar_00");
                }
            });

            var tl = new TimelineMax();

            // bounce vehicle
            var to = this._vehicle.y;
            this._vehicle.y = this._vehicle.y - 160;
            tl.append(TweenMax.to(this._vehicle, 0.4, {
                y: to,
                ease: Power2.easeIn,
                onComplete: function onComplete() {
                    TweenMax.killTweensOf(this._vehicle.scale);
                    TweenMax.to(this._vehicle.scale, 0.12, {
                        delay: 0.01,
                        y: 0.96,
                        ease: Power1.easeInOut,
                        yoyo: true,
                        repeat: 1
                    });

                    _Common2.default.audio.playSound("sfx_car_land_00");
                },
                onCompleteScope: this
            }));
            tl.append(TweenMax.to(this._vehicle, 0.1, {
                y: to - 18,
                ease: Power1.easeOut
            }));
            tl.append(TweenMax.to(this._vehicle, 0.08, {
                y: to,
                ease: Power1.easeIn
            }));

            // fade shadow
            this._vehicle.shadow.alpha = 0;
            TweenMax.killTweensOf(this._vehicle.shadow);
            TweenMax.to(this._vehicle.shadow, 0.4, {
                delay: 0.04,
                alpha: 1,
                ease: Power1.easeInOut
            });

            // slide driver
            to = this._driver.x;
            this._driver.x = this._driver.x + 800;
            TweenMax.killTweensOf(this._driver);
            TweenMax.to(this._driver, 0.4, {
                delay: 0.3,
                x: to,
                ease: Back.easeOut,
                easeParams: [1]
            });

            // fade driver
            this._driver.alpha = 0;
            TweenMax.to(this._driver, 0.2, {
                delay: 0.3,
                alpha: 1,
                ease: Power1.easeInOut
            });

            // bounce driver
            this._driver.rotation = 0.14;
            TweenMax.to(this._driver, 0.8, {
                delay: 0.46,
                rotation: 0,
                ease: Elastic.easeOut,
                easeParams: [1]
            });

            // breath driver
            this._driver.scale = new PIXI.Point(1, 1);
            TweenMax.killTweensOf(this._driver.scale);
            TweenMax.to(this._driver.scale, 1, {
                y: 0.96,
                ease: Power1.easeInOut,
                yoyo: true,
                repeat: -1
            });
            TweenMax.to(this._driver.scale, 1.1, {
                y: 0.98,
                ease: Power1.easeInOut,
                yoyo: true,
                repeat: -1
            });

            // slide sidekick
            to = this._sidekick.x;
            this._sidekick.x = this._sidekick.x + 800;
            TweenMax.killTweensOf(this._sidekick);
            TweenMax.to(this._sidekick, 0.4, {
                delay: 0.5,
                x: to,
                ease: Back.easeOut,
                easeParams: [1]
            });

            // fade sidekick
            this._sidekick.alpha = 0;
            TweenMax.to(this._sidekick, 0.2, {
                delay: 0.5,
                alpha: 1,
                ease: Power1.easeInOut
            });

            // bounce sidekick
            this._sidekick.rotation = 0.14;
            TweenMax.to(this._sidekick, 0.8, {
                delay: 0.66,
                rotation: 0,
                ease: Elastic.easeOut,
                easeParams: [1]
            });

            // breath sidekick
            this._sidekick.scale = new PIXI.Point(1, 1);
            TweenMax.killTweensOf(this._sidekick.scale);
            TweenMax.to(this._sidekick.scale, 1, {
                delay: 0.2,
                y: 0.96,
                ease: Power1.easeInOut,
                yoyo: true,
                repeat: -1
            });
            TweenMax.to(this._sidekick.scale, 1.1, {
                delay: 0.2,
                y: 0.98,
                ease: Power1.easeInOut,
                yoyo: true,
                repeat: -1
            });

            // pop nameplate
            this._nameplate.scale = new PIXI.Point(0, 0);
            TweenMax.killTweensOf(this._nameplate.scale);
            TweenMax.to(this._nameplate.scale, 0.34, {
                delay: 0.24,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2]
            });
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onNextButtonClick",
        value: function onNextButtonClick(button) {
            if (++this._index >= _Common2.default.config.characters.length) {
                this._index = 0;
            }
            this.showCharacter(this._index);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onPreviousButtonClick",
        value: function onPreviousButtonClick(button) {
            if (--this._index < 0) {
                this._index = _Common2.default.config.characters.length - 1;
            }
            this.showCharacter(this._index);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onRaceButtonClick",
        value: function onRaceButtonClick(button) {
            this._homeButton.interactive = false;
            this._raceButton.interactive = false;

            var id = _Common2.default.config.characters[this._index].id;
            this.signals.next.dispatch(this, id);

            _Common2.default.audio.playSound("sfx_carsrush_by_00");
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onHomeButtonClick",
        value: function onHomeButtonClick(button) {
            this._homeButton.interactive = false;
            this._raceButton.interactive = false;

            this.signals.home.dispatch(this);

            _Common2.default.audio.playSound("sfx_whistle_fall_00");
        }
    }, {
        key: "onSwipeLeft",
        value: function onSwipeLeft() {
            this.onPreviousButtonClick(null);
        }
    }, {
        key: "onSwipeRight",
        value: function onSwipeRight() {
            this.onNextButtonClick(null);
        }
    }]);

    return CharacterScene;
}(p3.Scene);

exports.default = CharacterScene;

},{"../Common":7}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ConfirmQuitScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 30/03/2016.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var ConfirmQuitScene = function (_p3$Scene) {
    _inherits(ConfirmQuitScene, _p3$Scene);

    function ConfirmQuitScene() {
        _classCallCheck(this, ConfirmQuitScene);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (ConfirmQuitScene.__proto__ || Object.getPrototypeOf(ConfirmQuitScene)).call(this));

        _this._panel = null;

        /**
         * @type {p3.Button}
         * @private
         */
        _this._yesButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        _this._noButton = null;
        return _this;
    }

    _createClass(ConfirmQuitScene, [{
        key: "init",
        value: function init() {
            _get(ConfirmQuitScene.prototype.__proto__ || Object.getPrototypeOf(ConfirmQuitScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            this._panel = new PIXI.Sprite(assets.getTexture("ui_info_sign"));
            this._panel.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._panel.y = _Common2.default.STAGE_HEIGHT;
            this._panel.anchor = new PIXI.Point(0.5, 1);
            this._panel.visible = false;
            this.addChild(this._panel);

            if (language === "ar") {
                this._panel.label = new PIXI.Text(translate("confirm_title"), {
                    fontSize: "32px", fontFamily: "Noto Kufi Arabic", fill: 0x450C41, align: "center", padding: 6 });
                this._panel.label.x = 8;
                this._panel.label.y = -375;
                this._panel.label.rotation = -0.024;
                this._panel.label.pivot.x = this._panel.label.width * 0.5;
                this._panel.label.pivot.y = this._panel.label.height * 0.5;
                this._panel.addChild(this._panel.label);
            } else {
                this._panel.label = new PIXI.BitmapText(translate("confirm_title"), font(34, "center"));
                this._panel.label.x = 8;
                this._panel.label.y = -375;
                this._panel.label.rotation = -0.024;
                this._panel.label.pivot.x = this._panel.label.textWidth * 0.5;
                this._panel.label.pivot.y = this._panel.label.textHeight * 0.5;
                this._panel.label.tint = 0x450C41;
                this._panel.addChild(this._panel.label);
            }

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_big_out");
            states.over = assets.getTexture("ui_btn_big_over");
            states.down = assets.getTexture("ui_btn_big_down");
            states.icon = assets.getTexture("ui_icon_tick");

            this._yesButton = new p3.Button(states);
            this._yesButton.x = _Common2.default.STAGE_WIDTH * 0.5 + 10 + 130;
            this._yesButton.y = _Common2.default.STAGE_HEIGHT * 0.5 + 220;
            this._yesButton.visible = false;
            this._yesButton.interactive = false;
            this._yesButton.overSoundName = "sfx_btn_rollover_00";
            this._yesButton.clickSoundName = "sfx_btn_press_00";
            this._yesButton.signals.click.add(this.onYesButtonClick, this);
            this.addChild(this._yesButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_big_out");
            states.over = assets.getTexture("ui_btn_big_over");
            states.down = assets.getTexture("ui_btn_big_down");
            states.icon = assets.getTexture("ui_icon_cross");

            this._noButton = new p3.Button(states);
            this._noButton.x = _Common2.default.STAGE_WIDTH * 0.5 + 10 - 130;
            this._noButton.y = _Common2.default.STAGE_HEIGHT * 0.5 + 220;
            this._noButton.visible = false;
            this._noButton.interactive = false;
            this._noButton.overSoundName = "sfx_btn_rollover_00";
            this._noButton.clickSoundName = "sfx_btn_press_00";
            this._noButton.signals.click.add(this.onNoButtonClick, this);
            this.addChild(this._noButton);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(ConfirmQuitScene.prototype.__proto__ || Object.getPrototypeOf(ConfirmQuitScene.prototype), "appear", this).call(this);
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            var to = this._panel.y;
            this._panel.y = this._panel.y + 40;
            TweenMax.to(this._panel, 0.34, {
                y: to,
                ease: Power1.easeInOut,
                onStart: function onStart() {
                    this._panel.visible = true;
                },
                onStartScope: this
            });

            this._panel.scale.y = 0;
            TweenMax.to(this._panel.scale, 0.34, {
                y: 1,
                ease: Back.easeInOut,
                easeParams: [2]
            });

            this._noButton.scale = new PIXI.Point();
            TweenMax.to(this._noButton.scale, 0.4, {
                delay: 0.2,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [4],
                onStart: function onStart() {
                    this._noButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._noButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._yesButton.scale = new PIXI.Point();
            TweenMax.to(this._yesButton.scale, 0.4, {
                delay: 0.2 + 0.06,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [4],
                onStart: function onStart() {
                    this._yesButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._yesButton.interactive = true;
                },
                onCompleteScope: this
            });
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {
            var tl = new TimelineMax({ onComplete: callback, onCompleteScope: scope });

            tl.insert(TweenMax.to(this._panel, 0.34, {
                y: this._panel.y + 40,
                ease: Power1.easeInOut
            }));
            tl.insert(TweenMax.to(this._panel.scale, 0.34, {
                y: 0,
                ease: Back.easeInOut,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._panel.visible = false;
                },
                onCompleteScope: this
            }));

            this._yesButton.interactive = false;
            tl.insert(TweenMax.to(this._yesButton.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._yesButton.visible = false;
                },
                onCompleteScope: this
            }));

            this._noButton.interactive = false;
            tl.insert(TweenMax.to(this._noButton.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._noButton.visible = false;
                },
                onCompleteScope: this
            }));
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;
        }
    }, {
        key: "update",
        value: function update() {}

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onYesButtonClick",
        value: function onYesButtonClick(button) {
            this.signals.next.dispatch(this);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onNoButtonClick",
        value: function onNoButtonClick(button) {
            this.animateOut(function () {
                this.signals.previous.dispatch(this);
            }, this);
        }
    }]);

    return ConfirmQuitScene;
}(p3.Scene);

exports.default = ConfirmQuitScene;

},{"../Common":7}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AI = require("../AI");

var _AI2 = _interopRequireDefault(_AI);

var _AudioParams = require("../AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Hud = require("../Hud");

var _Hud2 = _interopRequireDefault(_Hud);

var _Player = require("../Player");

var _Player2 = _interopRequireDefault(_Player);

var _Pickup = require("../Pickup");

var _Pickup2 = _interopRequireDefault(_Pickup);

var _PickupSelector = require("../PickupSelector");

var _PickupSelector2 = _interopRequireDefault(_PickupSelector);

var _Powerup = require("../powerups/Powerup");

var _Powerup2 = _interopRequireDefault(_Powerup);

var _Skybox = require("../Skybox");

var _Skybox2 = _interopRequireDefault(_Skybox);

var _DoomBuggyView = require("../cars/DoomBuggyView");

var _DoomBuggyView2 = _interopRequireDefault(_DoomBuggyView);

var _PussycatView = require("../cars/PussycatView");

var _PussycatView2 = _interopRequireDefault(_PussycatView);

var _MeanMachineView = require("../cars/MeanMachineView");

var _MeanMachineView2 = _interopRequireDefault(_MeanMachineView);

var _IQView = require("../cars/IQView");

var _IQView2 = _interopRequireDefault(_IQView);

var _TurboView = require("../cars/TurboView");

var _TurboView2 = _interopRequireDefault(_TurboView);

var _BombPowerup = require("../powerups/BombPowerup");

var _BombPowerup2 = _interopRequireDefault(_BombPowerup);

var _BoostPowerup = require("../powerups/BoostPowerup");

var _BoostPowerup2 = _interopRequireDefault(_BoostPowerup);

var _BubblesPowerup = require("../powerups/BubblesPowerup");

var _BubblesPowerup2 = _interopRequireDefault(_BubblesPowerup);

var _ButterfliesPowerup = require("../powerups/ButterfliesPowerup");

var _ButterfliesPowerup2 = _interopRequireDefault(_ButterfliesPowerup);

var _CandyPowerup = require("../powerups/CandyPowerup");

var _CandyPowerup2 = _interopRequireDefault(_CandyPowerup);

var _FlamePowerup = require("../powerups/FlamePowerup");

var _FlamePowerup2 = _interopRequireDefault(_FlamePowerup);

var _GluePowerup = require("../powerups/GluePowerup");

var _GluePowerup2 = _interopRequireDefault(_GluePowerup);

var _LightningPowerup = require("../powerups/LightningPowerup");

var _LightningPowerup2 = _interopRequireDefault(_LightningPowerup);

var _MissilePowerup = require("../powerups/MissilePowerup");

var _MissilePowerup2 = _interopRequireDefault(_MissilePowerup);

var _SmartMissilePowerup = require("../powerups/SmartMissilePowerup");

var _SmartMissilePowerup2 = _interopRequireDefault(_SmartMissilePowerup);

var _SteamPowerup = require("../powerups/SteamPowerup");

var _SteamPowerup2 = _interopRequireDefault(_SteamPowerup);

var _TacsPowerup = require("../powerups/TacsPowerup");

var _TacsPowerup2 = _interopRequireDefault(_TacsPowerup);

var _RaceCar = require("../race/RaceCar");

var _RaceCar2 = _interopRequireDefault(_RaceCar);

var _RaceEngine = require("../race/RaceEngine");

var _RaceEngine2 = _interopRequireDefault(_RaceEngine);

var _RaceEntity = require("../race/RaceEntity");

var _RaceEntity2 = _interopRequireDefault(_RaceEntity);

var _RaceTrack = require("../race/RaceTrack");

var _RaceTrack2 = _interopRequireDefault(_RaceTrack);

var _RaceView = require("../race/RaceView");

var _RaceView2 = _interopRequireDefault(_RaceView);

var _TutorialControls = require("../tutorials/TutorialControls");

var _TutorialControls2 = _interopRequireDefault(_TutorialControls);

var _TutorialLadder = require("../tutorials/TutorialLadder");

var _TutorialLadder2 = _interopRequireDefault(_TutorialLadder);

var _TutorialLaps = require("../tutorials/TutorialLaps");

var _TutorialLaps2 = _interopRequireDefault(_TutorialLaps);

var _TutorialPowerups = require("../tutorials/TutorialPowerups");

var _TutorialPowerups2 = _interopRequireDefault(_TutorialPowerups);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  GameScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 21/02/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var GameScene = function (_p3$Scene) {
    _inherits(GameScene, _p3$Scene);

    /**
     * @param {boolean} [tutorial=false]
     * @param {boolean} [replay=false]
     */
    function GameScene(tutorial, replay) {
        _classCallCheck(this, GameScene);

        /**
         * @member {RaceEngine}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (GameScene.__proto__ || Object.getPrototypeOf(GameScene)).call(this));

        _this._engine = null;

        /**
         * @member {Hud}
         * @private
         */
        _this._hud = null;

        /**
         * @member {number}
         * @private
         */
        _this._time = 0;

        /**
         * @type {number}
         * @private
         */
        _this._totalLaps = 2;

        /**
         * @member {boolean}
         * @private
         */
        _this._racing = false;

        /**
         * @member {Player}
         * @private
         */
        _this._player = null;

        /**
         * @member {null}
         * @private
         */
        _this._skybox = null;

        /**
         * @member {boolean}
         * @private
         */
        _this._offroad = false;

        /**
         * @member {PIXI.RenderTexture}
         * @private
         */
        _this._pauseImage = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        _this._overlay = null;

        /**
         * @member {boolean}
         * @private
         */
        _this._gameover = false;

        /**
         * @member {Array}
         * @private
         */
        _this._cars = [];

        /**
         * @member {Array.<AI>}
         * @private
         */
        _this._ai = [];

        /**
         * @member {Array.<Pickup>}
         * @private
         */
        _this._pickups = [];

        /**
         * @member {Array.<MissilePowerup>}
         * @private
         */
        _this._missilePowerups = [];

        /**
         * @member {Array.<AOEPowerup>}
         * @private
         */
        _this._aoePowerups = [];

        /**
         * @member {Array.<BombPowerup>}
         * @private
         */
        _this._bombPowerups = [];

        /**
         * @type {Array.<BoostPowerup>}
         * @private
         */
        _this._boostPowerups = [];

        /**
         * @member {Audio}
         * @private
         */
        _this._ambientSFX = null;

        /**
         * @member {TweenMax}
         * @private
         */
        _this._balanceTime = window.performance.now();

        /**
         * @member {number}
         * @private
         */
        _this._balanceDelayMin = 4;

        /**
         * @member {number}
         * @private
         */
        _this._balanceDelayMax = 8;

        /**
         * @member {number}
         * @private
         */
        _this._balanceDelay = p3.Utils.randomRange(_this._balanceDelayMax, _this._balanceDelayMin);

        /**
         * @type {Tutorial}
         * @private
         */
        _this._tutorial = null;

        /**
         * @type {Array.<number>}
         * @private
         */
        _this._tutorialRatios = [0, 0.06, 0.12, 0.172];

        /**
         * @type {number}
         * @private
         */
        _this._tutorialIndex = 0;

        /**
         * @type {boolean}
         * @private
         */
        _this._tutorialPause = false;

        /**
         * @type {boolean}
         * @private
         */
        _this._isTutorial = tutorial;

        /**
         * @type {boolean}
         * @private
         */
        _this._isReplay = replay;

        /**
         * @type {boolean}
         * @private
         */
        _this._isRacing = false;

        /**
         * @type {Audio}
         * @private
         */
        _this._startingRevSFX = null;
        return _this;
    }

    _createClass(GameScene, [{
        key: "init",
        value: function init() {
            _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "init", this).call(this);

            _Common2.default.game = this;

            var assets = _Common2.default.assets;

            var tracks = ["track01", "track02", "track03", "track04", "track05"];
            var name = this._isTutorial ? "track01" : this._isReplay && _Common2.default.previousTrackName ? _Common2.default.previousTrackName : tracks[Math.floor(Math.random() * tracks.length)];
            console.log("track -", name);

            var data = assets.getJSON(name);
            var track = new _RaceTrack2.default(data);

            var view = new _RaceView2.default(1280);
            view.x = _Common2.default.STAGE_WIDTH * 0.5;
            view.drawDistance = _ismobilejs2.default ? 16 : 8;
            this.addChild(view);

            _RaceEngine2.default.getTexture = function (url) {
                return assets.getTexture(url);
            };

            this._engine = new _RaceEngine2.default(track, view);
            this._engine.init();
            _Common2.default.engine = this._engine;

            this._engine.camera.vanishingPoint = new PIXI.Point(0, _Common2.default.STAGE_HEIGHT - 350);

            this._hud = new _Hud2.default();
            this.addChild(this._hud);

            this._hud.pauseButton.signals.click.add(this.onPauseButtonClick, this);

            this._player = new _Player2.default(_Common2.default.playerDriverId, GameScene.getRaceCarView(_Common2.default.playerDriverId));
            this._player.view.y = _Common2.default.STAGE_HEIGHT * 0.5 + 246;
            this._player.offset.y = -54;
            this._player.zDepthOffset = 1;
            this._player.signals.lap.add(this.onRaceCarLap, this);
            this._engine.addEntity(this._player, 0);

            this._engine.camera.shakeOffset.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._engine.camera.target = this._player;

            this._skybox = new _Skybox2.default();
            this.addChildAt(this._skybox, 0);

            this.createAI();
            this.placeObjects();

            this.start();
        }
    }, {
        key: "destroy",
        value: function destroy() {
            TweenMax.killAll();

            if (this._pauseImage) {
                this._pauseImage.parent.removeChild(this._pauseImage);
                this._pauseImage.destroy();
                this._pauseImage = null;
            }
            this._player.destroy();
            for (var i = 0; i < this._ai.length; ++i) {
                var ai = this._ai[i];
                ai.destroy();
            }
            this._ai.length = 0;

            for (var _i = 0; _i < this._pickups.length; ++_i) {
                var pickup = this._pickups[_i];
                pickup.destroy();
            }
            this._pickups.length = 0;

            var arr = this._missilePowerups.concat(this._aoePowerups, this._bombPowerups, this._boostPowerups);
            for (var _i2 = 0; _i2 < arr.length; ++_i2) {
                var powerup = arr[_i2];
                powerup.destroy();
            }
            this._missilePowerups.length = this._bombPowerups.length = this._aoePowerups.length = this._boostPowerups.length = 0;

            this.stopAmbientSFX();
            this.stopStartingRevSFX();

            _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(GameScene.prototype.__proto__ || Object.getPrototypeOf(GameScene.prototype), "appear", this).call(this);

            if (_Common2.default.isFirstTime) {
                _Common2.default.isFirstTime = false;

                /*
                delay(function() {
                    this.signals.pause.dispatch(this);
                }, 0.5, this);
                */
            }

            _Common2.default.audio.playSound("sfx_cockerel_cry_00");
            _Common2.default.audio.playMusic(["music_raceloop_00", "music_raceloop_01", "music_raceloop_02"]);
        }
    }, {
        key: "show",
        value: function show() {
            this.resumeGame();
        }
    }, {
        key: "hide",
        value: function hide() {}

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {}

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {}
    }, {
        key: "start",
        value: function start() {
            this._hud.runCountdown(0.8, go, this);

            function go() {
                this._player.moving = true;
                this._isRacing = true;

                for (var i = 0; i < this._ai.length; ++i) {
                    var ai = this._ai[i];
                    ai.moving = true;
                }
                this._time = 0;

                this._player.startEngineSFX();
                this.stopStartingRevSFX();

                _Common2.default.audio.playSound("sfx_car_start_tyres_04");
            }

            this._cars = this._ai.concat([this._player]);
            console.log(this._cars);

            this._hud.ladder.signals.change.add(this.onLadderChange, this);
            this._hud.ladder.init();

            this._hud.setLaps(this._player.lap + 1, 3);
            this.playAmbientSFX();
            this.playStartingRevSFX();
        }
    }, {
        key: "end",
        value: function end() {
            if (this._gameover) return;
            this._gameover = true;

            console.log("gameover");

            var place = this.getRacePos(this._player);
            this.signals.next.dispatch(this, place);
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;
            this._hud.resize();
            this._skybox.resize();

            if (this._tutorial) {
                this._tutorial.resize();
            }
        }
    }, {
        key: "update",
        value: function update() {
            if (_Common2.default.paused) return;

            this._updateTutorial();

            if (this._tutorialPause) return;

            this._engine.update(deltaTime);
            this._hud.update(deltaTime);

            this._updatePowerups();
            this._updateCarsOrder();

            this._time += deltaTime * 1000;

            this.checkCollisions();
            this.checkCollisionsPickups();
            this.checkCollisionsMissiles();
            this.checkCollisionBombs();
            this.checkCollisionAOEs();

            this._skybox.update();

            this._balanceRace();
        }
    }, {
        key: "resumeGame",
        value: function resumeGame() {
            this._hud.pauseButton.interactive = true;
            TweenMax.resumeAll(true, true, true);

            if (this._pauseImage) {
                this.visible = true;
                TweenMax.to(this._pauseImage, 0.14, {
                    alpha: 0,
                    ease: Power1.easeInOut,
                    onComplete: function onComplete() {
                        this._pauseImage.parent.removeChild(this._pauseImage);
                        this._pauseImage = null;
                    },
                    onCompleteScope: this
                });
            }

            this.resumePowerups();

            this.playAmbientSFX();
            !this._isRacing && this.playStartingRevSFX();
            this._player.startEngineSFX();
            this._player.offroad && this._player.startOffroadSFX();
            !this._isRacing && this._hud.startingLights.resume();
        }

        /**
         * @param {boolean} [animate=true]
         */

    }, {
        key: "pauseGame",
        value: function pauseGame() {
            var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this._hud.pauseButton.interactive = false;
            this._hud.pauseButton.onMouseOut();
            TweenMax.pauseAll(true, true, true);

            if (animate) {
                var filter = new PIXI.filters.BlurFilter();
                filter.blur = 6;
                filter.quality = 3;

                this.filters = [filter];
                this.filterArea = new PIXI.Rectangle(0, 0, p3.View.width, p3.View.height);

                var texture = new PIXI.RenderTexture.create(p3.View.width, p3.View.height, PIXI.SCALE_MODES.DEFAULT, 1);
                _Common2.default.renderer.render(this, texture);

                this.filters = null;
                this.filterArea = null;

                this._pauseImage && this._pauseImage.parent.removeChild(this._pauseImage);

                this._pauseImage = new PIXI.Sprite(texture);
                this.parent.addChild(this._pauseImage);

                this._pauseImage.alpha = 0;
                TweenMax.to(this._pauseImage, 0.2, {
                    alpha: 1,
                    ease: Power1.easeInOut,
                    onComplete: function onComplete() {
                        this.visible = false;
                    },
                    onCompleteScope: this
                });
            }

            this.pausePowerups();

            this.stopAmbientSFX();
            this.stopStartingRevSFX();
            this._player.stopEngineSFX();
            this._player.stopOffroadSFX();
            !this._isRacing && this._hud.startingLights.pause();
        }
    }, {
        key: "createAI",
        value: function createAI() {
            var types = [0, 1, 2, 4, 3];
            var playerIndex = types.indexOf(_Common2.default.playerDriverId);
            if (playerIndex !== -1) {
                types.splice(playerIndex, 1);
            }

            for (var i = 0; i < types.length; ++i) {
                var id = types[i];
                var ai = new _AI2.default(id, GameScene.getRaceCarView(id));
                ai.offset.y = -54;
                ai.zDepthOffset = 1;
                ai.signals.lap.add(this.onRaceCarLap, this);
                this._ai.push(ai);
            }

            var startingSpacing = 560;
            var arr = this._ai.slice(0);
            if (this._isTutorial) {
                arr.splice(2, 0, this._player);
            } else {
                arr.push(this._player);
            }

            for (var _i3 = 0; _i3 < arr.length; ++_i3) {
                var car = arr[_i3];
                car.offset.x = (_i3 % 2 ? -1 : 1) * startingSpacing;

                var distance = this._engine.track.length - 2;
                distance -= _i3 * 1.4;
                this._engine.addEntity(car, distance);
            }
        }
    }, {
        key: "placeObjects",
        value: function placeObjects() {
            var assets = _Common2.default.assets;

            for (var i = 0; i < this._engine.track.objects.length; ++i) {
                var data = this._engine.track.objects[i];
                switch (data.id) {
                    case 0:
                        {
                            var object = new _RaceEntity2.default(_RaceEntity2.default.TYPE_STATIC, new PIXI.Sprite(assets.getTexture(data.t)));
                            object.offset.x = data.o.x * _Common2.default.RACE_ENTITY_SCALE;
                            object.offset.y = 240.0;
                            object.scale.x = 6;
                            object.scale.y = 6;
                            object.view.anchor = new PIXI.Point(0.5, 1.0);
                            this._engine.addEntity(object, data.d, false);
                            break;
                        }
                    case 1:
                        {
                            var _object = new _Pickup2.default();
                            _object.offset.x = data.o.x * _Common2.default.RACE_ENTITY_SCALE;
                            _object.offset.y = -120.0;
                            _object.zDepthOffset = 1;
                            _object.signals.collect.add(this.onPickupCollect, this);
                            _object.init();
                            this._engine.addEntity(_object, data.d);
                            this._pickups.push(_object);
                            break;
                        }
                }
            }
        }
    }, {
        key: "checkCollisions",
        value: function checkCollisions() {
            var cars = this.getCars();
            for (var i = 0; i < cars.length; ++i) {
                var cara = cars[i];
                var hit = false;

                for (var j = 0; j < cars.length; ++j) {
                    var carb = cars[j];
                    if (cara === carb) continue;

                    var diff = cara.getDistanceTo(carb);
                    var a = cara.distance;
                    var b = a + diff;

                    var collision = this._engine.testCollision(new PIXI.Point(cara.offset.x, a), new PIXI.Point(carb.offset.x, b), new PIXI.Point(cara.collisionWidth, cara.collisionLength), new PIXI.Point(carb.collisionWidth, carb.collisionLength));

                    if (collision) {
                        cara.onCollisionBegin(collision, carb);
                        carb.onCollisionBegin(collision, cara);
                        hit = true;

                        if (collision.top) {
                            cara.distance = carb.distance + (cara.collisionLength + carb.collisionLength) / this._engine.view.segmentHeight;
                        }
                        if (collision.bottom) {
                            cara.distance = carb.distance - (cara.collisionLength + carb.collisionLength) / this._engine.view.segmentHeight;
                        }
                        if (collision.left) {
                            cara.offset.x = carb.offset.x - (cara.collisionWidth + carb.collisionWidth) * 0.5;
                        }
                        if (collision.right) {
                            cara.offset.x = carb.offset.x + (cara.collisionWidth + carb.collisionWidth) * 0.5;
                        }
                        cara.distance = (cara.distance + this._engine.track.length) % this._engine.track.length;

                        if (collision.bottom) {
                            if (cara.velocity < carb.velocity) {
                                carb.velocity = cara.velocity;
                            } else if (carb.velocity < cara.velocity) {
                                cara.velocity = carb.velocity;
                            }
                        }
                        if (collision.left || collision.right) {
                            if (Math.abs(cara.turnVelocity) + Math.abs(carb.turnVelocity) > 1200) {
                                cara.turnVelocity *= -0.9;
                                carb.turnVelocity *= -0.9;
                            } else {
                                cara.turnVelocity = 0;
                                carb.turnVelocity = 0;
                            }
                        }
                    }
                }
                !hit && cara.onCollisionEnd();
            }
        }
    }, {
        key: "checkCollisionsPickups",
        value: function checkCollisionsPickups() {
            var cars = this.getCars();
            for (var i = 0; i < cars.length; ++i) {
                var car = cars[i];

                for (var _i4 = 0; _i4 < this._pickups.length; ++_i4) {
                    var pickup = this._pickups[_i4];
                    var collision = this._engine.testCollision(new PIXI.Point(car.offset.x, car.distance), new PIXI.Point(pickup.offset.x, pickup.distance), new PIXI.Point(car.collisionWidth, car.collisionLength), new PIXI.Point(pickup.collisionWidth, car.collisionLength));
                    if (collision && !car.usingPowerup) {
                        if (pickup.collect(car)) {
                            car.usingPowerup = true;
                        }
                    }
                }
            }
        }
    }, {
        key: "checkCollisionsMissiles",
        value: function checkCollisionsMissiles() {
            var cars = this.getCars();
            for (var i = 0; i < cars.length; ++i) {
                var car = cars[i];

                for (var j = 0; j < this._missilePowerups.length; ++j) {
                    var powerup = this._missilePowerups[j];
                    if (!powerup.missile.armed) continue;

                    var diff = car.getDistanceTo(powerup.missile);
                    var a = car.distance;
                    var b = a + diff;

                    if (car !== powerup.missile.owner) {
                        var collision = this._engine.testCollision(new PIXI.Point(car.offset.x, a), new PIXI.Point(powerup.missile.offset.x, b), new PIXI.Point(car.collisionWidth, car.collisionLength), new PIXI.Point(powerup.missile.collisionWidth, powerup.missile.collisionLength));
                        if (collision) {
                            powerup.missile.explode(car);
                            car.takeHit(powerup.missile.owner.isPlayer || car.isPlayer);

                            (powerup.missile.owner === this._player || car === this._player) && this._hud.ladder.usePowerup(powerup.missile.powerupType, car, true);
                            car === this._player && this._engine.camera.applyShake(1, 30);
                        }
                    }
                }
            }
        }
    }, {
        key: "checkCollisionBombs",
        value: function checkCollisionBombs() {
            var cars = this.getCars();
            for (var i = 0; i < cars.length; ++i) {
                var car = cars[i];

                for (var _i5 = 0; _i5 < this._bombPowerups.length; ++_i5) {
                    var powerup = this._bombPowerups[_i5];
                    var collision = this._engine.testCollision(new PIXI.Point(car.offset.x, car.distance), new PIXI.Point(powerup.bomb.offset.x, powerup.bomb.distance), new PIXI.Point(car.collisionWidth, car.collisionLength), new PIXI.Point(powerup.bomb.collisionWidth, car.collisionLength));
                    if (collision && powerup.bomb.armed) {
                        powerup.bomb.explode(car);
                        car.takeHit(powerup.bomb.owner.isPlayer || car.isPlayer);

                        (powerup.bomb.owner === this._player || car === this._player) && this._hud.ladder.usePowerup(powerup.bomb.powerupType, car, true);
                        car === this._player && this._engine.camera.applyShake(1, 30);
                    }
                }
            }
        }
    }, {
        key: "checkCollisionAOEs",
        value: function checkCollisionAOEs() {
            var cars = _Common2.default.game.getCars();

            for (var i = 0; i < this._aoePowerups.length; ++i) {
                var powerup = this._aoePowerups[i];
                for (var j = 0; j < cars.length; ++j) {
                    var car = cars[j];
                    if (powerup.aoe.owner === car) continue;

                    var diff = powerup.aoe.owner.getDistanceTo(car);
                    if (!car.debuffed && Math.abs(diff) <= powerup.aoe.range) {
                        car.applyDebuff(3, powerup.aoe.slow, powerup.aoe.swerve);
                        (powerup.aoe.owner === this._player || car === this._player) && this._hud.ladder.usePowerup(powerup.aoe.powerupType, car, true);
                        car === this._player && this._engine.camera.applyShake(3, 14);
                    }
                }
            }
        }
    }, {
        key: "playAmbientSFX",
        value: function playAmbientSFX() {
            var params = new _AudioParams2.default();
            params.loop = true;
            this._ambientSFX = _Common2.default.audio.playSound(["sfx_generic_race_loop_00", "sfx_generic_race_loop_01", "sfx_generic_race_loop_02", "sfx_ambient_wacky_loop_03"], params);
        }
    }, {
        key: "stopAmbientSFX",
        value: function stopAmbientSFX() {
            if (this._ambientSFX) {
                this._ambientSFX.stop();
                this._ambientSFX = null;
            }
        }
    }, {
        key: "playStartingRevSFX",
        value: function playStartingRevSFX() {
            var params = new _AudioParams2.default();
            params.loop = true;
            this._startingRevSFX = _Common2.default.audio.playSound("sfx_race_start_idle_revs_00", params);
        }
    }, {
        key: "stopStartingRevSFX",
        value: function stopStartingRevSFX() {
            if (this._startingRevSFX) {
                this._startingRevSFX.stop();
                this._startingRevSFX = null;
            }
        }
    }, {
        key: "resumePowerups",
        value: function resumePowerups() {
            var arr = this._missilePowerups.concat(this._aoePowerups, this._bombPowerups, this._boostPowerups);
            for (var i = 0; i < arr.length; ++i) {
                var powerup = arr[i];
                powerup.resume();
            }
        }
    }, {
        key: "pausePowerups",
        value: function pausePowerups() {
            var arr = this._missilePowerups.concat(this._aoePowerups, this._bombPowerups, this._boostPowerups);
            for (var i = 0; i < arr.length; ++i) {
                var powerup = arr[i];
                powerup.pause();
            }
        }

        /**
         * @private
         */

    }, {
        key: "_updatePowerups",
        value: function _updatePowerups() {
            for (var i = this._missilePowerups.length - 1; i >= 0; --i) {
                var powerup = this._missilePowerups[i];
                if (powerup.destroyNextFrame) {
                    this._missilePowerups.splice(i, 1);
                } else {
                    powerup.update(deltaTime);
                }
            }
            for (var _i6 = this._aoePowerups.length - 1; _i6 >= 0; --_i6) {
                var _powerup = this._aoePowerups[_i6];
                if (_powerup.destroyNextFrame) {
                    this._aoePowerups.splice(_i6, 1);
                } else {
                    _powerup.update(deltaTime);
                }
            }
            for (var _i7 = this._bombPowerups.length - 1; _i7 >= 0; --_i7) {
                var _powerup2 = this._bombPowerups[_i7];
                if (_powerup2.destroyNextFrame) {
                    this._bombPowerups.splice(_i7, 1);
                } else {
                    _powerup2.update(deltaTime);
                }
            }
            for (var _i8 = this._boostPowerups.length - 1; _i8 >= 0; --_i8) {
                var _powerup3 = this._boostPowerups[_i8];
                if (_powerup3.destroyNextFrame) {
                    this._boostPowerups.splice(_i8, 1);
                } else {
                    _powerup3.update(deltaTime);
                }
            }
        }

        /**
         * @private
         */

    }, {
        key: "_updateCarsOrder",
        value: function _updateCarsOrder() {
            this._cars.sort(function (a, b) {
                return b.getTotalDistance() - a.getTotalDistance();
            });
        }

        /**
         * @private
         */

    }, {
        key: "_updateTutorial",
        value: function _updateTutorial() {
            if (!this._isTutorial) return;

            var input = _Common2.default.input;
            input.isKeyPressed(32) && this._dismissTutorial();

            if (this._player.lap !== 1 || this._tutorialIndex >= this._tutorialRatios.length) return;

            var ratio = this._tutorialRatios[this._tutorialIndex];
            if (Math.floor(this._player.distance) / this._engine.track.length >= ratio) {
                this._tutorialPause = true;
                this.pauseGame(false);

                var tutorial = void 0;
                switch (this._tutorialIndex++) {
                    case 0:
                        {
                            tutorial = new _TutorialControls2.default();
                            tutorial.show();
                            this.addChild(tutorial);
                            break;
                        }
                    case 1:
                        {
                            tutorial = new _TutorialLadder2.default();
                            tutorial.show();
                            this.addChild(tutorial);
                            break;
                        }
                    case 2:
                        {
                            tutorial = new _TutorialLaps2.default();
                            tutorial.show();
                            this.addChild(tutorial);
                            break;
                        }
                    case 3:
                        {
                            tutorial = new _TutorialPowerups2.default();
                            tutorial.show();
                            this.addChild(tutorial);
                            break;
                        }
                }
                tutorial.resize();

                delay(this._dismissTutorial, 4, this);

                this._tutorial = tutorial;
            }
        }
    }, {
        key: "_dismissTutorial",
        value: function _dismissTutorial() {
            if (!this._tutorial) return;

            this._tutorial.hide();
            this._tutorial = null;
            this._tutorialPause = false;
            this.resumeGame();
        }

        /**
         * @private
         */

    }, {
        key: "_balanceRace",
        value: function _balanceRace() {
            if (this.getCars().length <= 1) return;

            var time = (window.performance.now() - this._balanceTime) / 1000;
            if (time > this._balanceDelay) {
                this._balanceTime = window.performance.now();

                var distance = 0;
                var count = 0;
                var cars = this.getCars();
                for (var i = 0; i < cars.length; ++i) {
                    var cara = cars[i];
                    for (var j = 0; j < cars.length; ++j) {
                        var carb = cars[j];
                        if (cara !== carb) {
                            distance += Math.abs(carb.getTotalDistance() - cara.getTotalDistance());
                            ++count;
                        }
                    }
                }
                var scalar = Math.max(0, Math.min(1.4, distance / count / 12));
                console.log("scalar:", scalar);

                distance = 0;
                count = 0;
                for (var _i9 = 0; _i9 < cars.length; ++_i9) {
                    for (var _j = 0; _j < cars.length; ++_j) {
                        var _carb = cars[_j];
                        if (this._player !== _carb) {
                            distance += _carb.getTotalDistance() - this._player.getTotalDistance();
                            ++count;
                        }
                    }
                }
                var avgPlayerDist = distance / count;
                console.log("avgPlayerDist:", avgPlayerDist);

                for (var _i10 = 0; _i10 < cars.length; ++_i10) {
                    var car = cars[_i10];
                    var racePos = this.getRacePos(car);

                    var modifier = void 0;
                    if (racePos === 0) {
                        if (car.isPlayer) {
                            modifier = -0.01;
                        } else {
                            modifier = -0.026;
                        }
                    } else if (racePos === 1) {
                        if (car.isPlayer) {
                            modifier = 0.012;
                        } else {
                            modifier = 0;
                        }
                    } else if (racePos === 2) {
                        if (car.isPlayer) {
                            modifier = 0.026;
                        } else {
                            modifier = 0.02;
                        }
                    } else if (racePos === 3) {
                        if (car.isPlayer) {
                            modifier = 0.04;
                        } else {
                            modifier = 0.03;
                        }
                    } else if (racePos === 4) {
                        if (car.isPlayer) {
                            modifier = 0.054;
                        } else {
                            modifier = 0.04;
                        }
                    }

                    // if player is too far away slow all AI down
                    if (avgPlayerDist > 4 && !car.isPlayer) {
                        modifier = -0.06;
                    }

                    car.speedModifer = 1 + modifier * scalar;
                    console.log("place:", _i10, "modifier:", car.speedModifer);
                }
                this._balanceDelay = p3.Utils.randomRange(this._balanceDelayMax, this._balanceDelayMin);
            }
        }

        /**
         * @param {Pickup} pickup
         * @param {RaceCar} collector
         */

    }, {
        key: "onPickupCollect",
        value: function onPickupCollect(pickup, collector) {
            var isPlayer = collector.id === _Common2.default.playerDriverId;

            var selector = new _PickupSelector2.default(isPlayer);
            selector.x = pickup.view.x;
            selector.y = pickup.view.y;
            selector.visible = isPlayer;
            selector.signals.select.add(function (selector, type) {
                var powerup = void 0;
                switch (type) {
                    case 0:
                        {
                            powerup = new _BombPowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._bombPowerups.push(powerup);
                            break;
                        }
                    case 1:
                        {
                            powerup = new _CandyPowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._bombPowerups.push(powerup);
                            break;
                        }
                    case 2:
                        {
                            powerup = new _FlamePowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._boostPowerups.push(powerup);
                            break;
                        }
                    case 3:
                        {
                            powerup = new _GluePowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._bombPowerups.push(powerup);
                            break;
                        }
                    case 4:
                        {
                            powerup = new _LightningPowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._boostPowerups.push(powerup);
                            break;
                        }
                    case 5:
                        {
                            powerup = new _MissilePowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._missilePowerups.push(powerup);
                            break;
                        }
                    case 6:
                        {
                            powerup = new _TacsPowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._bombPowerups.push(powerup);
                            break;
                        }
                    case 7:
                        {
                            powerup = new _SmartMissilePowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._missilePowerups.push(powerup);
                            break;
                        }
                    case 8:
                        {
                            powerup = new _SteamPowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._boostPowerups.push(powerup);
                            break;
                        }
                    case 9:
                        {
                            powerup = new _BubblesPowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._aoePowerups.push(powerup);
                            break;
                        }
                    case 10:
                        {
                            powerup = new _ButterfliesPowerup2.default(collector);
                            powerup.type = type;
                            powerup.activate();
                            this._aoePowerups.push(powerup);
                            break;
                        }
                }
                collector === this._player && this._hud.ladder.usePowerup(type, collector);
            }, this);
            this._engine.view.addChild(selector);

            var to = selector.y - 140;
            TweenMax.to(selector, 0.4, {
                y: to,
                ease: Power1.easeOut,
                onComplete: function onComplete() {
                    selector.start();
                },
                onCompleteScope: this
            });

            selector.scale = new PIXI.Point(0.2, 0.2);
            TweenMax.to(selector.scale, 0.4, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2]
            });
        }

        /**
         * @param {RaceCar} car
         * @param {number} lap
         */

    }, {
        key: "onRaceCarLap",
        value: function onRaceCarLap(car, lap) {
            console.log(car, lap);

            if (lap - 1 >= this._totalLaps && car === this._player) {
                this.end();
            } else if (car === this._player) {
                this._hud.setLaps(Math.max(1, Math.min(this._totalLaps, this._player.lap)), this._totalLaps);
            }
        }

        /**
         * @param {RaceAvatar} avatar
         * @param {number} pos
         */

    }, {
        key: "onLadderChange",
        value: function onLadderChange(avatar, pos) {
            if (avatar.isPlayer) {
                console.log(avatar, pos);
                _Common2.default.audio.playSound("sfx_change_race_position_00");
            }
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onPauseButtonClick",
        value: function onPauseButtonClick(button) {
            this.signals.pause.dispatch(this);
        }

        /**
         * @param {number} id
         * @returns {RaceCarView}
         * @static
         */

    }, {
        key: "getCars",


        /**
         * @returns {Array.<AI>}
         */
        value: function getCars() {
            return this._cars.slice(0);
        }

        /**
         * @returns {Array.<Powerup>}
         */

    }, {
        key: "getPickups",
        value: function getPickups() {
            return this._pickups.slice(0);
        }

        /**
         * @param car
         * @returns {number}
         */

    }, {
        key: "getRacePos",
        value: function getRacePos(car) {
            return this._cars.indexOf(car);
        }
    }], [{
        key: "getRaceCarView",
        value: function getRaceCarView(id) {
            var view = void 0;
            switch (id) {
                case 0:
                    {
                        view = new _PussycatView2.default();
                        break;
                    }
                case 1:
                    {
                        view = new _TurboView2.default();
                        break;
                    }
                case 2:
                    {
                        view = new _MeanMachineView2.default();
                        break;
                    }
                case 3:
                    {
                        view = new _DoomBuggyView2.default();
                        break;
                    }
                case 4:
                    {
                        view = new _IQView2.default();
                        break;
                    }
            }
            return view;
        }
    }]);

    return GameScene;
}(p3.Scene);

exports.default = GameScene;

},{"../AI":2,"../AudioParams":6,"../Common":7,"../Hud":8,"../Pickup":11,"../PickupSelector":12,"../Player":13,"../Skybox":16,"../cars/DoomBuggyView":18,"../cars/IQView":19,"../cars/MeanMachineView":20,"../cars/PussycatView":21,"../cars/TurboView":22,"../powerups/BombPowerup":27,"../powerups/BoostPowerup":29,"../powerups/BubblesPowerup":31,"../powerups/ButterfliesPowerup":33,"../powerups/CandyPowerup":35,"../powerups/FlamePowerup":37,"../powerups/GluePowerup":39,"../powerups/LightningPowerup":41,"../powerups/MissilePowerup":43,"../powerups/Powerup":44,"../powerups/SmartMissilePowerup":46,"../powerups/SteamPowerup":48,"../powerups/TacsPowerup":50,"../race/RaceCar":53,"../race/RaceEngine":56,"../race/RaceEntity":57,"../race/RaceTrack":61,"../race/RaceView":62,"../tutorials/TutorialControls":72,"../tutorials/TutorialLadder":73,"../tutorials/TutorialLaps":74,"../tutorials/TutorialPowerups":75,"ismobilejs":1}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  PauseScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2016.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var PauseScene = function (_p3$Scene) {
    _inherits(PauseScene, _p3$Scene);

    function PauseScene() {
        _classCallCheck(this, PauseScene);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (PauseScene.__proto__ || Object.getPrototypeOf(PauseScene)).call(this));

        _this._overlay = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._panel = null;

        /**
         * @type {p3.Button}
         * @private
         */
        _this._homeButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        _this._muteButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        _this._resumeButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        _this._replayButton = null;

        /**
         * @type {Array.<PIXI.Texture>}
         * @private
         */
        _this._images = [];

        /**
         * @type {number}
         * @private
         */
        _this._index = 0;

        /**
         * @type {Array.<PIXI.Sprite>}
         * @private
         */
        _this._pageIndicators = [];
        return _this;
    }

    _createClass(PauseScene, [{
        key: "init",
        value: function init() {
            _get(PauseScene.prototype.__proto__ || Object.getPrototypeOf(PauseScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            this._panel = new PIXI.Sprite(assets.getTexture("ui_help_bg"));
            this._panel.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._panel.y = _Common2.default.STAGE_HEIGHT + 12;
            this._panel.anchor = new PIXI.Point(0.5, 1);
            this._panel.visible = false;
            this.addChild(this._panel);

            if (language === "ar") {
                this._panel.title = new PIXI.Text(translate("pause_title"), {
                    fontSize: "40px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6 });
                this._panel.title.y = -636;
                this._panel.title.pivot.x = this._panel.title.width * 0.5;
                this._panel.title.pivot.y = this._panel.title.height * 0.5;
                this._panel.addChild(this._panel.title);
            } else {
                this._panel.title = new PIXI.BitmapText(translate("pause_title"), font(44, "center"));
                this._panel.title.y = -636;
                this._panel.title.pivot.x = this._panel.title.textWidth * 0.5;
                this._panel.title.pivot.y = this._panel.title.textHeight * 0.5;
                this._panel.addChild(this._panel.title);
            }

            this._panel.image = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._panel.image.y = -this._panel.height * 0.5;
            this._panel.image.anchor = new PIXI.Point(0.5, 0.5);
            this._panel.addChild(this._panel.image);

            this._panel.image.mask = new PIXI.Graphics();
            this._panel.addChild(this._panel.image.mask);

            this._panel.roll = new PIXI.Sprite(assets.getTexture("ui_help_roll"));
            this._panel.roll.x = 6;
            this._panel.roll.y = -560;
            this._panel.roll.anchor = new PIXI.Point(0.5, 0.5);
            this._panel.roll.start = new PIXI.Point(this._panel.roll.x, this._panel.roll.y);
            this._panel.addChild(this._panel.roll);

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_big_out");
            states.over = assets.getTexture("ui_btn_big_over");
            states.down = assets.getTexture("ui_btn_big_down");
            states.icon = assets.getTexture("ui_icon_play");

            this._resumeButton = new p3.Button(states);
            this._resumeButton.visible = false;
            this._resumeButton.interactive = false;
            this._resumeButton.overSoundName = "sfx_btn_rollover_00";
            this._resumeButton.clickSoundName = "sfx_btn_press_00";
            this._resumeButton.signals.click.add(this.onResumeButtonClick, this);
            this.addChild(this._resumeButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_out");
            states.over = assets.getTexture("ui_btn_over");
            states.down = assets.getTexture("ui_btn_down");
            states.icon = assets.getTexture("ui_icon_home");

            this._homeButton = new p3.Button(states);
            this._homeButton.visible = false;
            this._homeButton.interactive = false;
            this._homeButton.overSoundName = "sfx_btn_rollover_00";
            this._homeButton.clickSoundName = "sfx_btn_press_00";
            this._homeButton.signals.click.add(this.onHomeButtonClick, this);
            this.addChild(this._homeButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_out");
            states.over = assets.getTexture("ui_btn_over");
            states.down = assets.getTexture("ui_btn_down");
            states.icon = assets.getTexture("ui_icon_sound_on");
            states.iconAlt = assets.getTexture("ui_icon_sound_off");

            this._muteButton = new p3.MuteButton(states);
            this._muteButton.visible = false;
            this._muteButton.interactive = false;
            this._muteButton.overSoundName = "sfx_btn_rollover_00";
            this._muteButton.clickSoundName = "sfx_btn_press_00";
            this.addChild(this._muteButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_big_out");
            states.over = assets.getTexture("ui_btn_big_over");
            states.down = assets.getTexture("ui_btn_big_down");
            states.icon = assets.getTexture("ui_icon_replay");

            this._replayButton = new p3.Button(states);
            this._replayButton.visible = false;
            this._replayButton.interactive = false;
            this._replayButton.overSoundName = "sfx_btn_rollover_00";
            this._replayButton.clickSoundName = "sfx_btn_press_00";
            this._replayButton.signals.click.add(this.onReplayButtonClick, this);
            this.addChild(this._replayButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_arrow_r");

            this._nextButton = new p3.Button(states);
            this._nextButton.visible = false;
            this._nextButton.interactive = false;
            this._nextButton.overSoundName = "sfx_btn_rollover_00";
            this._nextButton.clickSoundName = "sfx_btn_press_00";
            this._nextButton.signals.click.add(this.onNextButtonClick, this);
            this.addChild(this._nextButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_arrow_l");

            this._previousButton = new p3.Button(states);
            this._previousButton.visible = false;
            this._previousButton.interactive = false;
            this._previousButton.overSoundName = "sfx_btn_rollover_00";
            this._previousButton.clickSoundName = "sfx_btn_press_00";
            this._previousButton.signals.click.add(this.onPreviousButtonClick, this);
            this.addChild(this._previousButton);

            this._images = [{ texture: !_ismobilejs2.default.any ? assets.getTexture("ui_help_01") : assets.getTexture("ui_help_01_mobile"), text: _ismobilejs2.default.any ? translate("pause_info1_mobile") : translate("pause_info1") }, { texture: assets.getTexture("ui_help_02"), text: translate("pause_info2") }, { texture: assets.getTexture("ui_help_03"), text: translate("pause_info3") }, { texture: assets.getTexture("ui_help_04"), text: translate("pause_info4") }];

            var sequence = new p3.MovieClipSequence();
            sequence.addTextures([assets.getTexture("ui_pagination_off"), assets.getTexture("ui_pagination_on")]);

            var holder = new PIXI.Container();
            holder.x = _Common2.default.STAGE_WIDTH * 0.5;
            holder.y = 740;
            this.addChild(holder);

            var spacing = new PIXI.Point(40, -8);
            for (var i = 0; i < this._images.length; ++i) {
                var indicator = new p3.MovieClip(sequence);
                indicator.x = i * spacing.x - (this._images.length - 1) * spacing.x * 0.5;
                indicator.y = i % 2 * spacing.y;
                indicator.anchor = new PIXI.Point(0.5, 0.5);
                indicator.visible = false;
                holder.addChild(indicator);
                this._pageIndicators.push(indicator);

                if (i === this._index) indicator.gotoAndStop(1);else indicator.gotoAndStop(0);
            }
        }
    }, {
        key: "hide",
        value: function hide() {
            _get(PauseScene.prototype.__proto__ || Object.getPrototypeOf(PauseScene.prototype), "hide", this).call(this);

            this._panel.y = _Common2.default.STAGE_HEIGHT + 12;

            this._panel.image.texture = PIXI.Texture.EMPTY;

            this._panel.roll.y = this._panel.roll.start.y;
            this._panel.roll.scale = new PIXI.Point(1, 1);
            this._panel.roll.visible = true;
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            var to = this._panel.y;
            this._panel.y = this._panel.y + 40;
            TweenMax.to(this._panel, 0.34, {
                y: to,
                ease: Power1.easeInOut,
                onStart: function onStart() {
                    this._panel.visible = true;
                },
                onStartScope: this
            });

            this._panel.scale.y = 0;
            TweenMax.to(this._panel.scale, 0.34, {
                y: 1,
                ease: Back.easeInOut,
                easeParams: [2],
                onComplete: function onComplete() {
                    this.showPage(this._index);
                },
                onCompleteScope: this
            });

            this._homeButton.scale = new PIXI.Point();
            TweenMax.to(this._homeButton.scale, 0.4, {
                delay: 0.1,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._homeButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._homeButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._muteButton.scale = new PIXI.Point();
            TweenMax.to(this._muteButton.scale, 0.4, {
                delay: 0.1 * 0.06,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._muteButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._muteButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._previousButton.scale = new PIXI.Point();
            TweenMax.to(this._previousButton.scale, 0.4, {
                delay: 0.1 * 0.06 * 2,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._previousButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._previousButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._nextButton.scale = new PIXI.Point();
            TweenMax.to(this._nextButton.scale, 0.4, {
                delay: 0.1 * 0.06 * 2,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._nextButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._nextButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._resumeButton.scale = new PIXI.Point();
            TweenMax.to(this._resumeButton.scale, 0.4, {
                delay: 0.1 + 0.06 * 4,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [4],
                onStart: function onStart() {
                    this._resumeButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._resumeButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._replayButton.scale = new PIXI.Point();
            TweenMax.to(this._replayButton.scale, 0.4, {
                delay: 0.1 + 0.06 * 4,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [4],
                onStart: function onStart() {
                    this._replayButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._replayButton.interactive = true;
                },
                onCompleteScope: this
            });

            for (var i = 0; i < this._pageIndicators.length; ++i) {
                var indicator = this._pageIndicators[i];
                indicator.scale = new PIXI.Point();
                TweenMax.to(indicator.scale, 0.24, {
                    delay: 0.3 + i * 0.04,
                    x: 1,
                    y: 1,
                    ease: Back.easeOut,
                    easeParams: [2],
                    onStart: function onStart(indicator) {
                        indicator.visible = true;
                    },
                    onStartParams: [indicator],
                    onStartScope: this
                });
            }
        }

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {
            var _this2 = this;

            var tl = new TimelineMax({ onComplete: callback, onCompleteScope: scope });

            tl.insert(TweenMax.to(this._panel, 0.34, {
                y: this._panel.y + 40,
                ease: Power1.easeInOut
            }));
            tl.insert(TweenMax.to(this._panel.scale, 0.34, {
                y: 0,
                ease: Back.easeInOut,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._panel.visible = false;
                },
                onCompleteScope: this
            }));

            this._homeButton.interactive = false;
            tl.insert(TweenMax.to(this._homeButton.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._homeButton.visible = false;
                },
                onCompleteScope: this
            }));

            this._muteButton.interactive = false;
            tl.insert(TweenMax.to(this._muteButton.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._muteButton.visible = false;
                },
                onCompleteScope: this
            }));

            this._nextButton.interactive = false;
            tl.insert(TweenMax.to(this._nextButton.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._nextButton.visible = false;
                },
                onCompleteScope: this
            }));

            this._previousButton.interactive = false;
            tl.insert(TweenMax.to(this._previousButton.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._previousButton.visible = false;
                },
                onCompleteScope: this
            }));

            this._resumeButton.interactive = false;
            tl.insert(TweenMax.to(this._resumeButton.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._resumeButton.visible = false;
                },
                onCompleteScope: this
            }));

            this._replayButton.interactive = false;
            tl.insert(TweenMax.to(this._replayButton.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: function onComplete() {
                    this._replayButton.visible = false;
                },
                onCompleteScope: this
            }));

            var _loop = function _loop(i) {
                var indicator = _this2._pageIndicators[i];
                tl.insert(TweenMax.to(indicator.scale, 0.14, {
                    x: 0,
                    y: 0,
                    ease: Back.easeIn,
                    easeParams: [1],
                    onComplete: function onComplete() {
                        indicator.visible = false;
                    },
                    onCompleteScope: _this2
                }));
            };

            for (var i = 0; i < this._pageIndicators.length; ++i) {
                _loop(i);
            }
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;

            this._homeButton.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
            this._homeButton.y = 100;

            this._muteButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
            this._muteButton.y = 100;

            this._nextButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
            this._nextButton.y = _Common2.default.STAGE_HEIGHT * 0.5;

            this._previousButton.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
            this._previousButton.y = _Common2.default.STAGE_HEIGHT * 0.5;

            this._resumeButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 120;
            this._resumeButton.y = p3.View.height - 120;

            this._replayButton.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 120;
            this._replayButton.y = p3.View.height - 120;
        }
    }, {
        key: "update",
        value: function update() {
            var input = _Common2.default.input;
            if (input.isKeyPressed(32)) {
                this.onResumeButtonClick(null);
            }
        }

        /**
         * @param {number} [index]
         */

    }, {
        key: "showPage",
        value: function showPage(index) {
            var image = this._images[index];
            this._panel.image.texture = image.texture;

            this._panel.roll.y = this._panel.roll.start.y;
            TweenMax.killTweensOf(this._panel.roll);
            TweenMax.to(this._panel.roll, 0.4, {
                y: this._panel.roll.y + 354,
                ease: Power2.easeInOut,
                onStart: function onStart() {
                    this._panel.roll.visible = true;
                },
                onStartScope: this
            });
            this._panel.roll.scale = new PIXI.Point(1, 1);
            TweenMax.killTweensOf(this._panel.roll.scale);
            TweenMax.to(this._panel.roll.scale, 0.4, {
                x: 0.93,
                y: 0.1,
                ease: Power2.easeInOut,
                onComplete: function onComplete() {
                    this._panel.roll.visible = false;
                },
                onCompleteScope: this
            });

            var width = this._panel.image.texture.width;
            var height = this._panel.image.texture.height;

            this._panel.image.mask.clear();
            this._panel.image.mask.beginFill(0xFF0000);
            this._panel.image.mask.drawRect(-width * 0.5, -height * 0.5, width, height);
            this._panel.image.mask.endFill();

            this._panel.image.mask.y = this._panel.roll.y - height * 0.5;
            TweenMax.killTweensOf(this._panel.image.mask);
            TweenMax.to(this._panel.image.mask, 0.418, {
                y: this._panel.image.mask.y + 370,
                ease: Power2.easeInOut
            });

            // show the correct page indicator
            for (var i = 0; i < this._pageIndicators.length; ++i) {
                var _indicator = this._pageIndicators[i];
                if (i === index) _indicator.gotoAndStop(1);else _indicator.gotoAndStop(0);
            }

            _Common2.default.audio.playSound("ui_tracks_poster_reveal_00");
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onNextButtonClick",
        value: function onNextButtonClick(button) {
            if (++this._index >= this._images.length) {
                this._index = 0;
            }
            this.showPage(this._index);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onPreviousButtonClick",
        value: function onPreviousButtonClick(button) {
            if (--this._index < 0) {
                this._index = this._images.length - 1;
            }
            this.showPage(this._index);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onHomeButtonClick",
        value: function onHomeButtonClick(button) {
            this.animateOut(function () {
                this.signals.home.dispatch(this);
            }, this);

            _Common2.default.audio.playSound("sfx_whistle_fall_00");
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onResumeButtonClick",
        value: function onResumeButtonClick(button) {
            this.animateOut(function () {
                this.signals.next.dispatch(this);
            }, this);

            _Common2.default.audio.playSound("sfx_whistle_rise_00");
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onReplayButtonClick",
        value: function onReplayButtonClick(button) {
            this.animateOut(function () {
                this.signals.previous.dispatch(this);
            }, this);

            _Common2.default.audio.playSound("sfx_whistle_fall_00");
        }
    }]);

    return PauseScene;
}(p3.Scene);

exports.default = PauseScene;

},{"../Common":7,"ismobilejs":1}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AudioParams = require("../AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ResultsScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2016.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var ResultsScene = function (_p3$Scene) {
    _inherits(ResultsScene, _p3$Scene);

    /**
     * @param {number} [id]
     * @param {number} [place]
     */
    function ResultsScene(id, place) {
        _classCallCheck(this, ResultsScene);

        /**
         * @type {number}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (ResultsScene.__proto__ || Object.getPrototypeOf(ResultsScene)).call(this));

        _this._id = id || 0;

        /**
         * @type {number}
         * @private
         */
        _this._place = place || 0;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._nextButton = null;

        /**
         * @type {p3.Button}
         * @private
         */
        _this._replayButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._homeButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        _this._muteButton = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._shine1 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._shine2 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._sign = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._badge = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._trophy = null;

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        _this._emitter = null;

        /**
         * @type {Audio}
         * @private
         */
        _this._outroSFX = null;
        return _this;
    }

    _createClass(ResultsScene, [{
        key: "init",
        value: function init() {
            _get(ResultsScene.prototype.__proto__ || Object.getPrototypeOf(ResultsScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(_Common2.default.blankTexture);
            bg.width = _Common2.default.STAGE_WIDTH;
            bg.height = _Common2.default.STAGE_HEIGHT;
            this.addChild(bg);

            this._shine2 = new PIXI.Sprite(assets.getTexture("ui_result_shine_2"));
            this._shine2.x = _Common2.default.STAGE_WIDTH * 0.5 - 220;
            this._shine2.y = _Common2.default.STAGE_HEIGHT * 0.5 - 120;
            this._shine2.scale = new PIXI.Point(4, 4);
            this._shine2.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this._shine2);

            this._shine1 = new PIXI.Sprite(assets.getTexture("ui_result_shine_1"));
            this._shine1.x = _Common2.default.STAGE_WIDTH * 0.5 - 220;
            this._shine1.y = _Common2.default.STAGE_HEIGHT * 0.5 - 120;
            this._shine1.scale = new PIXI.Point(4, 4);
            this._shine1.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this._shine1);

            this._badge = new PIXI.Sprite(assets.getTexture("ui_result_position_bg"));
            this._badge.x = _Common2.default.STAGE_WIDTH * 0.5 - 200;
            this._badge.y = _Common2.default.STAGE_HEIGHT * 0.5 - 140;
            this._badge.anchor = new PIXI.Point(0.5, 0.5);
            this._badge.visible = false;
            this.addChild(this._badge);

            var config = assets.getJSON("particle_emitter_trophy_stars_00");
            var holder = new PIXI.Container();
            holder.x = 8;
            holder.y = -12;
            this._badge.addChild(holder);

            this._emitter = new PIXI.particles.Emitter(holder, [assets.getTexture("particle_impact_star_orange"), assets.getTexture("particle_impact_star_white"), assets.getTexture("particle_impact_star_yellow")], config);

            this._trophy = new PIXI.Sprite(PIXI.Texture.EMPTY);
            this._trophy.x = -8;
            this._trophy.y = 50;
            this._trophy.anchor = new PIXI.Point(0.5, 0.5);
            this._badge.addChild(this._trophy);

            var footer = new PIXI.Sprite(assets.getTexture("ui_result_bg_bottom"));
            footer.x = (_Common2.default.STAGE_WIDTH - footer.width) * 0.5;
            footer.y = _Common2.default.STAGE_HEIGHT - footer.height;
            this.addChild(footer);

            this._sign = new PIXI.Sprite(assets.getTexture("ui_info_sign"));
            this._sign.y = p3.View.height - 80;
            this._sign.anchor = new PIXI.Point(0.5, 0.5);
            this._sign.visible = false;
            this.addChild(this._sign);

            var str = void 0,
                strings = void 0;
            if (this._place <= 2) {
                strings = ["results_sign_amazing", "results_sign_brilliant", "results_sign_fantastic"];
            } else {
                strings = ["results_sign_nice_try", "results_sign_keep_trying"];
            }
            str = strings[Math.floor(Math.random() * strings.length)];

            if (language === "ar") {
                this._sign.label = new PIXI.Text(translate(str), {
                    fontSize: "36px", fontFamily: "Noto Kufi Arabic", fill: 0x450C41, align: "center", padding: 6 });
                this._sign.label.x = 8;
                this._sign.label.y = -130;
                this._sign.label.rotation = -0.024;
                this._sign.label.pivot.x = this._sign.label.width * 0.5;
                this._sign.label.pivot.y = this._sign.label.height * 0.5;
                this._sign.addChild(this._sign.label);
            } else {
                this._sign.label = new PIXI.BitmapText(translate(str), font(40, "center"));
                this._sign.label.x = 8;
                this._sign.label.y = -130;
                this._sign.label.rotation = -0.024;
                this._sign.label.pivot.x = this._sign.label.textWidth * 0.5;
                this._sign.label.pivot.y = this._sign.label.textHeight * 0.5;
                this._sign.label.tint = 0x450C41;
                this._sign.addChild(this._sign.label);
            }

            var character = _Common2.default.config.characters[this._id];

            holder = new PIXI.Container();
            holder.y = p3.View.height;
            this.addChild(holder);

            this._sidekick = new PIXI.Sprite(character.sidekick ? assets.getTexture(character.sidekick.texture) : PIXI.Texture.EMPTY);
            this._sidekick.x = character.sidekick ? character.sidekick.offset.x : 0;
            this._sidekick.y = character.sidekick ? character.sidekick.offset.y : 0;
            this._sidekick.anchor = new PIXI.Point(0.5, 1);
            this._sidekick.visible = false;
            holder.addChild(this._sidekick);

            this._driver = new PIXI.Sprite(assets.getTexture(character.driver.texture));
            this._driver.x = character.driver.offset.x;
            this._driver.y = character.driver.offset.y;
            this._driver.anchor = new PIXI.Point(0.5, 1);
            this._driver.visible = false;
            holder.addChild(this._driver);

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_big_out");
            states.over = assets.getTexture("ui_btn_big_over");
            states.down = assets.getTexture("ui_btn_big_down");
            states.icon = assets.getTexture("ui_icon_play");

            this._nextButton = new p3.Button(states);
            this._nextButton.visible = false;
            this._nextButton.interactive = false;
            this._nextButton.overSoundName = "sfx_btn_rollover_00";
            this._nextButton.clickSoundName = "sfx_btn_press_00";
            this._nextButton.signals.click.add(this.onNextButtonClick, this);
            this.addChild(this._nextButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_big_out");
            states.over = assets.getTexture("ui_btn_big_over");
            states.down = assets.getTexture("ui_btn_big_down");
            states.icon = assets.getTexture("ui_icon_replay");

            this._replayButton = new p3.Button(states);
            this._replayButton.visible = false;
            this._replayButton.interactive = false;
            this._replayButton.overSoundName = "sfx_btn_rollover_00";
            this._replayButton.clickSoundName = "sfx_btn_press_00";
            this._replayButton.signals.click.add(this.onReplayButtonClick, this);
            this.addChild(this._replayButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_out");
            states.over = assets.getTexture("ui_btn_over");
            states.down = assets.getTexture("ui_btn_down");
            states.icon = assets.getTexture("ui_icon_home");

            this._homeButton = new p3.Button(states);
            this._homeButton.visible = false;
            this._homeButton.interactive = false;
            this._homeButton.overSoundName = "sfx_btn_rollover_00";
            this._homeButton.clickSoundName = "sfx_btn_press_00";
            this._homeButton.signals.click.add(this.onHomeButtonClick, this);
            this.addChild(this._homeButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_out");
            states.over = assets.getTexture("ui_btn_over");
            states.down = assets.getTexture("ui_btn_down");
            states.icon = assets.getTexture("ui_icon_sound_on");
            states.iconAlt = assets.getTexture("ui_icon_sound_off");

            this._muteButton = new p3.MuteButton(states);
            this._muteButton.visible = false;
            this._muteButton.interactive = false;
            this._muteButton.overSoundName = "sfx_btn_rollover_00";
            this._muteButton.clickSoundName = "sfx_btn_press_00";
            this.addChild(this._muteButton);

            if (this._place > 2) {
                bg.tint = 0xB3B5DC;
                this._shine1.tint = 0xFFFFFF;
                this._shine2.tint = 0x83EFFF;
                if (this._place === 3) {
                    this._trophy.texture = assets.getTexture("ui_result_position_4");
                } else if (this._place === 4) {
                    this._trophy.texture = assets.getTexture("ui_result_position_5");
                }
            } else if (this._place === 2) {
                bg.tint = 0xF47970;
                this._shine1.tint = 0xFFFFFF;
                this._shine2.tint = 0xEB8622;
                this._trophy.texture = assets.getTexture("ui_result_position_3");
            } else if (this._place === 1) {
                bg.tint = 0x8D82CD;
                this._shine1.tint = 0xFFFFFF;
                this._shine2.tint = 0xFE588E;
                this._trophy.texture = assets.getTexture("ui_result_position_2");
            } else if (this._place === 0) {
                bg.tint = 0xC5639A;
                this._shine1.tint = 0xFFEB62;
                this._shine2.tint = 0xFFE383;
                this._trophy.texture = assets.getTexture("ui_result_position_1");
            }
        }
    }, {
        key: "destroy",
        value: function destroy(destroyChildren) {
            this._emitter.destroy();

            _get(ResultsScene.prototype.__proto__ || Object.getPrototypeOf(ResultsScene.prototype), "destroy", this).call(this, destroyChildren);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(ResultsScene.prototype.__proto__ || Object.getPrototypeOf(ResultsScene.prototype), "appear", this).call(this);

            _Common2.default.audio.playSound("sfx_crowd_cheer_00");
            if (this._place <= 2) {
                _Common2.default.audio.playSound("sfx_fanfare_00");
            }

            var params = new _AudioParams2.default();
            params.callback = function () {
                _Common2.default.audio.playMusic("music_garage_loop_00");
            };
            params.scope = this;

            _Common2.default.audio.stopMusic();
            this._outroSFX = _Common2.default.audio.playSound("music_race_end_00", params);
        }
    }, {
        key: "show",
        value: function show() {}

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            this._homeButton.scale = new PIXI.Point();
            TweenMax.to(this._homeButton.scale, 0.4, {
                delay: 0.1,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._homeButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._homeButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._muteButton.scale = new PIXI.Point();
            TweenMax.to(this._muteButton.scale, 0.4, {
                delay: 0.1 + 0.06,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._muteButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._muteButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._replayButton.scale = new PIXI.Point();
            TweenMax.to(this._replayButton.scale, 0.4, {
                delay: 0.1 + 0.06 * 3,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [4],
                onStart: function onStart() {
                    this._replayButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._replayButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._nextButton.scale = new PIXI.Point();
            TweenMax.to(this._nextButton.scale, 0.4, {
                delay: 0.1 + 0.06 * 4,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [4],
                onStart: function onStart() {
                    this._nextButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._nextButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._badge.scale = new PIXI.Point();
            TweenMax.killTweensOf(this._badge.scale);
            TweenMax.to(this._badge.scale, 0.34, {
                delay: 0.04,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    this._badge.visible = true;
                },
                onStartScope: this
            });

            this._trophy.scale = new PIXI.Point();
            TweenMax.killTweensOf(this._trophy.scale);
            TweenMax.to(this._trophy.scale, 0.34, {
                delay: 0.2,
                x: 1,
                ease: Back.easeOut,
                easeParams: [1]
            });
            TweenMax.to(this._trophy.scale, 0.26, {
                delay: 0.2,
                y: 1,
                ease: Back.easeOut,
                easeParams: [3]
            });

            var to = this._sign.y;
            this._sign.y = this._sign.y + 400;
            TweenMax.killTweensOf(this._sign);
            TweenMax.to(this._sign, 0.32, {
                delay: 0.52,
                y: to,
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    this._sign.visible = true;
                },
                onStartScope: this
            });

            // slide driver
            to = this._driver.x;
            this._driver.x = this._driver.x + 800;
            TweenMax.killTweensOf(this._driver);
            TweenMax.to(this._driver, 0.4, {
                delay: 0.3,
                x: to,
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    this._driver.visible = true;
                },
                onStartScope: this
            });

            // fade driver
            this._driver.alpha = 0;
            TweenMax.to(this._driver, 0.2, {
                delay: 0.3,
                alpha: 1,
                ease: Power1.easeInOut
            });

            // bounce driver
            this._driver.rotation = 0.14;
            TweenMax.to(this._driver, 0.8, {
                delay: 0.46,
                rotation: 0,
                ease: Elastic.easeOut,
                easeParams: [1]
            });

            // slide sidekick
            to = this._sidekick.x;
            this._sidekick.x = this._sidekick.x + 800;
            TweenMax.killTweensOf(this._sidekick);
            TweenMax.to(this._sidekick, 0.4, {
                delay: 0.5,
                x: to,
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    this._sidekick.visible = true;
                },
                onStartScope: this
            });

            // fade sidekick
            this._sidekick.alpha = 0;
            TweenMax.to(this._sidekick, 0.2, {
                delay: 0.5,
                alpha: 1,
                ease: Power1.easeInOut
            });

            // bounce sidekick
            this._sidekick.rotation = 0.14;
            TweenMax.to(this._sidekick, 0.8, {
                delay: 0.66,
                rotation: 0,
                ease: Elastic.easeOut,
                easeParams: [1]
            });
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;

            this._driver.parent.x = _Common2.default.STAGE_WIDTH * 0.5 + p3.View.width * 0.24;

            this._sign.x = _Common2.default.STAGE_WIDTH * 0.5 - p3.View.width * 0.176;

            this._nextButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 120;
            this._nextButton.y = p3.View.height - 120;

            this._replayButton.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 120;
            this._replayButton.y = p3.View.height - 120;

            this._homeButton.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
            this._homeButton.y = 100;

            this._muteButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
            this._muteButton.y = 100;
        }
    }, {
        key: "update",
        value: function update() {
            this._shine1.rotation += 0.12 * deltaTime;
            this._shine2.rotation -= 0.08 * deltaTime;

            this._emitter.update(deltaTime);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onNextButtonClick",
        value: function onNextButtonClick(button) {
            this.signals.next.dispatch(this);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onReplayButtonClick",
        value: function onReplayButtonClick(button) {
            this.signals.previous.dispatch(this);
        }

        /**
         * @param {p3.Button} button
         */

    }, {
        key: "onHomeButtonClick",
        value: function onHomeButtonClick(button) {
            this.signals.home.dispatch(this);
        }
    }]);

    return ResultsScene;
}(p3.Scene);

exports.default = ResultsScene;

},{"../AudioParams":6,"../Common":7}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _AudioParams = require("../AudioParams");

var _AudioParams2 = _interopRequireDefault(_AudioParams);

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  PreloaderScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 27/03/2016.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 */
var SplashScene = function (_p3$Scene) {
    _inherits(SplashScene, _p3$Scene);

    function SplashScene() {
        _classCallCheck(this, SplashScene);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (SplashScene.__proto__ || Object.getPrototypeOf(SplashScene)).call(this));

        _this._char1 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._char2 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._char3 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._char4 = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._logo = null;

        /**
         * @type {PIXI.BitmapText | PIXI.Text}
         * @private
         */
        _this._titleLabel = null;

        /**
         * @type {p3.Button}
         * @private
         */
        _this._playButton = null;

        /**
         * @type {Audio}
         * @private
         */
        _this._introSFX = null;
        return _this;
    }

    _createClass(SplashScene, [{
        key: "init",
        value: function init() {
            _get(SplashScene.prototype.__proto__ || Object.getPrototypeOf(SplashScene.prototype), "init", this).call(this);

            var assets = _Common2.default.assets;

            var bg = new PIXI.Sprite(assets.getTexture("ui_splash"));
            this.addChild(bg);

            this._char1 = new PIXI.Sprite(assets.getTexture("ui_char_04a"));
            this._char1.x = _Common2.default.STAGE_WIDTH * 0.5 - 420;
            this._char1.y = _Common2.default.STAGE_HEIGHT + 34;
            this._char1.scale = new PIXI.Point(-0.74, 0.74);
            this._char1.anchor = new PIXI.Point(0.5, 1);
            this._char1.visible = false;
            this.addChild(this._char1);

            this._char1.blink = new PIXI.Sprite(assets.getTexture("ui_char_04a_blink"));
            this._char1.blink.anchor = new PIXI.Point(0.5, 1);
            this._char1.blink.visible = false;
            this._char1.addChild(this._char1.blink);

            this.blinkAnimation(this._char1);

            this._char2 = new PIXI.Sprite(assets.getTexture("ui_char_04b"));
            this._char2.x = _Common2.default.STAGE_WIDTH * 0.5 - 298;
            this._char2.y = _Common2.default.STAGE_HEIGHT + 40;
            this._char2.scale = new PIXI.Point(-0.74, 0.74);
            this._char2.anchor = new PIXI.Point(0.5, 1);
            this._char2.visible = false;
            this.addChild(this._char2);

            this._char2.blink = new PIXI.Sprite(assets.getTexture("ui_char_04b_blink"));
            this._char2.blink.anchor = new PIXI.Point(0.5, 1);
            this._char2.blink.visible = false;
            this._char2.addChild(this._char2.blink);

            this.blinkAnimation(this._char2);

            this._char4 = new PIXI.Sprite(assets.getTexture("ui_char_02"));
            this._char4.x = _Common2.default.STAGE_WIDTH * 0.5 + 400;
            this._char4.y = _Common2.default.STAGE_HEIGHT + 46;
            this._char4.scale = new PIXI.Point(0.74, 0.74);
            this._char4.anchor = new PIXI.Point(0.5, 1);
            this._char4.visible = false;
            this.addChild(this._char4);

            this._char4.blink = new PIXI.Sprite(assets.getTexture("ui_char_02_blink"));
            this._char4.blink.anchor = new PIXI.Point(0.5, 1);
            this._char4.blink.visible = false;
            this._char4.addChild(this._char4.blink);

            this.blinkAnimation(this._char4);

            this._char3 = new PIXI.Sprite(assets.getTexture("ui_char_01"));
            this._char3.x = _Common2.default.STAGE_WIDTH * 0.5 + 214;
            this._char3.y = _Common2.default.STAGE_HEIGHT + 60;
            this._char3.scale = new PIXI.Point(0.74, 0.74);
            this._char3.anchor = new PIXI.Point(0.5, 1);
            this._char3.visible = false;
            this.addChild(this._char3);

            this._char3.blink = new PIXI.Sprite(assets.getTexture("ui_char_01_blink"));
            this._char3.blink.anchor = new PIXI.Point(0.5, 1);
            this._char3.blink.visible = false;
            this._char3.addChild(this._char3.blink);

            this.blinkAnimation(this._char3);

            this._logo = new PIXI.Sprite(assets.getTexture("logo"));
            this._logo.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._logo.y = 94;
            this._logo.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this._logo);

            if (language === "ar") {
                this._titleLabel = new PIXI.Text(translate("splash_title"), {
                    fontSize: "40px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6 });
                this._titleLabel.x = _Common2.default.STAGE_WIDTH * 0.5;
                this._titleLabel.y = 220;
                this._titleLabel.pivot.x = this._titleLabel.width * 0.5;
                this._titleLabel.pivot.y = this._titleLabel.height * 0.5;
                this.addChild(this._titleLabel);
            } else {
                var holder = new PIXI.Container();
                holder.x = _Common2.default.STAGE_WIDTH * 0.5;
                holder.y = 212;
                this.addChild(holder);

                this._titleLabel = new PIXI.BitmapText(translate("splash_title"), font(46, "center"));
                this._titleLabel.tint = 0xFFFFFF;
                this._titleLabel.maxWidth = 340;
                holder.addChild(this._titleLabel);

                holder.pivot.x = holder.width * 0.5;
                holder.pivot.y = holder.height * 0.5;
            }

            var states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_big_out");
            states.over = assets.getTexture("ui_btn_big_over");
            states.down = assets.getTexture("ui_btn_big_down");
            states.icon = assets.getTexture("ui_icon_play");

            this._playButton = new p3.Button(states);
            this._playButton.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._playButton.y = _Common2.default.STAGE_HEIGHT * 0.5 + 254;
            this._playButton.visible = false;
            this._playButton.overSoundName = "sfx_btn_rollover_00";
            this._playButton.downSoundName = "sfx_btn_press_00";
            this._playButton.signals.click.add(this.onPlayButtonClick, this);
            this.addChild(this._playButton);

            states = new p3.ButtonStates();
            states.normal = assets.getTexture("ui_btn_out");
            states.over = assets.getTexture("ui_btn_over");
            states.down = assets.getTexture("ui_btn_down");
            states.icon = assets.getTexture("ui_icon_sound_on");
            states.iconAlt = assets.getTexture("ui_icon_sound_off");

            this._muteButton = new p3.MuteButton(states);
            this._muteButton.visible = false;
            this._muteButton.interactive = false;
            this._muteButton.overSoundName = "sfx_btn_rollover_00";
            this._muteButton.clickSoundName = "sfx_btn_press_00";
            this.addChild(this._muteButton);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this._char1.blinkTween && this._char1.blinkTween.kill();
            this._char2.blinkTween && this._char2.blinkTween.kill();
            this._char3.blinkTween && this._char3.blinkTween.kill();
            this._char4.blinkTween && this._char4.blinkTween.kill();

            this._introSFX && this._introSFX.destroy();

            _get(SplashScene.prototype.__proto__ || Object.getPrototypeOf(SplashScene.prototype), "destroy", this).call(this);
        }
    }, {
        key: "appear",
        value: function appear() {
            _get(SplashScene.prototype.__proto__ || Object.getPrototypeOf(SplashScene.prototype), "appear", this).call(this);

            var params = new _AudioParams2.default();
            params.callback = function () {
                _Common2.default.audio.playMusic("music_intro_loop_00");
            };
            params.scope = this;

            _Common2.default.audio.stopMusic();
            this._introSFX = _Common2.default.audio.playSound("music_intro_start_00", params);
        }
    }, {
        key: "animateIn",
        value: function animateIn() {
            this._playButton.scale = new PIXI.Point();
            TweenMax.to(this._playButton.scale, 0.4, {
                delay: 0.4,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [4],
                onStart: function onStart() {
                    this._playButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._playButton.interactive = true;
                },
                onCompleteScope: this
            });

            this._muteButton.scale = new PIXI.Point();
            TweenMax.to(this._muteButton.scale, 0.4, {
                delay: 0.4 + 0.06,
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [2],
                onStart: function onStart() {
                    this._muteButton.visible = true;
                },
                onStartScope: this,
                onComplete: function onComplete() {
                    this._muteButton.interactive = true;
                },
                onCompleteScope: this
            });

            this.animateDriver(this._char1, 1, 0);
            this.animateDriver(this._char2, 1, 0.2);
            this.animateDriver(this._char3, -1, 0.1);
            this.animateDriver(this._char4, -1, 0.3);
        }

        /**
         * @param {PIXI.DisplayObject} char
         * @param {number} [direction]
         * @param {number} [delay]
         */

    }, {
        key: "animateDriver",
        value: function animateDriver(char) {
            var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            // slide driver
            var to = char.x;
            if (direction === 1) {
                char.x = char.x - 800;
            } else if (direction === -1) {
                char.x = char.x + 800;
            }
            TweenMax.killTweensOf(char);
            TweenMax.to(char, 0.4, {
                delay: delay,
                x: to,
                ease: Back.easeOut,
                easeParams: [1],
                onStart: function onStart() {
                    char.visible = true;
                },
                onStartScope: this
            });

            // fade driver
            char.alpha = 0;
            TweenMax.to(char, 0.2, {
                delay: delay,
                alpha: 1,
                ease: Power1.easeInOut
            });

            // bounce driver
            if (direction === 1) {
                char.rotation = -0.14;
            } else if (direction === -1) {
                char.rotation = 0.14;
            }
            TweenMax.to(char, 0.8, {
                delay: delay + 0.16,
                rotation: 0,
                ease: Elastic.easeOut,
                easeParams: [1]
            });
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;

            this._muteButton.x = (_Common2.default.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
            this._muteButton.y = 100;
        }
    }, {
        key: "update",
        value: function update() {
            var input = _Common2.default.input;
            if (input.isKeyPressed(32)) {
                this.onPlayButtonClick(null);
            }
        }

        /**
         * @param {PIXI.Sprite} character
         */

    }, {
        key: "blinkAnimation",
        value: function blinkAnimation(character) {
            character.blinkTween = delay(function () {
                character.blink.visible = true;
                character.blinkTween = delay(function () {
                    character.blink.visible = false;
                    this.blinkAnimation(character);
                }, 0.1, this);

                character.scale.y = 0.734;
                TweenMax.to(character.scale, 0.44, {
                    y: 0.74,
                    ease: Back.easeOut
                });
            }, 1 + Math.random() * 2, this);
        }
    }, {
        key: "onPlayButtonClick",
        value: function onPlayButtonClick(event) {
            this._playButton.interactive = false;

            this.signals.next.dispatch(this);

            this._introSFX && this._introSFX.destroy();
            _Common2.default.audio.stopMusic();

            _Common2.default.audio.playSound("sfx_whistle_rise_00");
            _Common2.default.audio.playSound("music_intro_end_00");
        }
    }]);

    return SplashScene;
}(p3.Scene);

exports.default = SplashScene;

},{"../AudioParams":6,"../Common":7}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ThemeLoaderScene
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 08/05/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ThemeLoaderScene = function (_p3$Scene) {
    _inherits(ThemeLoaderScene, _p3$Scene);

    function ThemeLoaderScene() {
        _classCallCheck(this, ThemeLoaderScene);

        var _this = _possibleConstructorReturn(this, (ThemeLoaderScene.__proto__ || Object.getPrototypeOf(ThemeLoaderScene)).call(this));

        var assets = _Common2.default.assets;
        var bg = new PIXI.Sprite(assets.getTexture("ui_loading"));
        _this.addChild(bg);

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._wheel = new PIXI.Sprite(assets.getTexture("ui_loader"));
        _this._wheel.x = _Common2.default.STAGE_WIDTH * 0.5;
        _this._wheel.y = p3.View.height * 0.5;
        _this._wheel.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._wheel);

        if (language === "ar") {
            _this._loadingLabel = new PIXI.Text(translate("theme_loader"), {
                fontSize: "54px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6 });
            _this._loadingLabel.x = _Common2.default.STAGE_WIDTH * 0.5;
            _this._loadingLabel.y = p3.View.height * 0.5 + 240;
            _this._loadingLabel.pivot.x = _this._loadingLabel.width * 0.5;
            _this._loadingLabel.pivot.y = _this._loadingLabel.height * 0.5;
            _this.addChild(_this._loadingLabel);
        } else {
            _this._loadingLabel = new PIXI.BitmapText(translate("theme_loader"), font(64, "center"));
            _this._loadingLabel.x = _Common2.default.STAGE_WIDTH * 0.5;
            _this._loadingLabel.y = p3.View.height * 0.5 + 240;
            _this._loadingLabel.pivot.x = _this._loadingLabel.textWidth * 0.5;
            _this._loadingLabel.pivot.y = _this._loadingLabel.textHeight * 0.5;
            _this.addChild(_this._loadingLabel);
        }
        return _this;
    }

    _createClass(ThemeLoaderScene, [{
        key: "appear",
        value: function appear() {
            _get(ThemeLoaderScene.prototype.__proto__ || Object.getPrototypeOf(ThemeLoaderScene.prototype), "appear", this).call(this);

            var assets = _Common2.default.assets;
            assets.unloadTexture("track");
            assets.unloadTexture("skybox");

            // todo switch random tracks back on
            var random = Math.floor(Math.random() * 5);
            var files = [];

            switch (random) {
                case 0:
                    {
                        files = [{ name: "track", url: "images/" + "wr1_mountain_1x" + ".json" }, { name: "skybox", url: "images/" + "wr1_mountain_bg_1x" + ".png" }];
                        break;
                    }
                case 1:
                    {
                        files = [{ name: "track", url: "images/" + "wr2_snow_1x" + ".json" }, { name: "skybox", url: "images/" + "wr2_snow_bg_1x" + ".png" }];
                        break;
                    }
                case 2:
                    {
                        files = [{ name: "track", url: "images/" + "wr3_halloween_1x" + ".json" }, { name: "skybox", url: "images/" + "wr3_halloween_bg_1x" + ".png" }];
                        break;
                    }
                case 3:
                    {
                        files = [{ name: "track", url: "images/" + "wr4_desert_1x" + ".json" }, { name: "skybox", url: "images/" + "wr4_desert_bg_1x" + ".png" }];
                        break;
                    }
                case 4:
                    {
                        files = [{ name: "track", url: "images/" + "wr5_italy_1x" + ".json" }, { name: "skybox", url: "images/" + "wr5_italy_bg_1x" + ".png" }];
                        break;
                    }
            }

            assets.addFiles(files, "assets/");
            assets.signals.progress.add(this.onLoadingProgress, this);
            assets.signals.complete.addOnce(this.onLoadingCompleted, this);
            assets.load();
        }
    }, {
        key: "resize",
        value: function resize() {
            this.x = (p3.View.width - _Common2.default.STAGE_WIDTH) * 0.5;
        }
    }, {
        key: "update",
        value: function update() {
            this._wheel.rotation += 8 * deltaTime;
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onLoadingProgress",
        value: function onLoadingProgress(event) {
            console.log("progress:", event.progress + "%");
        }
    }, {
        key: "onLoadingCompleted",
        value: function onLoadingCompleted() {
            var assets = _Common2.default.assets;
            assets.signals.progress.removeAll();
            assets.signals.complete.removeAll();

            this.signals.next.dispatch(this);
        }
    }]);

    return ThemeLoaderScene;
}(p3.Scene);

exports.default = ThemeLoaderScene;

},{"../Common":7}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Tutorial
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 08/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends PIXI.Container
 */
var Tutorial = function (_PIXI$Container) {
    _inherits(Tutorial, _PIXI$Container);

    function Tutorial() {
        _classCallCheck(this, Tutorial);

        /**
         * @member {object} signals
         * @member {signals.Signal} object.signals
         */
        var _this = _possibleConstructorReturn(this, (Tutorial.__proto__ || Object.getPrototypeOf(Tutorial)).call(this));

        _this.signals = {
            complete: new signals.Signal()
        };

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        _this._panel = null;
        return _this;
    }

    _createClass(Tutorial, [{
        key: "destroy",
        value: function destroy() {
            this.signals.complete.dispose();

            _get(Tutorial.prototype.__proto__ || Object.getPrototypeOf(Tutorial.prototype), "destroy", this).call(this);
        }

        /**
         * @param {string} [dialogue=""]
         */

    }, {
        key: "show",
        value: function show() {
            var dialogue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            var assets = _Common2.default.assets;
            this._panel = new PIXI.Sprite(assets.getTexture("ui_tut_bg"));
            this._panel.x = _Common2.default.STAGE_WIDTH * 0.5;
            this._panel.y = p3.View.height * 0.5 + 280;
            this._panel.anchor = new PIXI.Point(0.5, 0.5);
            this.addChild(this._panel);

            var holder = new PIXI.Container();
            holder.y = -8;
            this._panel.addChild(holder);

            if (language === "ar") {
                this._panel.label = new PIXI.Text(dialogue, {
                    fontSize: "20px", fontFamily: "Noto Kufi Arabic", fill: 0x450C41, align: "center", padding: 6,
                    wordWrap: true, wordWrapWidth: 440 });
                this._panel.label.x = 0;
                holder.addChild(this._panel.label);
            } else {
                this._panel.label = new PIXI.BitmapText(dialogue, font(26, "center"));
                this._panel.label.x = 0;
                this._panel.label.maxWidth = 440;
                this._panel.label.tint = 0x450C41;
                holder.addChild(this._panel.label);
            }

            holder.pivot.x = holder.width * 0.5;
            holder.pivot.y = holder.height * 0.5;

            this.animateIn(function () {}, this);
        }
    }, {
        key: "hide",
        value: function hide() {
            this.animateOut(function () {
                this.destroy();
            }, this);
        }
    }, {
        key: "resize",
        value: function resize() {}
        // override


        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {
            var to = this._panel.y;
            this._panel.y += 400;

            TweenMax.to(this._panel, 0.34, {
                y: to,
                ease: Back.easeOut,
                easeParams: [1],
                onComplete: callback,
                onCompleteScope: scope
            });
        }

        /**
         * @param callback
         * @param scope
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {
            TweenMax.to(this._panel, 0.2, {
                y: this._panel.y + 400,
                ease: Back.easeIn,
                easeParams: [1],
                onComplete: callback,
                onCompleteScope: scope
            });
        }
    }]);

    return Tutorial;
}(PIXI.Container);

exports.default = Tutorial;

},{"../Common":7}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Tutorial2 = require("./Tutorial");

var _Tutorial3 = _interopRequireDefault(_Tutorial2);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TutorialControls
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 08/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Tutorial
 */
var TutorialControls = function (_Tutorial) {
    _inherits(TutorialControls, _Tutorial);

    function TutorialControls() {
        _classCallCheck(this, TutorialControls);

        return _possibleConstructorReturn(this, (TutorialControls.__proto__ || Object.getPrototypeOf(TutorialControls)).call(this));
    }

    _createClass(TutorialControls, [{
        key: "show",
        value: function show() {
            _get(TutorialControls.prototype.__proto__ || Object.getPrototypeOf(TutorialControls.prototype), "show", this).call(this, !_ismobilejs2.default.any ? translate("tutorial_controls") : translate("tutorial_controls_mobile"));

            this._panel.label.x = 110;

            var assets = _Common2.default.assets;
            var icon = new PIXI.Sprite(!_ismobilejs2.default.any ? assets.getTexture("ui_tut_keys") : assets.getTexture("ui_tut_hand"));
            icon.x = -220;
            icon.y = -8;
            icon.anchor = new PIXI.Point(0.5, 0.5);
            this._panel.addChild(icon);
        }
    }]);

    return TutorialControls;
}(_Tutorial3.default);

exports.default = TutorialControls;

},{"../Common":7,"./Tutorial":71,"ismobilejs":1}],73:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Tutorial2 = require("./Tutorial");

var _Tutorial3 = _interopRequireDefault(_Tutorial2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TutorialLadder
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 08/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Tutorial
 */
var TutorialLadder = function (_Tutorial) {
    _inherits(TutorialLadder, _Tutorial);

    function TutorialLadder() {
        _classCallCheck(this, TutorialLadder);

        var _this = _possibleConstructorReturn(this, (TutorialLadder.__proto__ || Object.getPrototypeOf(TutorialLadder)).call(this));

        _this._marker = null;
        return _this;
    }

    _createClass(TutorialLadder, [{
        key: "show",
        value: function show() {
            _get(TutorialLadder.prototype.__proto__ || Object.getPrototypeOf(TutorialLadder.prototype), "show", this).call(this, translate("tutorial_leaderboard"));

            var assets = _Common2.default.assets;
            this._marker = new PIXI.Sprite(assets.getTexture("ui_tut_circle"));
            this._marker.y = 194;
            this._marker.anchor = new PIXI.Point(0.5, 0.5);
            this._marker.scale = new PIXI.Point(5, 5);
            this.addChildAt(this._marker, 0);
        }
    }, {
        key: "resize",
        value: function resize() {
            this._marker.x = (_Common2.default.STAGE_WIDTH - p3.View.width) * 0.5 + 90;
        }
    }]);

    return TutorialLadder;
}(_Tutorial3.default);

exports.default = TutorialLadder;

},{"../Common":7,"./Tutorial":71}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Tutorial2 = require("./Tutorial");

var _Tutorial3 = _interopRequireDefault(_Tutorial2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TutorialLaps
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 08/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Tutorial
 */
var TutorialLaps = function (_Tutorial) {
    _inherits(TutorialLaps, _Tutorial);

    function TutorialLaps() {
        _classCallCheck(this, TutorialLaps);

        var _this = _possibleConstructorReturn(this, (TutorialLaps.__proto__ || Object.getPrototypeOf(TutorialLaps)).call(this));

        _this._marker = null;
        return _this;
    }

    _createClass(TutorialLaps, [{
        key: "show",
        value: function show() {
            _get(TutorialLaps.prototype.__proto__ || Object.getPrototypeOf(TutorialLaps.prototype), "show", this).call(this, translate("tutorial_laps"));

            var assets = _Common2.default.assets;
            this._marker = new PIXI.Sprite(assets.getTexture("ui_tut_circle"));
            this._marker.x = _Common2.default.STAGE_WIDTH * 0.5 - 30;
            this._marker.y = 82;
            this._marker.anchor = new PIXI.Point(0.5, 0.5);
            this._marker.scale = new PIXI.Point(3, 3);
            this.addChildAt(this._marker, 0);
        }
    }]);

    return TutorialLaps;
}(_Tutorial3.default);

exports.default = TutorialLaps;

},{"../Common":7,"./Tutorial":71}],75:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Common = require("../Common");

var _Common2 = _interopRequireDefault(_Common);

var _Tutorial2 = require("./Tutorial");

var _Tutorial3 = _interopRequireDefault(_Tutorial2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  TutorialPowerups
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Legman on 08/06/2017.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * @class
 * @extends Tutorial
 */
var TutorialPowerups = function (_Tutorial) {
    _inherits(TutorialPowerups, _Tutorial);

    function TutorialPowerups() {
        _classCallCheck(this, TutorialPowerups);

        var _this = _possibleConstructorReturn(this, (TutorialPowerups.__proto__ || Object.getPrototypeOf(TutorialPowerups)).call(this));

        _this._marker = null;
        return _this;
    }

    _createClass(TutorialPowerups, [{
        key: "show",
        value: function show() {
            _get(TutorialPowerups.prototype.__proto__ || Object.getPrototypeOf(TutorialPowerups.prototype), "show", this).call(this, translate("tutorial_powerup"));

            this._panel.label.x = 60;

            var assets = _Common2.default.assets;
            var icon = new PIXI.Sprite(assets.getTexture("ui_icon_powerup_bomb"));
            icon.x = -240;
            icon.y = -12;
            icon.anchor = new PIXI.Point(0.5, 0.5);
            this._panel.addChild(icon);
        }
    }]);

    return TutorialPowerups;
}(_Tutorial3.default);

exports.default = TutorialPowerups;

},{"../Common":7,"./Tutorial":71}]},{},[23])

